{
  "=\"\"": "",
  "account": {
    "account_settings": "Account Settings",
    "add_card": "Add Card",
    "add_new_subscription": "Add New Subscription",
    "add_your_card_first": "Add your card first",
    "all_your_activity_data_will_be_emailed": "All your activity data will be emailed",
    "amount": "Amount",
    "are_you_sure_that_you_want_to_end_your_subscription": "Are you sure that you want to end your subscription?",
    "card_holder_name": "Card Holder Name",
    "card_holder_name_required": "Card Holder Name is Required",
    "card_not_added": "Card Not Added",
    "change_card": "Change Card",
    "change_subscription": "Change Subscription",
    "credit_card_debit_card": "Credit Card/ Debit Card",
    "earlier_subscription_will_work_until": "Earlier Subscription Will Work Until {{date}}",
    "end_subscription": "End Subscription",
    "export_my_data": "Export my data",
    "invoices": "Invoices",
    "last_4_digits": "**** ***** **** {{last4}}",
    "next_charge_on": "Next Charge On {{date}}",
    "no_invoices_have_been_added": "No invoices have been added…",
    "no_of_users": "No. of Users",
    "pay_now": "Pay Now",
    "payment_is_overdue_by": "Payment Is Overdue By {{days}} {{days === 1 ? 'day' : 'days'}}",
    "payment_method": "Payment Method",
    "plus_gst_with_percentage": "+GST ({{percentage}}%)",
    "select_subscription_type": "Select Subscription Type",
    "status": "Status",
    "subscription": "Subscription",
    "subscription_details": "Subscription Details",
    "subscription_plan_with_amount": "{{title}} - {{amount}}$ /year",
    "subscription_type_required": "Subscription Type is Required",
    "subscription_will_end_on": "Subscription Will End On {{date}}",
    "trial_period_ends_on": "Trial Period Ends On",
    "update_account_details": "Update Account Details",
    "you_need_to_add_a_card_before_add_a_new_subscription_plan_click_the_add_card_button_to_start_your_subscription": "You need to add a card before add a new subscription plan. Click the Add Card button to start your subscription.",
    "your_new_subscription_rate_will_begin_immediately": "Your New Subscription Rate Will Begin Immediately",
    "your_plan_includes": "Your Plan Includes"
  },
  "account_status": {
    "active": "Active",
    "all": "All",
    "inactive": "Inactive"
  },
  "account_type": {
    "individual": "Individual",
    "organisation": "Organisation"
  },
  "actions": {
    "accept": "Accept",
    "activate": "Activate",
    "add": "Add",
    "apply": "Apply",
    "approve": "Approve",
    "archive": "Archive",
    "are_you_sure_you_want_to_remove": "Are you sure you want to remove the",
    "assign_to": "Assign to",
    "back": "Back",
    "browse": "Browse",
    "browse_file": "Browse File",
    "cancel": "Cancel",
    "change": "Change",
    "clear": "Clear",
    "clear_all": "Clear All",
    "click_to_edit": "Click to edit",
    "close": "Close",
    "confirm": "Confirm",
    "continue": "Continue",
    "copied": "Copied",
    "copy": "Copy",
    "copy_link": "Copy Link",
    "create": "Create",
    "create_activity": "Create Activity",
    "deactivate": "Deactivate",
    "delete": "Delete",
    "do_you_want_to_continue": "Do you want to continue?",
    "download": "Download",
    "download_csv_template": "Download CSV Template",
    "download_evidence": "Download Evidence",
    "download_json": "Download JSON",
    "download_report": "Download Report",
    "edit": "Edit",
    "end": "End",
    "enter_activity": "Enter Activity",
    "export": "Export",
    "got_it": "Got It",
    "import": "Import",
    "leave": "Leave",
    "next": "Next",
    "no": "No",
    "notify": "Notify",
    "ok": "OK",
    "one_way_change": "This is a one-way change and cannot be reverted.",
    "proceed": "Proceed",
    "read": "Read",
    "reassign": "Reassign",
    "refresh": "Refresh",
    "refreshing": "Refreshing",
    "reject": "Reject",
    "remove": "Remove",
    "replace_image": "Replace image",
    "reset": "Reset",
    "reset_password": "Reset Password",
    "reset_to_default": "Reset to default",
    "save": "Save",
    "save_changes": "Save Changes",
    "search": "Search",
    "search_by_activity": "Search by Activity",
    "search_by_user": "Search by User",
    "select_activities_from": "Select Activities from",
    "select_activity": "Select Activity",
    "select_all_lower": "select all",
    "send": "Send",
    "sign_in": "Sign In",
    "sign_up": "Sign Up",
    "skip": "Skip",
    "stay": "Stay",
    "submit": "Submit",
    "this_action_cannot_be_undone": "This action cannot be undone!",
    "to": "to",
    "update": "Update",
    "update_partner": "Update Partner",
    "upload": "Upload",
    "verify": "Verify",
    "view": "View",
    "view_report": "View Report",
    "write": "write",
    "yes": "Yes"
  },
  "activity": {
    "activity_has_been_approved": "Activity has been successfully approved.",
    "activity_manager": "Activity Manager",
    "activity_plan": {
      "activity_description": "Activity Description",
      "activity_input": {
        "actual_expenditure": "Actual Expenditure",
        "actual_program_contribution_fund": "Actual Program Contribution",
        "actual_program_grant_fund": "Actual Program Grant",
        "actual_venue_hire": "Actual Venue Hire",
        "address": "Address",
        "anonymous_donor": "Anonymous Donor",
        "contractor_cost": "Contractor Cost",
        "contribution": "Contribution",
        "contribution_allocated": "Contribution allocated",
        "counted_as_program_amount": "Counted above as the program amount",
        "estimated_value": "Estimated value",
        "estimated_value_partner_contribution": "Estimated value of partner contribution",
        "expenditure": "Expenditure",
        "expenditure_value_required": "Expenditure value is required",
        "grant_amount": "Grant Amount",
        "grants_allocated": "Grant/s allocated",
        "green_light_date": "Green Light Date",
        "in_kind_not_counted": "In-kind value (not counted in the Financial Result)",
        "invite": "Invite",
        "invite_to_activity_member": "Invite to Activity Member",
        "message_for_invited_user": "Message for invited user",
        "network_no_amount": "Network, no amount",
        "no_contractors": "No contractors have been added",
        "no_partners": "No partners have been added",
        "no_reportable_expenditure": "No reportable Other Expenditure",
        "no_venues": "No venues have been added",
        "note_on_dates_and_timing": {
          "label": "Note on dates and timing",
          "placeholder": "Add information on the selection of dates or timing."
        },
        "only_numbers_can_be_entered": "Only numbers can be entered",
        "other_expenditure": "Other Expenditure",
        "partner": "Partner",
        "partner_name": "Partner Name",
        "partners_help_linked": "Partners contributing directly to this activity, separate from the Program Contribution and from partners of the program itself.",
        "partners_help_program": "Partners contributing to the program itself, separate from partners of its linked activities.",
        "permissions": "Permissions",
        "program_amount_help": "The amount the program contributes directly to this activity, kept separate from any Partner Funding the activity raises on its own.",
        "program_contribution_fund": "Program Contribution",
        "program_fund_remaining": "Remaining",
        "program_grant_fund": "Program Grant",
        "projected_amount": "Projected",
        "projected_contractor_incomplete": "Projected. Please complete",
        "projected_expenditure": "Projected Expenditure",
        "projected_program_contribution": "Projected Program Contribution",
        "projected_program_grant": "Projected Program Grant",
        "remove_partner_from_activity": "Remove partner from activity",
        "search_for_existing_contractors": "Search saved contractors",
        "search_for_existing_partners": "Search saved partners",
        "search_for_existing_venues": "Search saved venues",
        "total_volunteers": "Total Volunteers",
        "venue": "Venue",
        "venue_hire": "Venue Hire"
      },
      "activity_manager": "Activity Manager",
      "activity_members": "Activity Members",
      "activity_section": "Activity Section",
      "actual_input": {
        "total_volunteers": "TOTAL VOLUNTEERS",
        "venues": "VENUE(s)"
      },
      "actual_inputs": "Actual Inputs",
      "actual_outputs": "Actual Outputs",
      "add_group": "Add Group",
      "add_guest_user": "Add Guest User",
      "add_guest_user_modal_title": "Add Guest User",
      "add_new_contractor": "Add new contractor",
      "add_new_group": "Add New Group",
      "are_you_sure_you_want_to_delete_this_group": "Are you sure you want to delete this group?",
      "change_ownership": {
        "contact_email_required": "Contact email is required",
        "enter_details_title": "Enter details of the new activity manager",
        "found_user_info": "We found an takso user associate with your entered email address.",
        "notify_existing_user": "Notify existing user",
        "notify_new_user": "Notify new user",
        "notify_of_changes": "Notify of changes",
        "notify_option_required": "Notify option is required",
        "trigger": "Change Manager"
      },
      "core_participant_group": "Sub-group Participants",
      "couldnt_add_participant": "Couldn't add participant",
      "couldnt_change_permissions": "Couldn't change permissions",
      "create_new_group": "Create New Group",
      "create_new_subgroup": "Create sub-group",
      "current_members": "Current Members",
      "deactivate": {
        "no_permission_message": "This manager does not have the permission feature to contribute to this activity type",
        "permanent_remove_message": "Linked Activity will be permanently removed and assigned to the contact organisation",
        "reason_label": "Reason for {{mode}}",
        "reason_required": "Reason for deactivation is required"
      },
      "delete_activity": {
        "linked_confirm": "Are you sure you want to delete this linked activity?",
        "linked_title": "Delete Linked Activity",
        "remove_projected_confirm": "Are you sure you want to remove this projected activity?",
        "title_with_name": "Delete activity - {{name}}",
        "trigger": "Delete Activity"
      },
      "delete_confirmation": "Delete Confirmation",
      "deleted_user": "Deleted User",
      "details": {
        "activation_information": "Activation Information",
        "notify_grantee_confirm": "Are you sure, do you want to notify the Grantees?",
        "notify_grantee_title": "Notify Grantee",
        "projected_grant_amount": "Projected Grant Amount",
        "re_send_notification": "Re-Send Notification",
        "update_contact_information": "Update Contact Information",
        "update_contact_information_desc": "Contact information with this email address already exists in Takso. You can update the record with the information entered in the {{type}} application by pressing update. To proceed without updating information press no.",
        "view_report": "View Report"
      },
      "discard_changes": "Discard changes",
      "do_you_want_to_create_evaluation_subgroups_for_your_participants": "Add sub-groups for evaluation plan",
      "do_you_want_to_identify_any_core_groups_within_these_participants": "Do you want to identify any sub-groups within these participants?",
      "duplicate_permission": "Can duplicate this activity",
      "duplicate_permission_hint": "They can make their own copy of this activity, as the manager can. Only for members of your organisation.",
      "duplicate_permission_locked": "Available with the Collaborator or Custom permission.",
      "edit_group": "Edit Group",
      "evaluation_subgroups": "Evaluation Sub-Groups",
      "form": {
        "activity_manager": "Activity Manager",
        "activity_name_required": "Activity name is required",
        "add_linked_activity": "Add Linked Activity",
        "enter_summary_description": "Summarise the",
        "evaluation_of_this_program_will_be_an_aggregate_of_evaluation_from_the_programs_linked_activity_records_and_reported_through_the_documentation_page_of_this_program": "The evaluation of this program will be an aggregate of evaluation from the programs’ linked activity records and reported through the Documentation page of this program",
        "grant_id": "Grant ID",
        "grant_id_required": "Grant ID is required",
        "manage_reference": "Manage Reference",
        "no_reference_selected": "No reference have been selected",
        "primary_domain": "Primary Domain",
        "primary_objective": "Primary Objective",
        "projected_grant_amount_required": "Projected Grant Amount is required",
        "secondary_domain": "Secondary Domain",
        "secondary_objective": "Secondary Objective",
        "select_festival_type": "Select Festival Type",
        "select_primary_objective": "Select Primary Objective",
        "select_reference": "Select",
        "select_reference_with_label": "Select {{label}}",
        "summarise": "Summarise",
        "support_description": "Support Description",
        "you_have_not_created_any_linked_activities_yet": "You have not created any linked activities yet…"
      },
      "grant_program": {
        "are_you_sure_you_want_to_remove_this_file_from_the_grant_program": "Are you sure you want to remove this file from the grant program?",
        "delete_item": "Delete Item",
        "export_program_data": "Export Program Data",
        "export_program_information_needed_for_the_grant_application_form": "Export program information needed for the grant application form.",
        "format": "Format",
        "grants": "Grants",
        "import_grantees": "Import Grantees",
        "import_grantees_from_smarty_grants": "Import grantees from Smarty Grants",
        "import_successful_grant_applicant_information_to_create_the_linked_activities_for_this_program": "Import successful grant applicant information to create the linked activities for this program.",
        "max_file_size": "Max file size - {{max_file_size}}",
        "non_required_field_entry_errors_detected": "Non-required field entry errors detected. You can proceed with upload, but the following entries will not be uploaded if errors are not resolved.",
        "required_information_errors_preventing_upload": "Required information errors preventing upload. Please resolve the following:",
        "smarty_grants": "Smarty Grants"
      },
      "grants_program": "Grants Program",
      "group_not_in_any_plan": "'{{groupName}}' had {{count}} participants. However, they are not included in any evaluation plan.",
      "group_not_in_any_plan_tooltip": "'{{groupName}}' has {{count}} participants but they are not considered in an evaluation plan.\n\nTo resolve this, reopen the activity (at the top of the Evaluation Plan page) and edit an existing evaluation plan to include this group, or alternatively create a new evaluation plan if you wish to evaluate this group independently.\n\nThis is simply for your information. It will not stop you from completing your activity.",
      "group_reason_required": "Group reason is required",
      "invite": "Invite",
      "invite_organisation_members": "Invite others to collaborate on this activity",
      "linked_activity": {
        "activate_activity": "Activate Activity",
        "activity_type_not_accessible": "Activity type not accessible",
        "add_modal_label": "Add {{label}}",
        "create_new_modal_label": "Create New {{label}}",
        "deactivate_activity": "Deactivate Activity",
        "deactivate_external_linked_activity": "Deactivate External Linked Activity",
        "deactivate_external_linked_activity_confirmation": "The manager of this linked activity is a user in an external Takso account. On confirmation of deactivation, the activity record will be transferred to that account where they can choose to continue or delete the activity.",
        "delete_activity": "Delete Activity",
        "delete_linked_activity": "Delete Linked Activity",
        "delete_linked_activity_confirmation": "Are you sure you want to delete this linked activity?",
        "delete_projected_activity_confirmation": "Are you sure you want to remove this projected activity?",
        "invitation_activity_type_not_accessible": "Invitation to this activity is not possible for the user in question as the activity type is not accessible or available to them",
        "invitation_blocked_root_not_organisation_owned": "This invitation is not possible because the top-level parent Program is not owned by an organisation user.",
        "linked_activity_will_be_permanently_removed_and_assigned_to_contact_organisation": "Linked Activity will be permanently removed and assigned to the contact organisation",
        "proceed_with_deactivation": "Proceed with deactivation.",
        "reason_for_activation": "Reason for activation",
        "reason_for_deactivation": "Reason for deactivation",
        "reason_for_deactivation_is_required": "Reason for deactivation is required",
        "status": {
          "accepted": "Accepted",
          "activated": "Activated",
          "deactivated": "Deactivated",
          "projected": "Projected",
          "review": "Review"
        },
        "this_email_does_not_match_an_existing_account_in_takso_enter_details_below_to_create_a_guest_account_for_this_person": "This email does not match an existing account in Takso. Enter details below to create a guest account for this person",
        "you_cannot_invite_to_same_user_again": "You can not not invite to same user again",
        "you_cannot_invite_user_activity_organisation_not_matched": "You can not invite this user to this activity. This organisation is not matched"
      },
      "manage_activity": "Manage Activity",
      "message_for_guest_user": "Message for guest user",
      "no_contractor_found": "No contractor found",
      "no_of_participants": "No of Participants",
      "no_sub_groups_have_been_created": "No sub-groups have been created",
      "no_users_added": "No users have been added",
      "no_users_has_been_added": "No users has been added",
      "output": {
        "activity_data": "Activity Data",
        "final_result": "Final Result",
        "financial_result": "Financial Result",
        "only_numbers_accepted": "Only numbers are accepted",
        "other_income": "Other Income",
        "other_income_help": "Revenue the activity generates itself (e.g. ticket sales), separate from Partner Funding and the Program Contribution.",
        "placeholder_date": "Select date",
        "projected_activity_final_result": "Projected Activity Final Result",
        "projected_activity_financial_result": "Projected Activity Financial Result",
        "projected_income": "Projected Income",
        "this_field_invalid": "This field is invalid",
        "ticketed": "Ticketed or registered event",
        "warning_content": "You have made changes to the activity after adding documentation information. Please review the documentation information to ensure all information is still correct and update any fields affected by changes."
      },
      "participant_adding_success": "Participant added successfully",
      "participant_groups": {
        "at_least_one_eval_stage_must_have_participants": "At least one evaluation stage must have participants.",
        "do_your_group_numbers_vary": "Do your sub-group numbers vary?",
        "no_negative_numbers": "No negative numbers are accepted.",
        "num_participants_must_be_at_least_zero": "Number of participants must be 0 or greater.",
        "remove_all_subgroups": "Please remove all subgroups before changing this setting to \"no\".",
        "vary_by_series_tooltip": "You have created a multiseries evaluation plan. For this plan, will your participant sub-group counts be variable?"
      },
      "participant_permission_update_success": "Participant permission updated successfully",
      "permission_changed": "Permission changed",
      "plan_participants_considered_exceed_groups": "\"{{planName}}\" has {{count}} participants considered, which is more than the participants in its evaluation groups: {{breakdown}} ({{total}} total).",
      "plan_responses_exceed_groups": "'{{planName}}' has {{count}} responses recorded, which is more than the participants in its evaluation groups: {{breakdown}} ({{total}} total).",
      "please_set_permissions": "Please set permissions",
      "please_set_permissions_activity_member": "Please set permissions for activity member",
      "please_set_permissions_new_member": "Please set permissions for new member",
      "potential_issues": "Potential Issues",
      "program_collaborator": "Program Collaborator",
      "program_description": "Program Description",
      "program_manager": "Program Manager",
      "projected": {
        "activity_description": "Activity Description",
        "activity_period": "Activity Period",
        "grant_id": "Grant ID",
        "modal_title": "Projected Linked Activity",
        "organisation_goal": "Organisation Goal",
        "period_to": " to "
      },
      "projected_inputs": "Projected Inputs",
      "projected_outputs": "Projected Outputs",
      "re_invite": "Re-invite",
      "reason": "Reason",
      "reason_for_this_group": "Reason for this Group",
      "save_group": "Save Group",
      "search_by_activity_name": "Search by Activity Name",
      "search_for_existing_users": "Search users in your organisation",
      "setup_activity": "Set Up Activity",
      "status": {
        "accepted": "Accepted",
        "activated": "Activated",
        "deactivated": "Deactivated",
        "review": "Review"
      },
      "subgroup_exceeds_total_participants": "'{{groupName}}' has {{count}} participants. More than the activities {{total}} total participants.",
      "subgroup_exceeds_total_participants_tooltip": "The total participants recorded above should reflect all of the participants in the activity. \n\nThe intention of sub-groups is to give you the ability to select a specific sub-section of your total participants; therefore, they should never exceed your total participant values.",
      "table": {
        "activation_information": "Activation Information",
        "contact_org": "Contact/Organisation",
        "contact_organisation": "Contact/Organisation",
        "empty_linked_activities": "You have not created any linked activities yet...",
        "tooltip_view_activity": "Click on text to View the Activity",
        "view_report": "View Report"
      },
      "total_no_of_participants": "Total No of Participants",
      "update_group": "Update Actual Participants for {{groupName}}",
      "update_permissions": "Update Permissions",
      "user_added_activity": "User added to activity"
    },
    "activity_steps": {
      "activity_confirmation_modal_body": "You are about to confirm the goal for your activity. From this point the goal will be locked and unable to change. Do you want to proceed with this activity addressing this goal?",
      "activity_confirmation_modal_title": "Activity Confirmation",
      "activity_goals_overview": "Activity Goals Overview",
      "analysis_and_reflection_title": "Analysis and Reflection",
      "approved_by_label": "Approved by",
      "contact_admin_msg": "Please contact Takso admin for support...",
      "document_title": "Activities - Flow | {{app_name}}",
      "error_occurred": "ERROR OCCURRED",
      "evaluation_plans_title": "Evaluation Plans",
      "intended_outcomes": "Intended Outcomes",
      "intended_outcomes_for_policy": "Intended Outcomes - {{policyName}}",
      "joyride_goal_tip": "You will be asked to nominate the organisation goal that this activity will address. Once selected the planning has commenced, it cannot be changed.",
      "joyride_report_tip": "The <b>Report page</b> is a real-time summary of the activity as it is being built and can be viewed, printed or exported at any time.",
      "joyride_steps_tip": "The steps between <b>Objective</b> and <b>Evaluation</b> can be changed and edited as often as required, until the activity has got the <b>Green Light</b> to proceed",
      "key_activity_data_title": "Key Activity Data",
      "multi_stage_evaluation_only_label": "Multi stage evaluation only",
      "objective_intended_outcomes": "Objective - Intended Outcomes",
      "organisation_goal_to_be_addressed": "Set Goal",
      "outcome_summary_title": "Outcome Summary",
      "outstanding_information_title": "Information required to complete the activity",
      "set_objective_title": "Select Objective",
      "validation_errors_for_approval": "Issues to resolve before requesting approval",
      "validation_errors_for_green_light": "Issues to resolve before approving the activity",
      "validation_errors_for_re_request_approval": "Issues to resolve before re-requesting approval"
    },
    "actual_outcomes": {
      "no_responses": "No responses have been recorded for this evaluation plan.",
      "title": "Actual Outcomes"
    },
    "actual_output": {
      "total_volunteers": "Total Volunteers",
      "venues": "Venue(s)"
    },
    "archive": {
      "archive_activity": "Archive Activity",
      "complete_activity_record": "Complete Activity Record",
      "reopen_activity": "Reopen Activity",
      "thank_you_for_completing_the_activity": "Thank you for completing the activity. From this point you will no be able to edit this activity. The Program manager will review your activity report and you will be notified when it has been accepted. If there are any issues the program manager will contact you directly."
    },
    "browse": {
      "filter_by_activity_type": "Filter by activity type",
      "no_event_details_recorded_yet": "No event details recorded yet."
    },
    "core_data": {
      "data": "Data",
      "data_to_collect": "Data to Collect",
      "enter_notes": "Enter Notes",
      "inputs": "Inputs",
      "no_inputs_found": "No Inputs found...",
      "no_reference_documents": "No reference documents",
      "reference_documents": "Core data reference documents",
      "report_year": "Report Year",
      "reporting_year": "Reporting Year",
      "select_reporting_year": "Select Reporting Year",
      "upload_report": "Upload Report"
    },
    "departments": {
      "no_departments_have_been_added": "No departments have been added"
    },
    "documentation": {
      "activity_data": "Activity Data",
      "actualInputs": {
        "title": "Actual Inputs"
      },
      "actualOutputs": {
        "title": "Actual Outputs"
      },
      "aggregateReports": {
        "advancedFilter": "ADVANCED FILTER",
        "backToOutcomesAddressed": "Back to Outcomes Addressed",
        "reportPreview": "Your report will be previewed here",
        "reportTypes": {
          "inputsOutputs": "Inputs & Outputs",
          "outcomesReported": "Outcomes Reported"
        }
      },
      "analysisAndReflection": {
        "subtitle": "Provide notes about the activity",
        "title": "Analysis and Reflection"
      },
      "analysis_and_reflection": {
        "evaluationResultsAnalysis": "Findings",
        "evaluationResultsPlaceholder": "What conclusions can you draw about participant outcomes and how they were achieved?",
        "nextSteps": "Next Steps",
        "nextStepsPlaceholder": "What follow-up actions, future activities, or recommendations arise from this activity?",
        "reflection": "Reflection",
        "reflectionPlaceholder": "Consider the activity as a whole and what you would like to pass on to readers of the activity report. Was the activity successful in achieving its intended outcomes? Was your theory of change confirmed? What did you learn? Were there any significant hindrances or problems?",
        "summary": "Next Steps",
        "unpublishedNote": "Unpublished Note",
        "unpublishedNoteHelp": "This will not be visible on the activity report or export."
      },
      "documents_and_media": {
        "delete": {
          "confirmation": "Are you sure you want to remove this file from the activity?",
          "title": "Delete Media"
        },
        "document": "Document",
        "form": {
          "acceptedFileTypes": "Accepted file types: .pdf, .docx, .jpg, .jpeg, .png",
          "browseFile": "Browse File",
          "enterLink": "Enter Link",
          "maxFileSize": "Max file size - 50 MB"
        },
        "link": "Link",
        "notifications": {
          "copiedToClipboard": "copied to clipboard",
          "documentLink": "Document Link"
        },
        "table": {
          "emptyMessage": "No items added",
          "format": "Format"
        },
        "title": "Documents & Media",
        "uploadDescription": "Upload activity photos, short clips, and documents as a record of the activity. Images intended for use in the report should aim to include a Source as the image credit.",
        "uploadItems": "Upload Items",
        "uploadMedia": "Upload Media"
      },
      "expenditure": "Expenditure",
      "finalDescription": {
        "activityDescription": "Activity Description",
        "subtitle": "Ensure the description accurately reflects the activity or program delivered.",
        "theActivity": "the activity",
        "title": "Executive Summary"
      },
      "financialSummary": {
        "actual": "Actual",
        "contractor": "Contractor",
        "contractors": "Contractors",
        "financial_result": "Financial Result",
        "in_kind_support": "In-kind support",
        "note_label": "Financial note",
        "note_placeholder": "Add any context a reader needs to understand these figures.",
        "other_expenditure": "Other Expenditure",
        "other_income": "Other income",
        "partner": "Partner",
        "partners": "Partners",
        "program_contribution": "Program Contribution",
        "program_grant": "Program Grant",
        "projected": "Projected",
        "title": "Financial Summary",
        "venue": "Venue",
        "venues": "Venues"
      },
      "grant_amount": "Grant Amount",
      "other_income": "Other Income",
      "programReports": {
        "title": "Program Reports"
      },
      "results": {
        "label": "Result",
        "placeholder": "Enter key results of the activity including significant outputs and unexpected and notable outcomes."
      },
      "summary": {
        "label": "Final activity description for report",
        "tooltip": "Update the activity description so it can lead the Executive Summary of the report"
      },
      "total_volunteers": "Total Volunteers"
    },
    "duplicate": {
      "duplicate_as_a_standalone_activity": "Duplicate as a standalone single activity",
      "keep_in_program": "Keep in program",
      "keep_in_program_linked_to": "Keep in program — linked to \"{{parentName}}\""
    },
    "errors": {
      "couldnt_delete_activity": "We couldn't delete the activity",
      "couldnt_submit_activity": "We couldn't submit the activity",
      "couldnt_unassign_the_group": "We couldn't unassign the group"
    },
    "evaluation": {
      "activity_approval": "Activity Approval",
      "activity_description": "Activity Description",
      "activity_on_a_page": "Activity on a page",
      "activity_requires_approval": "Activity requires approval",
      "add_more_questions": "Add more questions",
      "add_new_evaluation_plan": "Add Evaluation Plan",
      "add_subtitle": "Add Subtitle",
      "add_subtitle_to_evaluation_series": "Add Subtitle to Evaluation Series",
      "add_to_report_shortlist": "Add to report shortlist",
      "additional_questions": "Additional Questions",
      "additional_questions_warning": "When deciding to include additional questions, ensure that the information requested is needed and will be used. This will avoid the collection of unnecessary information and ensure your survey is succinct",
      "after": "After",
      "after_average": "After Average",
      "after_response_1_10": "after response (1-10)",
      "after_responses": "After Responses",
      "all_methods": "All Methods",
      "another_evaluation_exists": "Another evaluation plan including this group and outcome/s exits, do you want to do a self-assessment for this plan?",
      "approval_user_required": "Approval User is required!",
      "approved": "Approved",
      "average_number_of_respondents": "Average Number of Respondents",
      "average_response": "Average: {{value}}",
      "before": "Before",
      "before_average": "Before Average",
      "before_response_1_10": "before response (1-10)",
      "before_responses": "Before Responses",
      "cannot_be_undone_warning": "This cannot be undone. if you want to apply a new evaluation method, please go to evaluation page",
      "cdp_reference_code": "CDP Reference Code",
      "click_individual_plan_access": "Click on the individual plan to access your evaluation information.",
      "closed": "Closed",
      "closed_message": "This evaluation plan has been closed and no further changes can be made.",
      "comment": "Comment",
      "comments": "Comments",
      "confirmation": "Confirmation",
      "copied_to_clipboard": "Copied to clipboard",
      "could_not_delete_subtitle": "We couldn't delete the subtitle",
      "create_multi_stage_evaluation_series": "Multi-stage series evaluation",
      "create_new_evaluation_plan": "Create new Evaluation Plan",
      "csv_template_instructions": "Download the evaluation template, enter the {{csvRespondentType}} responses, then upload the completed CSV. Reuploading a CSV will replace existing CSV-uploaded responses, but online survey responses will not be affected.",
      "csv_upload": "CSV Upload",
      "culture_counts": "Culture Counts",
      "culture_counts_instruction": "Populate with your data and use the upload button to load your participant responses.",
      "custom_question": "Custom Question",
      "custom_questions": "Additional Questions",
      "custom_success_message": "Custom Success Message",
      "data_collection_method": "DATA COLLECTION METHOD",
      "data_collection_method_required": "Data collection method is required",
      "delete_confirmation": "Delete Confirmation",
      "delete_subtitle_confirmation": "Are you sure you want to delete this subtitle?",
      "delete_survey_confirmation": "Are you sure you want to delete this {{type}}?",
      "disabled": "Evaluation Disabled",
      "disabled_message": "This evaluation did not take place, participant outcomes have been surveyed in another evaluation plan.",
      "do_you_intend_to_survey_same_people": "Do you intend to survey the same people multiple times?",
      "documentation_changes_warning": "You are have made changes to the activity after adding documentation information. Please review the documentation information to ensure all information is still correct and update any fields affected by changes.",
      "dont_send": "Don't send",
      "download_csv_template": "Download CSV Template",
      "download_culture_counts_results": "Download evaluation results from Culture Counts as a CSV format file.",
      "download_instruction": "Download to view individual evaluation responses and comments",
      "download_response_csv": "Download Response CSV",
      "download_takker_csv_template": "Download Takker CSV Template",
      "download_template_instructions": "Download the evaluation template, populate with your data and use the upload button to load your participant responses.",
      "edit_evaluation_plan": "Edit Evaluation Plan",
      "edit_the_plan": "Edit the plan",
      "enter_request_for_respondent_email": "Enter request for respondent's email",
      "enter_your_question": "Enter your question",
      "evaluation_closed": "Evaluation Closed",
      "evaluation_complete_confirmation": "Evaluation Complete Confirmation",
      "evaluation_completed": "Evaluation completed",
      "evaluation_completed_message": "You have selected that an evaluation was completed for this objective, do you want to proceed? The selection cannot be undone",
      "evaluation_disabled": "Evaluation disabled",
      "evaluation_groups": "Evaluation Groups",
      "evaluation_information": "Evaluation Information",
      "evaluation_method": "EVALUATION METHOD",
      "evaluation_method_required": "Evaluation Method is required",
      "evaluation_not_completed_message": "You have selected that an evaluation was not completed for this objective, do you want to proceed? The selection cannot be undone",
      "evaluation_plan": "Evaluation Plan",
      "evaluation_plan_name": "Evaluation Plan Name",
      "evaluation_plan_name_required": "Evaluation Plan Name is required",
      "evaluation_plan_rename": "Evaluation Plan Rename",
      "evaluation_plans": "Evaluation Plans",
      "evaluation_questions": "Evaluation Questions",
      "evaluation_respondent_type": "EVALUATION RESPONDENT TYPE",
      "evaluations_takso_link_info": "For evaluations using the Takso link, survey links are available under the relevant plan. If you are not using the Takso link, the survey question is available to copy into your preferred survey tool. ",
      "evidence_types_used": "Evidence Used",
      "facilitator_notes": "Tips for running this evaluation",
      "festival_types": "Festival Types",
      "final_result": "Final Result",
      "financial_result": "Financial Result",
      "go_to_culture_counts": "Go to Culture Counts",
      "green_light_request_approval": "Green Light Request Approval",
      "hide_evaluation_details": "Hide Evaluation Details",
      "hide_evaluation_question": "Hide Evaluation Question",
      "hide_survey_information": "Hide Survey Information",
      "how_many_times_placeholder": "Number of times this evaluation will be repeated",
      "import_csv_data": "Import CSV Data",
      "import_culture_counts_csv_file_into_takso": "Import Culture Counts CSV file into Takso",
      "import_culture_counts_survey": "Import Culture Counts Survey",
      "include_in_report": "Include in report",
      "individual_rate_of_change": "Individual - Amount of change",
      "individual_responses": "Individual Responses",
      "intercept_only": "Intercept Only",
      "invitation_method_required": "Invitation method is required",
      "leave_page_confirmation": "Are you sure you want to leave this page?",
      "linked_evaluation_groups_required": "Linked evaluation groups are required",
      "linked_objectives_required": "Linked objectives are required",
      "manager_of_activity": "Manager Of Activity",
      "manual_collection_instruction": "In the fields below please specify the number of evaluation participants who selected the number on the scale from not-at-all to most imaginable.",
      "manual_evaluation_instructions": "In the fields below please specify the number of evaluation participants who selected the number on the scale from not-at-all to most imaginable.",
      "method_proceed_warning": "You are not able to proceed with this method. If you are considering doing multiple evaluations that will include different people, check the help page to see how this can be done.",
      "mgr_assessed_evaluation_message": "Manager-assessed evaluation will be completed on the Documentation Page.",
      "mgr_assessment_instructions": "Please click the \"Show Evaluation Details\" button and complete the manager-assessed questions below to ensure that your activity is evaluated and the record complete.",
      "must_be_minimum_2_evaluations": "Must be a minimum of 2 evaluations",
      "new_evaluation_name": "New Evaluation Name",
      "no_data_in_all_methods": "No data in all methods.",
      "no_data_in_selected_outcome": "No data in selected outcome.",
      "no_evaluation_group_to_select": "There is no evaluation group to select",
      "no_objective_selected": "There is no objective to select",
      "number_of_contractors": "Number of Contractors ",
      "number_of_csv_responses": "Responses from CSV upload: {{value}}",
      "number_of_online_responses": "Responses from online surveys: {{value}}",
      "number_of_participants_completed": "Total survey responses: {{value}}",
      "number_of_respondents": "Number of Respondents",
      "number_required": "Number of new workers created is required",
      "objective_name": "Objective Name",
      "okay": "Okay",
      "only_numbers_accepted": "Only numbers are accepted",
      "organisation_goal": "Organisation Goal",
      "organisation_members_in_team": "Organisation Members In Team",
      "outcome_analysis_editor_placeholder": "Describe what the data shows for this outcome — gain scores, patterns, and anything unexpected.",
      "outcome_narrative": {
        "toolbar_placeholder": "Describe what the data shows for this outcome — gain scores, patterns, and anything unexpected."
      },
      "outstanding_information": "Information required to complete the activity",
      "participant_response_1_10": "participant response (1-10)",
      "participants": "participants",
      "participants_considered_but_group_listed_zero_self_assessed": "{{count}} participants considered, but this evaluation's only group is listed with 0 participants.",
      "participants_considered_exceeds_target_self_assessed": "{{count}} participants considered, more than the {{listed}} targeted.",
      "participants_exceeded": "Please set correct values ({{count}} participants exceeded)",
      "participation_warning": "{{csvUploadWarningCount}} entry has pre-participation scores higher than post-participation scores.",
      "participation_warning2": "This indicates your activity had a negative impact on this participant.",
      "participation_warning2_plural": "This indicates your activity had a negative impact on these participants.",
      "participation_warning_correct": "If this result is correct, no action is needed.",
      "participation_warning_plural": "{{csvUploadWarningCount}} entries have pre-participation scores higher than post-participation scores.",
      "participation_warning_reupload": "If not, please correct and re-upload your CSV.",
      "pending": "Pending",
      "please_select_file": "Please select a file",
      "post_average_response": "Average after: {{value}}",
      "post_rate": "Post Rate",
      "pre_average_response": "Average before: {{value}}",
      "pre_rate": "Pre Rate",
      "preview_survey": "Preview Survey",
      "primary_objective": "Primary Objective",
      "projected_expenditure": "Projected Expenditure ",
      "projected_income": "Projected Income",
      "projected_inputs": "Projected Inputs",
      "projected_outputs": "Projected Outputs",
      "qst_component_heading": "Question Heading",
      "qst_component_method_heading": "Survey Introduction",
      "qst_component_question1": "First Question",
      "qst_component_question2": "Second Question",
      "qst_text_choice_graded": "Graded",
      "qst_text_choice_heading": "Question Text",
      "qst_text_choice_std": "Standard",
      "questions": "Questions",
      "re_notify_invitees": "Re-Notify Invitees",
      "re_open": "Re Open",
      "re_request_approval": "Re-Request Approval",
      "reason": "Reason",
      "reason_for_disabling": "Reason for disabling this evaluation",
      "reason_free_text": "reason (free text)",
      "reason_required": "Reason is required",
      "recommended_sample_size": "Recommended Sample Size",
      "recommended_sample_size_is": "We recommend a sample size of {{recommendedSampleSize}} participants.",
      "remove_from_report_shortlist": "Remove from report shortlist",
      "remove_series": "Remove Series",
      "request_approval": "Request Approval",
      "request_approval_button": "Request Approval",
      "request_approval_label": "Request Approval",
      "request_email": "Request Email",
      "requiring_green_light": "Requiring Green Light",
      "respondent_email_message_required": "Respondent email message is required",
      "respondent_subset": "Respondent Subset",
      "respondent_subset_takker": "Underage (Takker)",
      "response_date": "response date",
      "responses_exceed_total_participants": "{{count}} responses, more than the {{listed}} participants listed. Numbers may need updating on the <planLink>Activity Plan page</planLink>.",
      "responses_recorded_but_group_listed_zero": "{{count}} responses recorded, but this evaluation's only group is listed with 0 participants. Numbers may need updating on the <planLink>Activity Plan page</planLink>.",
      "responses_recorded_message": "This evaluation plan has responses recorded; do you wish to delete any responses and complete a self-evaluation for this plan?",
      "results": "Results",
      "sample_size_description": "Based on <b>{{totalParticipants}} total participants</b> in the selected groups and a <b>confidence level of 95%</b> and a <b>confidence interval of +/-5</b> the recommended sample size is <b>{{sampleSize}}</b>.",
      "save_evaluation_plan": "Save Evaluation Plan",
      "secondary_objective": "Secondary Objective",
      "select_data_collection_method": "Select Data Collection Method",
      "select_evaluation_group": "Select Evaluation Group",
      "select_evaluation_method": "Survey Method",
      "select_evaluation_respondent_type": "Survey Respondent",
      "select_invitees": "Select Invitees",
      "select_invitees_placeholder": "Select Invitees",
      "select_predefined_questions": "Select Predefined Questions",
      "select_request_approval_placeholder": "Select Request Approval",
      "select_user_required": "Select user is required",
      "self_assessed_chart": {
        "activity_count": "Activity Count",
        "mgr_assessed_separate": "Manager-Assessed Separate",
        "name_after_response": "{{name}} After Response",
        "name_before_response": "{{name}} Before Response",
        "participants": "Participants",
        "respondent_percentage": "Respondent Percentage",
        "respondents": "Respondents",
        "self_assessed_separate": "Self Assessed Separate"
      },
      "self_assessed_evaluation_message": "Self-assessed evaluation will be completed on the Documentation Page.",
      "self_assessment_confirmation": "Do you want to do a self-assessment for this plan?",
      "self_assessment_instructions": "Please click show evaluation details button and complete the self assessment questions below to ensure that your activity is evaluated and the record complete.",
      "self_evaluation_confirmation": "Self Evaluation Confirmation",
      "send_request": "Send Request",
      "send_to_all": "Send to all",
      "send_to_selected": "Send to selected",
      "show_evaluation_details": "Show Evaluation Details",
      "show_evaluation_question": "Show Evaluation Question",
      "show_survey_information": "Show Survey Information",
      "source": "Source",
      "std_to_graded_warning": "Your question text will change when you switch between graded and standard formats. If you continue, please review the question text and all replacement fields to ensure it is what you want.",
      "subtitle": "Subtitle",
      "subtitle_deleted_successfully": "Subtitle has been successfully deleted",
      "survey": "survey",
      "survey_completion_message": "Survey Completion Message",
      "survey_series": "survey series",
      "survey_title": "Title used on survey",
      "survey_title_reqd": "Survey Title is required",
      "takker_csv": "Evaluation questions have been rewritten to be more suitable for underage (Takker) participants. During this trial stage only CSV upload is avaliable.",
      "takso_link": "Takso Link",
      "tell_us_more_one_rating": "Can you tell us why you gave this rating?",
      "tell_us_more_two_ratings": "Can you tell us why you gave these two ratings?",
      "trend_rate_of_change": "Trend - Amount of change",
      "type_reason_placeholder": "Type your reason here",
      "unsaved_changes_message": "You have unsaved changes. Do you want to leave ?",
      "update_evaluation_plan": "Update Evaluation Plan",
      "upload_csv": "Upload CSV",
      "upload_csv_file": "Upload a CSV file",
      "upload_evaluation_template": "UPLOAD EVALUATION TEMPLATE",
      "venue_s": "Venue(s) ",
      "view_series": "View Series",
      "view_the_plan": "View the plan",
      "warning_message": "To construct an Evaluation Plan, you must first select project objective/s and at least one Projected Participant Group from activity plan page.",
      "was_evaluation_completed": "Was The Evaluation Completed ?",
      "what_is_your_age": "What is your Age?",
      "what_is_your_postcode": "What is your Postcode?",
      "your_organisation_requires_approval": "Your organisation requires activities to be approved to proceed before Green light can be given."
    },
    "evaluation_methodology": {
      "placeholder": "Summarise the approach taken to evaluating this activity, including the plan(s) used below.",
      "title": "Evaluation Methodology"
    },
    "evaluation_plan": {
      "10_12_years_old": "10-12 years old",
      "6_9_years_old": "6-9 years old",
      "after_1_to_10": "After {{outcomeTitle}} (1-10)",
      "before_1_to_10": "Before {{outcomeTitle}} (1-10)",
      "error_messages": {
        "assessment_basis": "Assessment Basis",
        "cannot_be_transferred_to_manager_assessed": "<p> This evaluation plan currently contains <strong>{{responseCount}}</strong> participant responses. </p> <p> This plan cannot be transferred to manager-assessed because a manager-assessed plan already exists for these evaluation groups. </p> <p> You can remove this plan, however all responses will be lost. </p> <div> <p>Please note this action cannot be reverted.</p> </div>",
        "cannot_be_transferred_to_manager_assessed_because_of_series_conflict": "<p> This plan cannot be switched to manager-assessed right now because of a series conflict. </p> <p> Please complete or adjust other plans in this series first, then try again. </p>",
        "cannot_transfer_to_manager_assessed": "<p> This evaluation plan currently contains <strong>{{responseCount}}</strong> participant responses. </p> <p> This plan cannot be transferred to manager-assessed because a manager-assessed plan already exists for these evaluation groups. </p> <p>You can remove this plan, however all responses will be lost.</p> <div> <p>Please note this action cannot be reverted.</p> </div>",
        "duplicate_manager_assessed_plan_found": "Duplicate Manager-Assessed Plan Found",
        "number_of_participants_considered": "Number Of Participants Considered",
        "reason_for_evaluation_method": "Reason for Evaluation Method",
        "reason_for_evaluation_rating": "Reason for Evaluation Rating"
      },
      "evaluation_groups": "Evaluation Groups",
      "evaluation_information": "Evaluation Information",
      "invalid_evaluation_method": "Invalid evaluation method selected",
      "mark_as_complete": "Mark evaluation as complete",
      "mark_as_complete_tooltip": "Please only select this when all data has been recorded. This action will lock the plan and prevent additional data from being added.",
      "no_responses_recorded": "No responses have been recorded for this evaluation plan.",
      "plan_switched_to_manager_assessed": "This plan has been switched to manager-assessed.",
      "proxy_respondents_only": "Proxy/expert respondents only",
      "remove_plan": "Remove Plan",
      "reopen_allows_you_to_add": "Re-opening allows you to add or edit data.",
      "reopen_evaluation": "Re-open Evaluation",
      "reopen_only_available_when_complete": "Re-open is only available when all other evaluation plans in this series are marked as complete.",
      "reopening_allows_new_data": "Re-opening allows new data uploads and response updates for this plan.",
      "replace_with_manager_assessed_button": "Replace with Manager-Assessed Evaluation",
      "replace_with_manager_assessed_evaluation": "Replace with Manager-Assessed Evaluation",
      "replace_with_manager_assessed_evaluation_warning": "<p> <strong>{{evalPlanName}}</strong> contains {{responseCount}} responses. </p> <p>If you continue:</p> <ul> <li>Responses will remain in the record.</li> <li>They will not be counted in reporting.</li> <li>A manager-assessed evaluation will replace this plan.</li> </ul> <div> <p>This is a one-way change and cannot be reverted.</p> </div>",
      "select_at_least_one_evaluation_group": "Please select at least one evaluation group",
      "select_data_collection_method": "Please select a data collection method",
      "select_evaluation_method": "Please select an evaluation method",
      "select_one_objective": "Please select at least one objective",
      "select_respondent_type": "Please select an evaluation respondent type",
      "switch_to_manager_assessed": "Switch to Manager-Assessed Evaluation",
      "switch_to_manager_assessed_tooltip_warning": "This change can’t be undone. If you need to run this evaluation again, re-open the activity in Activity Approval (at the top of this page), then create a new evaluation plan.",
      "switch_to_manager_assessed_will_replace_eval_plan": "<p>The current plan assesses these groups:</p> <groupList/> <p>A manager-assessed evaluation will replace this plan.</p> <div> <p>This is a one-way change and cannot be reverted.</p> </div>",
      "underage_coming_soon": "Support for underage participants coming soon",
      "underage_participants_by_proxy": "Under age participants by proxy"
    },
    "evidence": {
      "allow_in_all_takso": "Allow in the \"All Takso\" library",
      "assign_evidence": "Assign Evidence",
      "consider_the_evidence": "Consider the evidence (practice knowledge, research and data) that supports the choice of a {{title}} and how it will be structured to address the goal.",
      "evidence_from_the_takso_library_cannot_be_edited": "Evidence from the Takso library cannot be edited.",
      "evidence_library": "Evidence Library",
      "evidence_section_description": "Record your practice knowledge, significant background information such as venues, timing, past experience as well as the papers/documents/media that shape your activity's development.",
      "form": {
        "add": "Add Evidence",
        "add_author": "Add author",
        "add_new_evidence": "Add New Evidence",
        "author": "Author",
        "change_type": "Change type",
        "content": "Content",
        "content_placeholder": "Enter relevant information from the evidence your are using",
        "create_button": "Create Evidence",
        "create_new_evidence": "Create New Evidence",
        "date_added": "Date Added",
        "doi": "DOI",
        "doi_placeholder": "e.g. 10.1000/xyz123",
        "edit_evidence": "Edit evidence",
        "enter_evidence": "Enter evidence",
        "evidence_type": "Evidence Type",
        "library_cannot_edit": "Library evidence cannot be edited",
        "library_evidence": "Library Evidence",
        "link": "Link",
        "link_placeholder": "https://",
        "linked_objectives": "Linked Objectives",
        "material_type": "Material type",
        "primary_objective_label": "Primary Objective",
        "relevant_objectives": "Relevant objectives",
        "remove_author": "Remove author",
        "remove_evidence": "Remove evidence",
        "remove_evidence_confirm": "Are you sure you want to remove this evidence?",
        "restrict_to_my_evidence": "Restrict to my evidence",
        "search_placeholder": "Search evidence",
        "secondary_objective_label": "Secondary Objective",
        "select_evidence_type": "Select Evidence Type",
        "select_evidence_type_placeholder": "Select evidence type",
        "select_objective": "Select Objective",
        "source": "Source",
        "source_placeholder": "Enter source details - e.g. Author, title and date",
        "update_button": "Update Evidence",
        "view_evidence": "View Evidence"
      },
      "goal_description": "Goal Description",
      "intended_outcomes": "Intended Outcomes",
      "library": {
        "add_to_this_activity": "Add to this activity",
        "already_added_to_activity": "Already added to this activity",
        "browse": "Browse evidence you've used before, evidence from others in your organisation, and evidence from across Takso that may support this activity's objectives. <span>Note: evidence is only added to the Organisation and All Takso libraries once an activity has been marked as complete.</span>",
        "evidence_only_added_once": "Note: evidence is only added to the Organisation and All Takso libraries once an activity has been marked as complete.",
        "filter_by_evidence_type": "Filter by evidence type",
        "no_evidence_found": "No evidence found.",
        "previously_linked_to": "Previously linked to",
        "remove_from_activity": "Remove from activity",
        "search_evidence": "Search evidence...",
        "used_on_these_activities": "Used on these activities"
      },
      "no_evidence_added": "No evidence added",
      "no_evidence_has_been_added": "No evidence added",
      "please_select_outcomes": "Please select outcomes",
      "restrict_to_my_evidence": "Restrict to my evidence",
      "search_evidence_placeholder": "Search for Evidence",
      "select_a_goal": "Please select an goal",
      "select_an_objective": "Please select an objective",
      "selected_objectives": "Selected Objectives",
      "source_label": "Source (legacy)",
      "visibility_usage": "Your evidence is always visible to you and your organisation once the activity is complete, this toggle only controls whether it's also shared platform-wide with other organisations. Leave it off for anything unreleased or internal; otherwise, sharing helps build the wider knowledge base of Takso."
    },
    "goal": {
      "cultural_activity_must_have_outcome": "Cultural (an activity must have a cultural outcome)",
      "duplicate_modal_body": "Your activity has been successfully duplicated. Please review Evidence, Theory of Change, Plan and Evaluation pages to ensure all information is up to date and relevant to the activity as you plan to implement it now",
      "duplicate_modal_title": "Activity Successfully Duplicated",
      "no_primary_domain_for_activity": "No primary domain for this activity",
      "no_second_domain_for_activity": "No secondary domain for this activity",
      "objective_goal_description": "Community aware and valuing arts, culture and heritage.",
      "primary_policy_domain": "Primary domain",
      "primary_policy_domain_for_activity": "Primary Policy domain for activity",
      "primary_policy_domain_objectives": "{{policy_name}} Domain Objectives",
      "primary_policy_populated_from_goal": "Your primary policy domain will be populated based on the selected goal",
      "secondary_policy_domain": "Secondary domain",
      "secondary_policy_domain_for_activity": "Secondary policy domain for activity",
      "secondary_policy_domain_objectives": "{{policy_name}} Domain Objectives - Secondary Policy Domain",
      "secondary_policy_domains_optional": "Secondary Policy Domains for activity (optional)",
      "secondary_policy_populated_from_goal": "Your secondary policy domain will be populated based on the selected goal",
      "select_primary_policy_domain": "Select primary policy domain",
      "select_primary_policy_domain_from_options": "Select primary domain from available options.",
      "select_secondary_policy_domain": "Select secondary policy domain",
      "select_secondary_policy_domain_from_options": "Select secondary domain from available options.",
      "what_is_a_goal": "A goal is an idea of the future or desired result that a person or a group of people envisions, plans and commits to achieve."
    },
    "group_unassign": {
      "confirm": "Are you sure you want to unassign this group from this activity?",
      "title": "Unassign Group"
    },
    "home": {
      "activity_dates": "Activity Dates",
      "activity_or_temporary_title_required": "Activity title or temporarily title is required",
      "activity_plan_type_required": "Activity plan type is required",
      "create": {
        "add_button": "Add Activity",
        "modal_title": "New Activity Record"
      },
      "dates_not_set": "Dates not set",
      "delete": {
        "confirm": "Are you sure you want to delete this activity?",
        "title": "Delete Activity"
      },
      "duplicate": {
        "created_with_previous_goal": "This activity was created using a previous goal. To duplicate this activity, you need to select a current goal with matching domains",
        "goal": "Organisation Goal to be Addressed",
        "new_activity_name": "New Activity Name",
        "new_activity_required": "New activity name is required",
        "primary_domain_objectives": "{{policy_name}} Domain Objectives - Primary Policy Domain",
        "secondary_domain_objectives": "{{policy_name}} Domain Objectives - Secondary Policy Domain",
        "title": "Duplicate Activity",
        "unable_to_duplicate": "Unable to duplicate. The activity you are attempting to duplicate was created using a previous goal. There are no current goals with matching domains. Please recreate this activity as a new record"
      },
      "group_add": {
        "title": "Add to group"
      },
      "group_change": {
        "title": "Change group"
      },
      "group_form": {
        "existing": "Existing Group",
        "name_required": "New Group name is required",
        "new": "New Group",
        "new_name": "New Group Name",
        "required_existing": "Existing Group is required",
        "select_existing": "Select an Existing Group",
        "select_placeholder": "Select a group"
      },
      "invited": {
        "request_withdrawal": "Request Withdrawal"
      },
      "manage_group": {
        "modal_title": "Group Management",
        "trigger": "Manage Groups"
      },
      "manage_group_form": {
        "actions": "Actions",
        "activity_count": "Activity Count",
        "no_groups": "You have not created any project groups yet..."
      },
      "new_invitations": "New Invitations",
      "no_groups": "No groups",
      "owned": {
        "add_to_group": "Add to group",
        "change_group": "Change group",
        "duplicate": "Duplicate",
        "remove_from_group": "Remove from group",
        "view_team": "View Team"
      },
      "program_list": {
        "activity_managed_by": "Managed by {{name}}",
        "hide_linked": "Show only my activities in {{name}}",
        "linked_breakdown": "({{own}} managed by yourself, {{others}} managed by others)",
        "linked_count_one": "{{count}} activity",
        "linked_count_other": "{{count}} activities",
        "part_of": "Part of",
        "program_managed_by": "program managed by {{name}}",
        "show_linked": "Show all activities in {{name}}"
      },
      "remove_group": {
        "confirmation": "Are you sure you want to separate these activities?",
        "modal_title": "Delete Group - {{groupName}}",
        "notification_body": "We couldn't delete the project group",
        "notification_title": "Something went wrong",
        "trigger": "Separate"
      },
      "rename_group": {
        "group_name_required": "Group name is required",
        "modal_title": "Rename Group",
        "notificationBody": "We couldn't submit the activity",
        "notification_title": "Something went wrong",
        "trigger": "Rename"
      },
      "search_by_name": "Search by Activity Name",
      "steps": {
        "step_1": "This page lists all of the activities you own or are invited to.",
        "step_2": "Use this to start a new activity",
        "step_3": "All activities that you own will appear in this box. The coloured tab will tell you the status of the activity. Activities that you have been invited to contribute to will appear in a separate section under this.",
        "step_4": "You can filter the activities that appear in the box here."
      }
    },
    "individual_rate_of_change": {
      "activity_count": "Activity Count",
      "after_response": "After Response",
      "after_response_with_name": "{{name}} After Response",
      "aggregate_chart": "Aggregate",
      "average": "Average",
      "before_response": "Before Response",
      "before_response_with_name": "{{name}} Before Response",
      "count": "count: ",
      "evaluation_plan": "evaluation plan",
      "include_in_report": "Include in report",
      "mgr_assessed_aggregate": "Manager-Assessed Aggregate",
      "mgr_assessed_separate": "Manager-Assessed Separate",
      "no_data_in_that_method": "No data in that method.",
      "no_response": "no response",
      "no_responses": "No responses",
      "participants": "Participants",
      "post_result": "post result: ",
      "pre_result": "pre result: ",
      "respondent_percentage": "Respondent Percentage",
      "respondents": "Respondents",
      "response": "{{name}} Response",
      "self_assessed_aggregate": "Self Assessed Aggregate",
      "self_assessed_separate": "Self Assessed Separate",
      "separate_chart": "Separate",
      "title": "Individual Amount of Change"
    },
    "linked_activity": {
      "change_ownership": "Change Manager",
      "enter_details_of_the_new_activity_manager": "Enter details of the new activity manager",
      "notify_activity_manager": "Notify Activity Manager",
      "notify_activity_manager_confirm": "Are you sure, do you want to notify the manager of this activity?",
      "notify_existing_user": "Notify existing user",
      "notify_new_user": "Notify new user",
      "notify_of_changes": "Notify of changes",
      "re_send_notification": "Re-Send Notification",
      "this_activity_will_be_managed_by": "This activity will be managed by:"
    },
    "linked_activity_approval": {
      "accept_report": "Accept Report",
      "report_approval_title": "REPORT APPROVAL",
      "review_report": "Review Report"
    },
    "make_visible_in_takso_library": "Make visible in the Takso Library",
    "media": {
      "image_credit": {
        "label": "Image credit",
        "placeholder": "If to be used in reporting provide a credit or source."
      }
    },
    "messages": {
      "activity_accepted": "Activity has been successfully accepted!",
      "activity_documentation": "Activity Documentation",
      "activity_evidence": "Activity Evidence",
      "activity_group": "Activity Group",
      "activity_group_updated": "Activity group has been successfully updated!",
      "activity_member": "Activity Member",
      "activity_member_added": "Your new activity member has been successfully added!",
      "activity_rejected": "Activity has been successfully rejected!",
      "evaluation_plan": "Evaluation Plan",
      "evaluation_plan_closed_next_active": "{{evalPlanName}} has been successfully closed and next plan in the series is now active!",
      "evaluation_plan_created": "Evaluation Plan has been successfully created!",
      "evaluation_plan_deleted": "Evaluation Plan has been successfully deleted!",
      "evaluation_plan_updated": "Evaluation Plan has been successfully updated!",
      "evaluation_template_uploaded": "Your evaluation template has been successfully uploaded!",
      "final_evaluation_plan_closed": "Final evaluation plan is successfully closed.",
      "group_created": "Group has been successfully created!",
      "group_deleted": "Group has been successfully deleted!",
      "group_updated": "Group has been successfully updated!",
      "linked_activity": "Linked Activity",
      "linked_activity_deleted": "Linked Activity has been deleted.",
      "objective_evidences_created": "Objective evidences has been successfully created!",
      "objective_evidences_removed": "Objective evidences has been successfully removed!",
      "objective_evidences_updated": "Objective evidences has been successfully updated!",
      "outcome_summary": "Outcome Summary",
      "outcome_summary_updated": "Outcome Summary has been successfully updated!",
      "participant_group": "Participant Group",
      "project_contractor": "Project Contractor",
      "project_contractor_added": "Project contractor has been successfully added!",
      "project_contractor_deleted": "Project contractor has been successfully deleted!",
      "project_group": "Project Group",
      "project_group_name": "Project Group Name",
      "project_group_name_updated": "Your project group name has been successfully updated!",
      "project_note_created": "Project note has been successfully created!",
      "project_note_deleted": "Project note has been successfully deleted!",
      "project_notes": "Project Notes",
      "project_partner": "Project Partner",
      "project_partner_added": "Project partner has been successfully added!",
      "project_partner_deleted": "Project partner has been successfully deleted!",
      "project_partner_description_updated": "Project partner description has been successfully updated!",
      "project_references": "Project References",
      "project_references_updated": "Your project references have been successfully updated!",
      "project_venue": "Project Venue",
      "project_venue_deleted": "Project venue has been successfully deleted!",
      "project_venues": "Project Venues",
      "project_venues_added": "Project venues has been successfully added!",
      "projected_activity_activated": "Your projected activity has been activated.",
      "projected_activity_added": "New projected activity has been Added.",
      "projected_activity_deleted": "Projected activity has been deleted.",
      "projected_activity_updated": "Your projected activity has been updated.",
      "subtitle_deleted": "Subtitle has been successfully deleted!"
    },
    "no_activity_selected": "No activity selected.",
    "notes": {
      "evaluation_results_analysis": "Evaluation Analysis",
      "reflection": "Reflection"
    },
    "objective": {
      "domain_objective": "Domain Objective",
      "error": {
        "content": "Objectives can only be updated before participant data is collected. Participant responses have already been recorded on an evaluation plan that references this objective."
      },
      "heading": "Intended Outcome ({{policy}})",
      "missing_outcome_header": "We're sorry we can't find the outcome provided for \"{{objective}}\".",
      "please_select_an_goal": "Please select an goal",
      "policy_domain_objective": "{{policy}} Domain Objective",
      "select_placeholder": "Select",
      "select_primary_domain": "Select objective for {{policy}} domain",
      "select_secondary_domain": "Select objective for {{policy}} domain",
      "warning": {
        "change_objective": "You are about to change an objective of this activity, this may mean that any evidence and theory of change attached to the outcome is no longer relevant. If you proceed, review any evidence and theory of change.",
        "content": "You are about to change your activities objective. Please double-check your evidence and theory of change to ensure they reflect this change. Survey question text will be reset to the default; any modifications you may have made will be lost."
      }
    },
    "outcome_summary": {
      "heading": "Outcome Summary"
    },
    "participants": {
      "activity_manager": "Activity Manager",
      "add_guest_user": "Add Guest User",
      "are_you_sure_you_want_to_delete_this_participant": "Are you sure you want to delete this participant?",
      "delete_participant": "Delete Participant",
      "edit_permission_of": "Edit Permission of {{name}}",
      "email": "Email",
      "invitation_status": "Invitation Status",
      "invite_user": "Invite User",
      "leave_withdrawn_in_list": "Leave withdrawn name in the member list",
      "manage_activity_members": "Manage Activity Members",
      "member_name": "Member Name",
      "message_is_required": "Message is required",
      "message_to_member": "Message to member",
      "notify_member": "Notify member",
      "owner": "Manager",
      "participant_remove_success": "Participant remove success",
      "permission": "Permission",
      "please_enter_message_to_notify_participant": "Please enter message to notify participant",
      "remove_participant": "Remove Participant",
      "remove_withdrawn_from_list": "Remove withdrawn name from the member list",
      "type": "Type",
      "update_permission": "Update Permission",
      "user_was_removed_from_the_activity": "User was removed from the activity",
      "we_couldnt_delete_the_activity": "We couldn't delete the activity",
      "withdraw_confirm": "Withdraw",
      "withdraw_member": "Withdraw member",
      "you_have_not_created_any_participants_yet": "You have not created any participants yet…"
    },
    "permissions": {
      "guest_users_no_permission": "Guest user do not have permission to execute this action."
    },
    "preview": {
      "analysis_and_reflection": "Analysis and Reflection",
      "key_activity_data": "Key Activity Data",
      "objective_intended_outcomes": "Objective - Intended Outcomes",
      "objective_intended_outcomes_with_policy": "Objective - Intended Outcomes ({{policy}})",
      "report_compiled_contact": "If you have not received your report in 15 minutes, please contact",
      "report_compiled_line1": "Your report is being compiled and will be sent to the email address associated with this account.",
      "report_compiled_line2": "Reports with multiple graphs may take a few minutes to generate.",
      "report_is_being_generated": "Report is being generated"
    },
    "report": {
      "custom_reports": {
        "button_tooltip": "Preview and customise a report for this activity",
        "button_tooltip_not_available": "Report Builder is currently only available for single activities"
      },
      "if_you_have_not_received_your_report_in_15_minutes_please_contact": "If you have not received your report in 15 minutes, please contact",
      "report_being_generated": "Report is being generated",
      "reports_with_multiple_graphs_may_take_a_few_minutes_to_generate": "Reports with multiple graphs may take a few minutes to generate.",
      "show_in_report": "Show in report",
      "your_report_is_being_compiled_and_will_be_sent_to_the_email_address_associated_with_this_account": "Your report is being compiled and will be sent to the email address associated with this account."
    },
    "report_activity": {
      "activity_description": "Activity Description",
      "festival_types": "Festival Types",
      "organisation_goal": "Organisation Goal",
      "period_to": " to "
    },
    "search": {
      "no_activities_found": "No activities found",
      "no_activities_found_matching_filters": "No activities found matching your filters",
      "search_by_activity_name_or_id": "Search by Activity Name or ID"
    },
    "takso_access": "Takso Access",
    "theory_of_change": {
      "create_theory_of_change": "Create theory of change",
      "describe_activity_required": "Based on what you have entered above, describe what you will do to achieve the outcome",
      "describe_how_this_program_will_be_structured_to_achieve_the_objectives": "Describe how this {{activityType}} program will be structured to achieve the objectives",
      "evidence_types_used": "Evidence Used",
      "preview_theory_of_change": "Preview Theory of Change",
      "primary_domain": "Primary Domain",
      "secondary_domain_one": "Secondary Domain",
      "secondary_domain_other": "Secondary Domains",
      "selected_outcome": "Selected outcome",
      "summarise_strongest_points": "Summarise the evidence that informs your approach to the activity",
      "we_are_aiming_for_outcomes_in_no_selected_domains": "<strong>We are aiming for</strong> outcomes in the [selected domains].",
      "we_are_aiming_for_outcomes_in_the_selected_domains_one": "<strong>We are aiming for</strong> outcomes in the {{domains, list}} domain.",
      "we_are_aiming_for_outcomes_in_the_selected_domains_other": "<strong>We are aiming for</strong> outcomes in the {{domains, list}} domains."
    },
    "unarchive_parent_before_duplicating": "\"{{parentName}}\" needs to be un-archived before you can duplicate this activity into it."
  },
  "activity_manager_description": "{{percentage}} of these responses were Manager assessed. In this method the activity manager observes participants and estimates the rating they would give, then models a distribution using a standard deviation. This is a proxy measure, not a direct rating collected from participants. The distribution above may reflect the manager's judgement rather than participants' own experience, and should be interpreted with that in mind.",
  "activity_status": {
    "active": "Active",
    "all": "All",
    "all_activities": "All Activities",
    "archived": "Archived",
    "completed": "Completed",
    "completed_activities": "Completed Activities",
    "deactivated": "Deactivated",
    "documentation_delayed": "Documentation Delayed",
    "in_development": "In Development",
    "labels": {
      "active": "Active",
      "cancelled": "Cancelled",
      "completed": "Completed",
      "draft": "Draft",
      "greenlit": "Greenlit"
    },
    "missed_green_light": "Missed Green Light",
    "ongoing": "Ongoing",
    "ongoing_activities": "Ongoing Activities",
    "projected": "Projected",
    "ready_to_archive": "Ready to Archive"
  },
  "activity_type": {
    "all_types": "All Types",
    "festival": "Festival",
    "festival_program": "Festival Program",
    "grant": "Grant",
    "grants_program": "Grants Program",
    "linked": "Linked",
    "linked_activity": "Linked Activity",
    "multi_activity": "Multi Activity",
    "multi_activity_program": "Multi-Activity Program",
    "single": "Single",
    "single_activity": "Single Activity"
  },
  "admin": {
    "account": {
      "added_successfully": "Account Added Successfully!",
      "created_successfully": "Account Created Successfully!",
      "info_label": "Account Info",
      "updated_successfully": "Your Acccount Info has been successfully updated!"
    },
    "account_permission": {
      "label": "Account Permission"
    },
    "account_permission_group": {
      "added_successfully": "Account Permission Group Added Successfully!"
    },
    "activity_settings": {
      "activity_types": {
        "add_activity_type": "Add Activity Type",
        "create_activity_type": "Create Activity Type",
        "edit_activity_details": "Edit Activity Details",
        "no_activity_details": "No activity details",
        "output_fields": "Output Fields"
      },
      "evaluation_methods_tab": "Evaluation Methods",
      "evaluation_questions": {
        "enable": "Enable",
        "evaluation_question": "Evaluation Question",
        "introduction_outcome_measure": "Introduction of Outcome Measure",
        "post_pre_test_question": "This result has a post pre-test question",
        "preamble_required": "Preamble is required",
        "question_1": "Question 1",
        "question_1_required": "Question 1 is required",
        "question_2": "Question 2",
        "question_2_required": "Question 2 is required"
      },
      "evaluation_questions_tab": "Evaluation Qsts",
      "outcomes": {
        "add_outcome": "Add Outcome",
        "create_outcome": "Create Outcome",
        "enable": "Enable"
      },
      "output_formatters": {
        "add_format_groups": "Add Format Groups",
        "add_output_format": "Add Output Format",
        "checkbox_names": "Checkbox Names",
        "checkbox_options": "Checkbox Options",
        "create_output_format": "Create Output Format",
        "create_output_format_group": "Create Output Format Group",
        "delete_confirmation": "Delete Confirmation",
        "delete_output_format_confirm": "Are you sure you want to delete this Output Format",
        "delete_output_format_group_confirm": "Are you sure you want to delete this Output Format group?",
        "edit_format_group": "Edit Format Group",
        "edit_output_format": "Edit Output format",
        "field_name": "Field Name",
        "field_name_required": "Field name is required",
        "format_group": "Format Group",
        "formula": "Formula",
        "formula_no_whitespace": "The formula cannot contain whitespace",
        "formula_required": "Formula is required",
        "include_formula": "Include Formula",
        "label_name": "Label Name",
        "label_required": "Label is required",
        "no_output_formats_yet": "You have not created any Output Formats yet...",
        "search_by_name_or_field": "Search by Name or Field Name",
        "type_required": "Type is required",
        "view_format_groups": "View Format Groups"
      },
      "output_formatters_tab": "Output Formatters",
      "reference_formal_version": "Reference: Formal Version ({{locale}})",
      "title": "Activity Settings"
    },
    "activity_type": {
      "added_successfully": "Activity Type Added Successfully!",
      "updated_successfully": "Activity type has been successfully Updated!"
    },
    "email": {
      "sent_successfully": "Email is successfully sent!"
    },
    "email_logs": {
      "advanced_search": "Advanced Search",
      "context": "Context",
      "dates": "Dates",
      "email_content_preview": "Email content preview",
      "email_logs_advanced_search": "Email Logs - Advanced Search",
      "email_logs_details": "Email Logs - Details",
      "message": "Message",
      "no_email_logs_yet": "No email logs yet...",
      "no_html_content": "No HTML content available for this email.",
      "recipient_email_address": "Recipient email address",
      "search_by_recipient_name_or_email": "Search by recipient name or email",
      "search_subject": "Search subject",
      "send_test_email": "Send Test Email",
      "status": "Status",
      "subject": "Subject",
      "template": "Template",
      "test_email_queued": "Test email queued for sending.",
      "to": "To",
      "to_user": "To User"
    },
    "evaluation_methods": {
      "facilitator_notes": "Tips for running this evaluation",
      "method": "Method",
      "no_methods": "No methods",
      "respondent_type": "Respondent Type"
    },
    "evaluation_question": {
      "label": "Evaluation question",
      "updated_successfully": "Evaluation question has been successfully Updated!"
    },
    "feature": {
      "added_successfully": "Feature Added Successfully!",
      "label": "Feature",
      "updated_successfully": "Feature has been successfully Updated!"
    },
    "help_page": {
      "added_successfully": "Help Page Added Successfully!",
      "label": "Help Page",
      "updated_successfully": "Help page has been successfully Updated!"
    },
    "help_tip": {
      "added_successfully": "Help Tip Added Successfully!",
      "label": "Help Tip",
      "updated_successfully": "Help Tips has been successfully Updated!"
    },
    "individual": {
      "label": "Individual"
    },
    "industry": {
      "added_successfully": "Industry Added Successfully!",
      "label": "Industry",
      "updated_successfully": "Industry has been successfully Updated!"
    },
    "invoice": {
      "label": "Invoices",
      "status_updated_successfully": "Invoices Status has been successfully Updated!"
    },
    "logs": {
      "email_logs": "Email Logs",
      "logs": "Logs",
      "system_logs": "System Logs"
    },
    "method": {
      "label": "Method",
      "updated_successfully": "Method has been successfully Updated!"
    },
    "outcome": {
      "added_successfully": "Outcome Added Successfully!",
      "label": "Outcome",
      "updated_successfully": "Outcome has been successfully Updated!"
    },
    "output_format": {
      "added_successfully": "Output Format is Added Successfully!",
      "deleted_successfully": "Output Format is Deleted Successfully!",
      "label": "Output Format",
      "updated_successfully": "Output Formatter has been successfully Updated!"
    },
    "output_format_group": {
      "label": "Output Format Group",
      "updated_successfully": "Output Format Group has been successfully Updated!"
    },
    "permission_group": {
      "added_successfully": "Permission Group Added Successfully!",
      "label": "Permission Group",
      "updated_successfully": "Permission Group has been successfully Updated!"
    },
    "question": {
      "enable_disable_updated_successfully": "Question Enable/ disable has been successfully Updated!",
      "label": "Question"
    },
    "system_feature": {
      "activate": "Activate",
      "active_status": "Active Status",
      "add_new_feature": "Add New Feature",
      "add_permission_group": "Add Permission Group",
      "create_new_feature": "Create New Feature",
      "create_permission_group": "Create Permission Group",
      "feature_details": "Feature Details",
      "feature_name": "Feature Name",
      "feature_name_required": "Feature Name is required",
      "name_required": "Name is required",
      "no_features": "No Features...",
      "no_permission_grants": "No permission grants",
      "not_visible": "Not Visible",
      "please_enter_a_version": "Please Enter a Version",
      "search_by_feature_name": "Search by feature name",
      "search_by_permission_name": "Search by permission name",
      "select_all": "Select All",
      "userstory_link": "Userstory Link",
      "visibility": "Visibility",
      "visible": "Visible"
    },
    "system_logs": {
      "advance_search": "Advance Search",
      "advance_search_header": "Advance Search",
      "advanced_search": "Advanced Search",
      "change_activity_type": "change activity type",
      "guest_user": "Guest User",
      "handle_submit_activity_type": "Handle Submit Activity Type :",
      "keyword": "Keyword",
      "message": "Message",
      "no_data_activity_type": "No data in that date range or activity type or selected outcome.",
      "no_logs": "No Logs...",
      "selected_activity_type_description": "SELECTED ACTIVITY TYPE DESCRIPTION",
      "title": "Logs"
    },
    "system_reports": {
      "account_count": "Account count",
      "activity_count": "Activity count",
      "activity_summary": "Activity Summary",
      "actual_expenditures": "Actual Expenditures",
      "aggregate": "Aggregate",
      "aggregrate_tab": "Aggregrate",
      "calendar_year": "Calendar Year",
      "chart_type": "Chart Type",
      "completed_activities": "Completed Activities",
      "dataset": "Dataset",
      "date_range": "Date Range",
      "download_csv_template": "Download CSV Template",
      "enter_activity_count": "Enter Activity Count",
      "festival_program": "Festival Program",
      "financial_reporting_period": "Financial Reporting Period",
      "financial_year": "Financial Year",
      "grant_program": "Grant Program",
      "headline_data": "Headline Data",
      "individual_rate_of_change": "Individual Amount of Change",
      "intercept_aggregate": "Intercept Aggregate",
      "invalid_format": "Invalid format, Enter following format",
      "january_1_to_december_31": "January 1 to December 31",
      "july_1_to_june_30_following_year": "July 1 to June 30 Following Year",
      "linked_activity": "Linked Activity",
      "manual_outcomes_summary": "Manual Outcomes Summary",
      "method": "Method",
      "multi_activity_program": "Multi-Activity Program",
      "ongoing_activities": "Ongoing Activities",
      "outcomes_summary": "Outcomes Summary",
      "preview_report": "Preview Report",
      "projected_expenditures": "Projected Expenditures",
      "reference": "Reference",
      "report_year": "Report Year",
      "save_chart": "Save Chart",
      "separate": "Separate",
      "system_overview": "System Overview",
      "title": "System Reports",
      "total_participants": "Total Participants",
      "total_respondents": "Total Respondents",
      "trend_rate_of_change": "Trend Amount of Change",
      "trend_rate_of_change_tab": "Trend - Amount of change",
      "upload_template": "Upload Template",
      "your_report_will_be_previewed_here": "Your report will be previewed here"
    },
    "system_settings": {
      "export": {
        "all_organisations": "All organisations",
        "filter_by_organisation": "Filter by Organisation"
      },
      "helps": {
        "add_help_page": "Add Help Page",
        "add_help_tip": "Add Help Tip",
        "content": "Content",
        "create_help_page": "Create Help Page",
        "create_tip": "Create Tip",
        "edit_help_page": "Edit Help Page",
        "edit_help_tip": "Edit Help Tip",
        "field_name": "Field Name",
        "field_name_header": "Field name",
        "field_name_lower": "Field name",
        "field_name_lower_required": "Field name is required",
        "field_name_required": "Field Name is required",
        "help_page_is_required": "Help page is required",
        "help_page_name": "Help Page Name",
        "help_page_required": "Help Page is required",
        "id": "ID",
        "select_help_page": "Select Help Page"
      },
      "industry_sector_types": {
        "add_industry_sector_type": "Add Industry Sector Type",
        "create_industry_sector_type": "Create Industry Sector Type",
        "edit_industry_sector_type": "Edit Industry Sector Type",
        "sector_type_description": "Sector Type Description",
        "sector_type_description_required": "Sector Type Description is required"
      },
      "page_title": "System Settings",
      "system_data_export": "System Data Export",
      "system_data_export_title": "System Data Export",
      "system_help": "System Help",
      "system_help_title": "System Help",
      "venue_types": {
        "add_venue_type": "Add Venue Type",
        "create_venue_type": "Create Venue Type",
        "edit_venue_type": "Edit Venue Type",
        "enter_sector_type_description": "Enter sector type description",
        "environmental_tester_only": "Environmental Tester only",
        "venue_no_street_address": "This location has no street address",
        "venue_options_must_have_english_text": "Venue option(s) {{value}} must have English text.",
        "venue_type_options": "Venue Type Options"
      }
    },
    "user": {
      "account_guest_user_label": "Account guest user",
      "account_updated_successfully": "Account user is successfully updated!",
      "account_user_label": "Account user",
      "all_invited_activities_withdrawn": "all invited activities of user are withdrawn!",
      "created_successfully": "User is successfully created!",
      "deleted_successfully": "User is successfully deleted!",
      "guest_updated_successfully": "Account guest user is successfully updated!",
      "new_user_label": "New user",
      "type_updated_successfully": "User type is successfully updated!"
    },
    "user_organisation": {
      "accounts": {
        "account_permission_group": "Account Permission Group",
        "account_type": "Account Type:",
        "account_type_and_subscription": "Account Type and Subscription",
        "activate_account": "Activate Account",
        "activate_accounts": "Activate Accounts",
        "add_new_account": "Add New Account",
        "admin_details": "Admin Details",
        "amount": "Amount",
        "badges": {
          "demo": "Demo",
          "evidence_blocked": "Evidence Blocked"
        },
        "bank_reference_id": "Bank Reference ID",
        "bank_reference_id_required": "Bank Reference is required",
        "billing_and_invoices": "Billing and Invoices",
        "block_evidence": "Block Evidence",
        "comments": "Comments",
        "comments_required": "Description is required",
        "date": "Date",
        "date_required": "Date is required",
        "demo_account": "Demo A/C",
        "edit_account": "Edit Account",
        "edit_account_type": "Edit Account Type",
        "edit_permission": "Edit Permission",
        "features": "Features",
        "graded_qsts": "Graded Questions By Default",
        "invoice_id": "Invoice ID",
        "last_payment": "Last Payment",
        "manage_account": "Manage Account",
        "mark_as_paid_now": "Mark as paid now",
        "marked_by": "Marked By",
        "marked_on": "Marked On",
        "no_features": "No Features...",
        "no_invoices_for_organisation": "There are no invoices for this organisation...",
        "no_of_users": "# Users",
        "organisation_code": "Organisation Code",
        "organisation_details": "Organisation Details",
        "payment_preference": "Payment Preference",
        "permission_group": "Permission Group",
        "permissions": "Permissions",
        "required_program_feature": "Required Program Feature!",
        "search_by_name_email": "Search by name / email",
        "select_account_type": "Select Account Type",
        "select_at_least_one_permission_group": "Please Select at least one Permission Group",
        "select_payment_preference": "Select Payment Preference",
        "select_subscription": "Select Subscription",
        "subscription": "Subscription",
        "system": "System",
        "takso_support_email": "Takso support email (system won't send emails to this email)",
        "update_permission": "Update Permission",
        "will_be_not_added_since_all_feature_groups_are_redundant": "{{redundantPermission}} will be not added since all featureGroups are redundant."
      },
      "communication": {
        "all_system_users": "Send to All System Users",
        "broadcast_message": "Broadcast Message",
        "broadcast_new_message": "Broadcast New Message",
        "contact_organisation_users": "CONTACT ORGANISATION USERS",
        "contact_takso_support": "CONTACT TAKSO SUPPORT",
        "errors": {
          "message_reqd": "Message is required",
          "select_a_target": "Select at least one target format (Email or Dashboard)",
          "select_one_option_required": "Select a target",
          "select_organisation_required": "Select an organisation"
        },
        "message": "Message",
        "new_badge": "New",
        "no_notification_found": "No notification found...",
        "send_to_all_organisation": "Send to All Organisations",
        "send_to_all_users": "Send to All Users",
        "send_to_myself": "Send Test To Myself",
        "send_to_only_admins": "Send to Admins Only",
        "send_to_selected_organisation": "Send to Selected Organisations",
        "table": {
          "action": "Action",
          "all_organisations": "All Organisations",
          "all_system_users": "All System Users",
          "created_at": "Created At",
          "sender": "Sender",
          "test_message": "Test Message"
        },
        "view_broadcast_message": "View Broadcast Message"
      },
      "graded_questions": "Graded Questions",
      "graded_questions_on_by_default": "Graded Questions On By Default",
      "page_title": "Users & Organisations",
      "users": {
        "are_you_sure_you_want_to_delete_this_user": "Are you sure you want to delete this user?",
        "change_user_type": "Change User Type",
        "delete_user": "Delete User",
        "download_takso_users": "Download Takso Users",
        "edit_organisation": "Edit Organisation",
        "edit_user": "Edit User",
        "manage_users": "Manage Users",
        "no_users": "No Users...",
        "reassign": {
          "activity_group_description": "This activity is part of a group with {{count}} other activities. If you wish to remove this activity from the group and reassign to another user, select Single activity. If you wish to reassign all activities in the group to a new user, select All activities.",
          "reassign_all_activities": "Reassign All Activities",
          "reassign_an_activity": "Reassign An Activity",
          "select_activity_placeholder": "Select Activity",
          "select_project": "Select Project",
          "select_project_and_reassign": "Select a project to reassign to a different user",
          "transfer_all": "Select a user to select activities from and then transfer to a different user"
        },
        "reset_password": "Reset Password",
        "search_by_user": "Search by user",
        "takso_support_email": "Takso support email (system won't send emails to this email)",
        "the_account_associated_with_this_user_is_currently_disabled": "The account associated with this user is currently disabled",
        "user_has_active_development_activities": "User has {{count}} active / development activities. Activities for this user must first be reassigned."
      }
    },
    "users": {
      "login_as": "Login As {{name}} (#{{id}}) and Go To Activity",
      "login_as_id": "Login As #{{id}}"
    },
    "venue_type": {
      "added_successfully": "Venue Type Added Successfully!",
      "updated_successfully": "Venue Type has been successfully Updated!"
    }
  },
  "audit": {
    "activities_with_no_resolvable_org": "Inspection: Activities with no resolvable organisation",
    "activity_universe_funnel": "Activity Universe Funnel",
    "data_audit": "Data Audit",
    "deleted_excluded_from_universe": "Deleted (excluded from universe): <strong>{{numDeleted}}</strong> · Excluded from Valid: activities with no resolvable organisation or belonging to a demo account.",
    "internal_data_quality_checks": "Internal data quality checks — admin only.",
    "linked_singles_with_no_valid_parent": "Inspection: Linked singles with no valid parent program",
    "no_issues_found": "No issues found.",
    "non_deleted_activities_parent_not_resolved": "Non-deleted activities where neither the manager's org nor the parent program's manager's org can be resolved. Up to 200 shown.",
    "percentage_of_total": "% of Total",
    "reportable_singles_by_status": "Reportable Singles by Status",
    "singles_flagged_as_linked": "Singles flagged as linked (isLinkedActivity=1) but missing a valid parent program row, or whose parent is not a program type. Up to 200 shown.",
    "tables": {
      "headings": {
        "demo": "Demo?",
        "direct_org": "Direct Org",
        "id": "ID",
        "name": "Name",
        "org": "Org",
        "owner_email": "Manager Email",
        "parent_id": "Parent ID",
        "parent_name": "Parent Name",
        "parent_org": "Parent Org",
        "parent_plan_type": "Parent Plan Type",
        "parent_program": "Parent Program",
        "pct_of_universe": "% of Universe",
        "programs": "Programs",
        "reason": "Reason",
        "reportable": "Reportable",
        "singles": "Singles",
        "status": "Status",
        "tier": "Tier",
        "type": "Type",
        "universe": "Universe",
        "valid": "Valid"
      }
    }
  },
  "auth": {
    "account": {
      "disabled": {
        "description": {
          "line1": "This account has been deactivated.",
          "line2": "For more information or help, contact us <1>support@takso-outcomes.com</1>"
        },
        "title": "Inactive account"
      }
    },
    "errors": {
      "idle1": "You've timed out!",
      "idle2": "You were idle too long, you'll need to login again."
    },
    "forgot_password": {
      "back_to_signin": "Go back to Sign In",
      "contact_us": "Contact Us",
      "email_placeholder": "Enter your email",
      "form_subtitle": "We'll help you back in.",
      "form_title": "Forgot your password?",
      "instructions": "Enter the email address you used when you joined and we willl email you instructions to reset your password.",
      "invalid_email": "Please enter valid email address",
      "recovery_sub": "We sent a recovery link to you at",
      "reset_button": "Reset Password",
      "subtitle": "We will help you back in",
      "title": "Forgot password?"
    },
    "hello": "Hello!",
    "help": {
      "answer": "Answer:",
      "frequently_asked_questions": "Frequently asked questions",
      "no_takso_administrators_found": "No Takso administrators found…",
      "q1": {
        "description": "Takso Outcomes Planning Platform® is a cloud-based service provided by Cultural Development Network to enable producers, presenters, planners and artists to plan, build, record and evaluate their activities. <1>More information</1>",
        "title": "Q1. What is Takso?"
      },
      "q2": {
        "description": "There are four sources of assistance.",
        "description_line1": "When you first log in to WB each page is introduced with onboarding tips. These tips can be set on or off through your Profile Settings under you name.",
        "description_line2": "Page Help sliders can be activated by selecting the orange ‘i’ information icon on the top title area of the page.",
        "description_line3": "Hover-over tips are available. When you hold my mouse pointer over a field in the body of a page, you will see a short help-text pop-up.",
        "description_line4": "You can contact your Takso Administrator/s through the contact details above.",
        "title": "Q2. Where can I find out more about how Takso works?"
      },
      "q3": {
        "description": "Only you and those you invite to collaborate on the activity can see your work and this can be limited or expanded by the permissions you give them. When you complete an activity and it is archived, the public <strong>‘Report’</strong> is available to other Takso users on the system.",
        "title": "Q3. Is my work private?"
      },
      "q4": {
        "description": "Takso captures the entire narrative of an activity including your own reflection on what it achieved. Sharing this summary information enables others to learn from our experience, and over time builds our collective knowledge across the sector.",
        "title": "Q4. Why does Takso share my final report with others?"
      },
      "q5": {
        "description": "The entries you make in Takso are saved automatically as you progress.",
        "title": "Q5. Is there a ‘Save’ button to save my work"
      },
      "takso_administrators": "Takso Administrators"
    },
    "invite_link_expired": {
      "line1": "Looks like this invitation link is broken or has already been used.",
      "line2": "Please contact the activity manager, their details are in the invitation email.",
      "this_invite_link_is_no_longer_active": "This invite link is no longer active."
    },
    "organization_welcome": {
      "back_to_home_page": "Back to home page",
      "hello": "Hello!",
      "line1": "We got your account details successfully.",
      "line2": "One of our agent will be touch with you.",
      "thank_you_for_signed_up_with_takso": "Thank you for signed up with takso."
    },
    "pages": {
      "account_access": "Account Access",
      "email_verification": "Email Verification",
      "forgot_password": "Forgot Password",
      "invitation_verification": "Invitation Verification",
      "reset_password": "Reset Password",
      "sign_in": "Sign In",
      "user_profile": "User Profile",
      "user_registration": "User Registration"
    },
    "password_changed": {
      "success_button": "Go back to Sign In",
      "success_line_1": "Your password was reset successfully. You can now sign in",
      "success_line_2": "with your new password.",
      "success_title": "Password Changed!"
    },
    "password_link_expired": {
      "description": {
        "line1": "Your request to reset your password has expired or the link has",
        "line2": "already been used."
      },
      "title": "This password reset link is no longer active."
    },
    "reset_password": {
      "button": "Return to login",
      "description": "Set a new password for your account",
      "title": "Create New Password"
    },
    "settings": {
      "help_tips": "Help Tips",
      "show_application_help_tips": "Show application help tips",
      "show_onboarding_help_tips": "Show on-boarding help tips"
    },
    "sign_in": "Sign in",
    "sign_up": {
      "already_have_an_account": "Already have an account?",
      "good_news": "Good news! <orange>Takso</orange> could be a great fit for your business and people all over the world trust us.",
      "multiple_users_in_one_organisation": "Multiple users in one organisation",
      "quote_name": "Chanie Hyde",
      "quote_name_sub": "Beta Launch",
      "quote_text": "“I think what’s great about Intercom is that every message feels immediate and personal, allowing us to scale while staying authentic.”",
      "subtitle": "Sign Up to Continue",
      "title": "Sign Up",
      "to_manage_your_own_activities": "To manage your own activities",
      "what_type_of_account": "What type of account?"
    },
    "signin": {
      "email": "Email",
      "new_user": "New user? Contact us at ",
      "password_forgot": "Forgot password?",
      "subtitle": "Please sign in to continue.",
      "tagline": "<orange>Planning</orange> and evaluation made simple... and the results are powerful",
      "takso_definition": {
        "1": "<bold>A productivity tool: </bold>it saves time on planning and reporting activities",
        "2": "<bold>A learning tool:</bold> it enhances our knowledge as artists and producers",
        "3": "<bold>An advocacy tool:</bold> it provides the evidence for further investment",
        "4": "<bold>An innovation tool:</bold> it directs us towards new ways of thinking",
        "5": "<bold>An evaluation tool:</bold> it guides consistent planning for evaluation",
        "6": "<bold>A bank of ideas:</bold> it is a database of every cultural activity imaginable",
        "7": "<bold>Is easy to use:</bold> it is on-line and uses intuitive human processes",
        "intro": "What is <orange>Takso?</orange>"
      },
      "title": "Hello!"
    },
    "subscription_details": {
      "select_subscription_type": "Select Subscription Type...",
      "select_your_subscription_plan_and_enjoy_a_14_days_free_trial": "Select your subscription plan and enjoy a 14 days free trial",
      "subscription_details": "Subscription Details",
      "subscription_plan": "Subscription Plan",
      "subscription_type_required": "Subscription type is required",
      "your_plan_includes": "Your plan includes"
    },
    "user_profile": {
      "change_password": "CHANGE PASSWORD",
      "profile_details": "PROFILE DETAILS"
    },
    "user_registration": {
      "you_are_invited": "You Are Invited!",
      "you_have_been_invited_please_complete_the_registration_to_continue": "You have been invites to Takso. Complete the registration to continue"
    },
    "verification": {
      "almost_there": "Almost There!",
      "button": "Go back to Sign In",
      "description": {
        "line1": "Please click on the link that has just been sent to your email address",
        "line2": "to verify your account and continue the registration process"
      },
      "we_have_sent_you_a_verification_link": "We have sent you a verification link."
    },
    "welcome_to_takso": "Welcome to Takso",
    "you_can_now_sign_in_to_your_account": "You can now sign in to your account",
    "your_account_has_been_activated_successfully": "Your account has been activated successfully."
  },
  "chart_types": {
    "aggregate": "Aggregate",
    "aggregate_individual_rate_of_change": "Aggregate Individual - Amount of Change",
    "aggregate_results": "Aggregate Results",
    "aggregate_trend_rate_of_change": "Aggregate Trend - Amount of Change",
    "individual_rate_of_change": "Individual - Amount of Change",
    "manager_assessed_rate_of_change": "Manager-Assessed - Amount of Change",
    "self_assessed_rate_of_change": "Self-Assessed - Amount of Change",
    "separated": "Separated",
    "separated_results": "Separated Results",
    "single_results": "Single Results",
    "trend_rate_of_change": "Trend - Amount of Change"
  },
  "charts": {
    "100_pct": "100%",
    "activity_type_prose": {
      "breakdown1": "The activity breakdown shows {{activities}}, all classified as {{classifiedAs}}.",
      "breakdown2": "The activity breakdown shows {{activities}} across {{outputGroups}}. {{largestGroup}} is the largest group with {{largestGroupNumActivities}} ({{largestGroupPct}}), followed by {{secondLargestGroup}} with {{secondLargestGroupNumActivities}} ({{secondLargestGroupPct}}).",
      "most_common_acitity_type": "The most common activity type is {{mostCommonType}} with {{activities}} ({{pct}} of total)."
    },
    "after": "After",
    "after_responses": "After Responses",
    "all_fall_in_upper_range": "All {{distWordLower}} fall in the upper range of the scale, from {{lowestRating}} to {{highestRating}}.",
    "assessments": "Assessments",
    "average": "Average",
    "average_abbrev": "avg",
    "average_after": "Average after",
    "average_after_fmt": "{{label}}: <strong>{{avg}}</strong>",
    "average_before": "Average before",
    "average_before_fmt": "Average before: <strong>{{avg}}</strong>",
    "average_for": "Average - {{label}}",
    "avg_post_rating_compares": "The average post rating of {{avg}} compares to a pre rating of {{preAvg}}, a {{magnitude}} {{increaseOrDecrease}} of {{pctChange}}%.",
    "avg_post_rating_sits": "The average post rating of {{avg}} sits in the {{avgZone}}.",
    "avg_rating_sits": "The average rating of {{avg}} sits in the {{avgZone}}.",
    "before": "Before",
    "before_and_after_counts": "Before {{b}} → After {{a}}",
    "before_responses": "Before Responses",
    "chart_host": {
      "copy_picture_in_ppt_template": "Copy — use as a picture placeholder's shape name in a PowerPoint template",
      "display": "Display",
      "error_loading_chart": "Error loading chart",
      "loading_chart": "Loading chart",
      "show_link_counts": "Show link counts",
      "show_node_names": "Show node names",
      "unknown_chart": "Unknown chart"
    },
    "custom_chart_subtitle": "Custom Chart Subtitle",
    "data_direction": {
      "decrease": "decrease",
      "increase": "increase"
    },
    "data_zones": {
      "lower_third": "lower third",
      "middle_range": "middle range",
      "upper_third": "upper third"
    },
    "display_view": {
      "grouped": "Grouped",
      "ranked": "Ranked"
    },
    "download_graph": "Download graph",
    "errors": {
      "error_loading_ratings": "Error loading ratings",
      "no_svg_found": "No SVG found"
    },
    "estimated_hours_per_volunteer": "estimated {{hours}} per volunteer",
    "evaluation_plans": {
      "evaluation_plan": "evaluation plan",
      "filter_by_evaluation_plan": "Filter by evaluation plan",
      "plan": "Plan"
    },
    "evaluations_plural_one": "evaluation",
    "evaluations_plural_other": "evaluations",
    "figure": "Figure",
    "filter_by_method": "Filter by method",
    "filter_by_method_or_eval_plan": "Filter by method or evaluation plan",
    "filter_by_series": "Filter by series",
    "including_volunteers": "incl. {{volunteers}}",
    "loading_ratings": "Loading ratings",
    "method": "Method",
    "modes": {
      "individual_rate_of_change": "Individual – Amount of change",
      "trend_rate_of_change": "Trend – Amount of change",
      "trend_separate": "Separate"
    },
    "multi_series_selection": "multiseries selection",
    "multi_stage_evaluations_plural_one": "multistage evaluation",
    "multi_stage_evaluations_plural_other": "multistage evaluations",
    "multiseries": "Multiseries",
    "nearly_100_pct": "Nearly 100%",
    "no_activity_type_data_available": "No activity type data available.",
    "no_data": "No data",
    "no_data_for_current_eval_plan_choose_one_above": "No data for the current method/plan filter — choose at least one above.",
    "no_data_for_filter": "No data for the filter applied to this chart on the Evaluation tab.",
    "no_dollar_value": "no dollar value",
    "no_investment_data_for_completed_activities": "No investment data for completed activities.",
    "no_outcomes_selected": "No outcomes selected",
    "no_partner_data_for_completed_activities": "No partner data for completed activities.",
    "no_venu_data_for_completed_activities": "No venue data for completed activities.",
    "none_recorded": "None recorded",
    "not_at_all": "Not at all",
    "not_available_for_individual_graph": "Not available for the Individual graph",
    "num_activities_one": "1 activity",
    "num_activities_other": "{{countFmt}} activities",
    "num_hours_one": "{{countFmt}} hour",
    "num_hours_other": "{{countFmt}} hours",
    "num_output_groups_one": "1 output group",
    "num_output_groups_other": "{{count}} output groups",
    "num_participants_html": "<strong>{{cnt}}</strong> {{value}}",
    "num_respondents_one": "{{countFmt}} respondent",
    "num_respondents_other": "{{countFmt}} respondents",
    "num_stages_aggregated": "{{num}} stages, aggregated",
    "num_volunteers_one": "{{countFmt}} volunteer",
    "num_volunteers_other": "{{countFmt}} volunteers",
    "number_of_responses": "Number of responses",
    "only_completed_activities_included": "Only completed activities are included. Active and development activities are excluded from investment data.",
    "outcome_network": {
      "click_a_second_outcome": "Now click a second outcome to reveal their connection",
      "computing_layout": "Computing layout"
    },
    "outcome_ratings": {
      "activities_included": "Activities included",
      "measure": "Measure",
      "no_evaluation_data_for_this_outcome_under_current_filter": "No evaluation data found for this outcome under the current filter.",
      "number_of_responses": "Number of responses",
      "participants_in_evaluation": "Participants in evaluation",
      "pct_response_rate_fmt": "<strong>{{rate}}%</strong> response rate",
      "report_view_title": "REPORT VIEW — chart as it appears in the report",
      "select_an_activity": "Select at least one activity below to display the chart.",
      "select_an_eval_method": "Select at least one evaluation method to display the chart."
    },
    "participant_ladder": {
      "from_non_ticketed_events": "from non-ticketed events",
      "from_ticketed_and_reg_events": "from ticketed and registered events",
      "groups": {
        "active": "Active",
        "receptive": "Receptive"
      },
      "largest_category": "The largest category is {{name}} with {{num}} participants ({{pct}} of total reach).",
      "no_participant_data_available": "No participant data available.",
      "no_participant_data_recorded_for": "No participant data is recorded for {{category}} events in the current selection.",
      "non_ticketed": "non-ticketed",
      "participant_data_shows": "The participant data shows {{numPeople}} people{{fromEventType}}, made up of {{numReceptive}} receptive (audience) and {{numActive}} active participants.",
      "receptive_participant_accounts": "Receptive participation accounts for {{pct}} of total reach, with active participation — performers, competitors and workshop participants — making up the remainder.",
      "ticketed_registered": "ticketed / registered"
    },
    "participants_by_type": {
      "all_types_hidden": "All types hidden",
      "data_by_activity_type_shows": "Participant data by activity type shows {{num}} participants, all from {{group}} activities.",
      "data_by_activity_type_with_most": "Participant data by activity type shows {{num}} participants across {{numGroups}} output groups. {{group}} activities account for the most with {{topGroupNum}} participants.",
      "hide_unused": "Hide unused",
      "most_common_activity_type": "The most common activity type is {{name}} with {{num}} participants.",
      "no_data_for_this_group": "No participant data for this group",
      "no_participant_data_by_activity_type": "No participant data by activity type available.",
      "num_participants_one": "1 participant",
      "num_participants_other": "{{countFmt}} participants"
    },
    "participants_considered": "participants considered",
    "participants_in_evaluation": "Participants in evaluation",
    "participants_plural_one": "participant",
    "participants_plural_other": "participants",
    "pct_of_responses_in_7_to_10_range": "{{highPct}}% of {{distWordLower}} are in the 7–10 range.",
    "pct_of_responses_in_lower_half": "{{lowPct}}% of {{distWordLower}} are in the lower half of the scale.",
    "per_hour_compact": "/hr",
    "post": "Post",
    "post_data_fmt": "<strong>{{value}}</strong> {{afterOrResponsesLabel}}",
    "post_result_with_count": "Post Result - {{label}}  Count - {{numParticipants}}",
    "post_result_with_participants_and_eval_plan_or_activity": "Post Result - {{context}}  Count - {{numParticipants}}  {{forLabel}} Name - {{name}}",
    "pre": "Pre",
    "pre_data_fmt": "<strong>{{value}}</strong> before",
    "rating": "Rating",
    "reponse_rating_for": "Response rating for '{{displayName}}'",
    "reponses_tightly_grouped": "{{distWord}} are tightly grouped between {{lowestRating}} and {{highestRating}}, suggesting a consistent result across participants.",
    "response_rate": "response rate",
    "responses": "responses",
    "responses_come_from": "Responses come from {{num}} activities.",
    "responses_range_from_to": "{{distWord}} range from {{lowestRating}} to {{highestRating}}.",
    "result": "Result",
    "samples_small_and_indicative_only": "The sample is small and results are indicative only.",
    "series": "Series",
    "stages_plural_one": "stage",
    "stages_plural_other": "stages",
    "the_most": "The most",
    "this_chart_has_been_filtered_by": "This chart has been filtered (set on the Evaluation tab) by {{filterKindLabel}} and includes: {{evalPlanNames}}.",
    "venues": {
      "num_unique_venues_one": "{{count}} unique venue",
      "num_unique_venues_other": "{{count}} unique venues",
      "num_venue_links_one": "{{count}} activity-venue link",
      "num_venue_links_other": "{{count}} activity-venu links"
    },
    "view_rating_dist_for": "View rating distribution for \"{{title}}\""
  },
  "common": {
    "account": "Account",
    "accounts": "Accounts",
    "action": "Action",
    "activate": "Activate",
    "active": "Active",
    "activities": "Activities",
    "activity": "Activity",
    "activity_name": "Activity Name",
    "activity_notes": "Activity Notes",
    "activity_plan": "Activity Plan",
    "activity_section": "Activity Section",
    "activity_type": "Activity Type",
    "activity_types": "Activity Types",
    "actual": "Actual",
    "admins": "Admins",
    "aiming_for": "Aiming for",
    "aiming_for_outcomes_in_the": "aiming for outcomes in the",
    "all": "All",
    "all_activities": "All Activities",
    "all_organisations": "All Organisations",
    "analysis": "Analysis",
    "and": "And",
    "and_go_to_activity": "and Go To Activity",
    "and_knowing": "And Knowing",
    "are_you_sure_you_want_to_leave": "Are you sure you want to leave?",
    "ascending": "Ascending",
    "beta_tester": "Beta Tester",
    "billing": "Billing",
    "business_organisation": "Business/ Organisation",
    "cdn_admin": "CDN Admin",
    "checklist": "Checklist",
    "collapse_all": "Collapse all",
    "comment": "Comment",
    "communication": "Communication",
    "completed": "Completed",
    "contact": "Contact",
    "contractor": "Contractor",
    "contractors": "Contractors",
    "copied_to_clipboard": "Copied to clipboard",
    "created": "Created",
    "created_date": "Created Date",
    "csv_file": "CSV File",
    "current": "Current",
    "custom": "Custom",
    "dashboard": "Dashboard",
    "data": "Data",
    "data_source": "Data source",
    "date": "Date",
    "date_added": "Date Added",
    "date_created": "Date Created",
    "date_updated": "Date Updated",
    "deactivated": "Deactivated",
    "default": "Default",
    "department": "Department",
    "departments": "Departments",
    "dept_admin": "Department Admin",
    "descending": "Descending",
    "description": "Description",
    "disable": "Disable",
    "disabled": "Disabled",
    "documentation": "Documentation",
    "domains_and_knowing": "domains and knowing",
    "downloading": "Downloading",
    "edit": "Edit",
    "email": "Email",
    "enter_email": "Enter Email",
    "error": "Error",
    "evaluation": "Evaluation",
    "evaluation_group": "Evaluation Group",
    "evaluation_groups": "Evaluation Groups",
    "evidence": "Evidence",
    "expand_all": "Expand all",
    "features": "Features",
    "for_example_abbrev": "e.g.",
    "goal": "Goal",
    "goal_description": "Goal Description",
    "goal_w_num_one": "{{count}} Goal",
    "goal_w_num_other": "{{count}} Goals",
    "goals": "Goals",
    "goals_not_created": "Goals are not yet created",
    "grant_id": "Grant ID",
    "green_light": "Green Light",
    "group_name": "Group Name",
    "help": "Help",
    "hide_unused": "Hide unused",
    "in_development": "In Development",
    "industry_sector_types": "Industry Sector Types",
    "information": "Information",
    "invited_activities": "Invited Activities",
    "is_required": "is required",
    "language": "Language",
    "last_update": "Last Update",
    "last_updated": "Last Updated",
    "linked": "Linked",
    "loading": "Loading",
    "loading_data": "Loading data",
    "login_as": "Login As",
    "managed_activities": "Managed Activities",
    "manager": "Manager",
    "method": "Method",
    "more_as_in_6_more": "more",
    "most_imaginable": "Most imaginable",
    "most_imagined": "Most imagined",
    "name": "Name",
    "next": "Next",
    "no_access": "No Access",
    "no_activities": "No activities",
    "no_goals_found": "No Goals Found",
    "no_records": "No Records",
    "no_records_found": "No records found",
    "no_tooltips": "No tooltips",
    "no_users_found": "No users found.",
    "none": "None",
    "not_applicable": "N/A",
    "not_at_all": "Not at all",
    "not_known": "Not known",
    "note": "Note",
    "notes": "Notes",
    "objective": "Objective",
    "objectives": "Objectives",
    "off": "Off",
    "ok": "OK",
    "on": "On",
    "optional": "Optional",
    "options": "Options",
    "order_by": "Order By",
    "org_abbrev": "Org",
    "organisation": "Organisation",
    "organisation_type": "Organisation Type",
    "outcome": "Outcome",
    "outcomes": "Outcomes",
    "owner": "Manager",
    "parent": "Parent",
    "partner_with_cnt_one": "{{countFmt}} partner",
    "partner_with_cnt_other": "{{countFmt}} partners",
    "partner_with_cnt_zero": "{{countFmt}} partners",
    "partners": "Partners",
    "people_one": "{{count}} person",
    "people_other": "{{count}} people",
    "peoplez_one": "{{count}} person",
    "peoplez_other": "{{count}} people",
    "peoplez_zero": "no people",
    "permission": "Permission",
    "permission_groups": "Permission Groups",
    "plus_n_more": "+{{count}} more",
    "policy_domain": "Policy Domain",
    "preamble": "Preamble",
    "previous": "Previous",
    "primary": "Primary",
    "primary_domain": "Primary Domain",
    "primary_objective": "Primary Objective",
    "profile": "Profile",
    "program": "Program",
    "program_activities": "Program Activities",
    "program_activity": "Program Activity",
    "projected": "Projected",
    "read": "Read",
    "read_less": "Read Less",
    "read_more": "Read More",
    "reference": "Reference",
    "references": "References",
    "replaced": "Replaced",
    "report": "Report",
    "report_type": "Report Type",
    "reporting_date": "Reporting Date",
    "reports": "Reports",
    "save_png": "Save PNG",
    "saved": "Saved",
    "saving": "Saving",
    "secondary": "Secondary",
    "secondary_domain": "Secondary Domain",
    "secondary_objective": "Secondary Objective",
    "selected": "Selected",
    "sender": "Sender",
    "settings": "Settings",
    "show": "Show",
    "single_activity": "Single Activity",
    "something_went_wrong": "Something went wrong",
    "sort_by": "Sort By",
    "source": "Source",
    "status": "Status",
    "success": "Success",
    "takso_platform": "Takso Platform",
    "theory_of_change": "Theory of Change",
    "therefore_we_will": "Therefore we will",
    "title": "Title",
    "to_be_designed": "To be designed.",
    "todo": "Todo",
    "total": "Total",
    "type": "Type",
    "unit": "Unit",
    "units": "Units",
    "unknown": "Unknown",
    "untitled": "Untitled",
    "updated": "Updated",
    "updated_date": "Updated Date",
    "upgrade": "Upgrade",
    "user": "User",
    "users": "Users",
    "venue_types": "Venue Types",
    "venues": "Venues",
    "view_activity": "View Activity",
    "view_less": "View Less",
    "view_more": "View More",
    "warning": "Warning",
    "warning_shriek": "Warning!",
    "we_are": "We are",
    "we_are_aiming_for": "We are aiming for",
    "we_know_that": "We know that",
    "we_will": "We will",
    "write": "Write",
    "you_have_unsaved_changes": "You have unsaved changes. Do you want to leave?"
  },
  "constant": {
    "admin_setup": {
      "data_export": "Data Export"
    },
    "admin_tabs": {
      "evaluation_methods": "Evaluation Methods",
      "evaluation_qsts": "Evaluation Qsts",
      "output_formatters": "Output Formatters"
    },
    "managed_by_options": {
      "externally": "Externally",
      "internally": "Internally",
      "myself": "Myself"
    },
    "organisation_report_types": {
      "inputs_outputs": "Inputs & Outputs",
      "management_summary": "Management Summary",
      "outcomes_reported": "Outcomes Reported"
    },
    "routes": {
      "accounts_users": "Accounts & Users",
      "activities": "Activities",
      "activity_settings": "Activity Settings",
      "data_audit": "Data Audit",
      "library": "Library",
      "logs": "Logs",
      "preview_survey": "Preview Survey",
      "report_builder": "Report Builder",
      "reports": "Reports",
      "system_logs": "System Logs",
      "system_reports": "System Reports",
      "system_settings": "System Settings",
      "user_help": "User-Help",
      "user_profile": "User-Profile"
    },
    "subscriptions": {
      "access_library": "Access to Takso library",
      "aggregated_reports": "Aggregated and generate reports",
      "basic_contract_templates": "Basic Contract Templates",
      "basic_onboarding": "Basic Onboarding",
      "duplicate_plans": "Duplicate activity plans",
      "group_activities": "Group activities",
      "plan_evaluate": "Plan and evaluate single activities",
      "up_to_25_profiles": "Up to 25 profiles"
    }
  },
  "contractor_status": {
    "confirmed": "Confirmed",
    "projected": "Projected"
  },
  "contractors": {
    "by_occupation": "Contractors by occupation",
    "contractor_address": "Contractor address",
    "contractor_locations": "Contractor locations",
    "loading_locations": "Loading contractor locations",
    "location": "Location",
    "map_options": "Map options",
    "no_contractors_added": "No contractors added",
    "no_contractors_with_geocoded_address": "No contractors with a geocoded address found for this selection.",
    "none_assigned_yet": "No contractors assigned yet — add them via Activity Plan → Inputs.",
    "num_contractors_mapped": "<strong>{{total}}</strong> {{contractors}} mapped",
    "num_contractors_one": "1 contractor",
    "num_contractors_other": "{{count}} contractors",
    "num_outside_map_view": "<strong>{{numContractors}}</strong> outside map view",
    "occupation": "Occupation",
    "outside_map_view": "Contractors outside map view",
    "place_labels": "Place labels",
    "radius": "Radius",
    "without_map_address": "{{numContractors}} without a mapped address"
  },
  "csv": {
    "import": {
      "external_csv": "External CSV",
      "use_this_column": "Use this column"
    },
    "num_columns_one": "1 column",
    "num_columns_other": "{{count}} columns"
  },
  "dashboard": {
    "invited_only_in_progress": "Only activities that are in progress are shown",
    "recent_activities_no_notification_found": "No notification found…",
    "todo": {
      "empty": "No current to do list actions",
      "end_date": "End Date",
      "greenlight_date": "Greenlight Date",
      "last_update": "Last Update",
      "upcoming": "Upcoming",
      "urgent": "High Priority"
    },
    "tour": {
      "activities": "<0>This is an overview of the activities running in your organisation.</0><br/><br/><amber>Amber</amber> - activities in development<br/><green>Green</green> - active activities<br/><blue>Blue</blue> - completed activities",
      "activity_panel": "Click here to see and enter all the activities you own or are invited to.",
      "dashboard": "Click here to go to the dashboard to see a list of things to do, notifications from Admin, and a summary of activities.",
      "library": "Takso Library. View the public reports of all completed activities across Takso.",
      "main_menu": "This is the main menu. From here you can navigate to different sections of Takso.",
      "notifications": "Communication from your organisation's Takso admins will appear here.",
      "organisation": "Click here to manage your corporate information and organizational Takso settings.",
      "page_help": "Page Help. You can access information and help for each page by clicking the help tab.",
      "reports": "View reports for your account generated from aggregate data from each activity in Takso.",
      "show_me_around": "Click \"Show me around\" anytime you want to take this tour again.",
      "todo": "These are the tasks which you are due to complete and will disappear as you finish each one.",
      "user_settings": "User settings. From here you can update your details and password, find FAQs and log out."
    },
    "upgrade": {
      "add_card": "Add a card to start your subscription.",
      "add_card_button": "Add Card",
      "click_the_upgrade_button_to_start_your_subscription": "Click the upgrade button to start your subscription.",
      "ends_today": "Your free trial ends today.",
      "header": "Account Upgrade",
      "includes": "Your plan includes",
      "modal_title": "UPGRADE ACCOUNT",
      "payment_method": "PAYMENT METHOD",
      "payment_method_placeholder": "Select Payment Method...",
      "payment_required": "Payment method is required",
      "plan_title": "YOUR PLAN",
      "subscription_label": "SUBSCRIPTION",
      "subscription_placeholder": "Select Subscription Type...",
      "subscription_required": "Subscription type is required",
      "trial_remaining": "You have {{count}} days left on your free trial."
    }
  },
  "date": {
    "date": "Date",
    "date_to_date": "{{startDate}} to {{endDate}}",
    "placeholder_format_dd_mm_yyyy": "DD MM YYYY",
    "year": "Year"
  },
  "date_range": {
    "last_28_days": "Last 28 Days",
    "last_7_days": "Last 7 Days",
    "last_calendar_year": "Last calendar year",
    "last_financial_year": "Last financial year",
    "last_month": "Last Month",
    "last_quarter": "Last Quarter",
    "placeholder": "DD MM YYYY - DD MM YYYY",
    "since_the_start": "All Time",
    "this_calendar_year": "This calendar year",
    "this_financial_year": "This financial year",
    "this_month": "This Month",
    "this_quarter": "This Quarter",
    "year_to_date": "Year to Date"
  },
  "email": {
    "verification": {
      "business_organisation": "Business/Organisation",
      "confirmation_required": "Confirmation is required!",
      "enter_details_to_create_partner_record": "Enter details to create partner record.",
      "existing_user_match": "The details entered match an existing Takso user.",
      "invitation_activity_type_not_accessible": "You can not not invite this user to this activity. This activity type is not accessible",
      "you_cannot_invite_user_activity_organisation_not_matched": "You can not not invite this user to this activity. This organisation is not matched"
    }
  },
  "empty_message": {
    "no_activities": "No Activities",
    "no_organisations": "No Organisations...",
    "you_have_not_created_any_output_formats_yet": "You have not created any Output Formats yet…"
  },
  "error": {
    "403": {
      "description": "You do not have permission to access this page. Please contact your Site Administrator(s) to request access.",
      "title": "Access Denied"
    },
    "404": {
      "button": "Take me to the Homepage",
      "description": "Unfortunately, the page you're looking for doesn't exist (anymore) or there was an error in the link you followed or typed."
    }
  },
  "error_messages": {
    "action_not_allowed": "Action not allowed",
    "csv_is_required": "CSV is required",
    "invalid_csv_format": "Invalid CSV format",
    "please_contact_support": "Please contact support.",
    "please_fill_fields": "Please fill the following fields",
    "something_went_wrong": "Something went wrong"
  },
  "evidence_types": {
    "academic_literature": {
      "button": "Academic Literature",
      "content": {
        "label": "Relevance note",
        "placeholder": "Why is this relevant to your objective(s)?"
      }
    },
    "grey_literature": {
      "button": "Reports & Grey Literature",
      "content": {
        "label": "Relevance note",
        "placeholder": "Why is this relevant to your objective(s)?"
      }
    },
    "other_media": {
      "button": "Other Media",
      "content": {
        "label": "Relevance note",
        "placeholder": "Why is this relevant to your objective(s)?"
      }
    },
    "practice_knowledge": {
      "button": "Practice Knowledge",
      "content": {
        "label": "What did you learn?",
        "placeholder": "What did you learn, and how does it relate to this objective?"
      }
    }
  },
  "expenditure_status": {
    "actual": "Actual",
    "actual_program_contribution": "Actual Program Contribution",
    "actual_program_grant": "Actual Program Grant",
    "program_contribution": "Program Contribution",
    "program_grant": "Program Grant",
    "projected": "Projected"
  },
  "formulary": {
    "abn": "ABN",
    "abn_acn": "ABN/ ACN",
    "account_logo": "Account Logo",
    "activity_manager": "Activity Manager",
    "activity_notes": "Activity Notes",
    "address": "Address",
    "address_line_1": "Address Line 1",
    "address_line_2": "Address Line 2",
    "anzsco_contractor_service_group": "ANZSCO Contractor Service Group",
    "anzsco_occupation_service_type": "ANZSCO Occupation / Service Type",
    "business_org_name": "Business/ Organisation Name",
    "business_organisation_name": "Business/ Organisation Name",
    "business_organization_name": "Business/ Organization Name",
    "city_suburb": "City/ Suburb",
    "city_suburb_slash": "City / Suburb",
    "clear_selection": "Clear selection",
    "click_to_upload": "Click to upload",
    "company_business_name": "Company/ Business Name",
    "confirm_password": "Confirm Password",
    "contact_email": "Contact Email",
    "contact_number": "Contact Number",
    "content": "Content",
    "country": "Country",
    "created_date": "Created Date",
    "currency_type": "Currency Type",
    "department": "Department",
    "description": "Description",
    "different_postal_address": "Different Postal Address",
    "domain": "Domain",
    "email": "Email",
    "field_name": "Field Name",
    "file": {
      "upload": {
        "document_required": "Document is required",
        "no_attached_document": "There is no attached document."
      }
    },
    "first_name": "First Name",
    "goal": "Goal",
    "goal_description": "Goal Description",
    "grant_id": "Grant ID",
    "id": "ID",
    "label": "Label",
    "last_name": "Last Name",
    "location": {
      "address_label": "Address",
      "enter_location_placeholder": "Enter a location"
    },
    "manager_first_name": "Manager First Name",
    "manager_surname": "Manager Surname",
    "message": "Message",
    "name": "Name",
    "new_password": "New Password",
    "no_description": "no description",
    "no_outcomes": "No outcomes",
    "no_title": "no title",
    "no_users": "No users",
    "number_of_participants": "Number of Participants",
    "occupation_service_type": "Occupation / Service Type",
    "organisation_logo": "Organisation Logo",
    "organisation_name": "Organisation Name",
    "organisation_sector_type": "Organisation Sector Type",
    "organization_type": "Organization Type",
    "outcome": "Outcome",
    "output_format": "Output Format",
    "output_formatter": "Output Formatter",
    "password": "Password",
    "password_validation": {
      "lowercase": "At least 1 lower case letter (a...z)",
      "min_length": "At least 8 characters",
      "numeric": "At least 1 number (0...9)",
      "special_character": "At least 1 special character",
      "uppercase": "At least 1 upper case letter (A...Z)"
    },
    "payment_preference": "Payment Preference",
    "phone": "Phone",
    "phone_number": "Phone Number",
    "phone_optional": "Phone (Optional)",
    "placeholder": {
      "7_plus_characters": "7+ characters",
      "choose_an_option": "Choose an option",
      "choose_an_outcome": "Choose an Outcome",
      "confirm_password": "Confirm Password",
      "description_is_required": "Description is required",
      "enter_abn": "Enter ABN",
      "enter_abn_acn": "Enter ABN/ ACN",
      "enter_activity_name": "Enter activity name",
      "enter_activity_notes": "Enter activity notes",
      "enter_address_line_1": "Enter Address Line 1",
      "enter_address_line_2": "Enter Address Line 2",
      "enter_business_org_name": "Enter Business/ Organization Name",
      "enter_business_organization_name": "Enter Business/ Organization Name",
      "enter_company_business_name": "Enter Company/ Business Name",
      "enter_confirm_password": "Enter Confirm Password",
      "enter_description": "Enter Description",
      "enter_email": "Enter Email",
      "enter_email_address": "Enter Email Address",
      "enter_first_name": "Enter First Name",
      "enter_group_name": "Enter Group Name",
      "enter_last_name": "Enter Last Name",
      "enter_name": "Enter Name",
      "enter_new_password": "Enter New Password",
      "enter_organisation_name": "Enter Organisation Name",
      "enter_phone": "Enter Phone",
      "enter_phone_number": "Enter phone number",
      "enter_position_designation": "Enter Position / Designation",
      "enter_postcode": "Enter Postcode",
      "enter_state": "Enter State",
      "enter_suburb": "Enter Suburb",
      "enter_support_description": "Enter support description",
      "enter_surname": "Enter Surname",
      "enter_title": "Enter Title",
      "enter_venue_name": "Enter Venue Name",
      "enter_web_domain": "Enter Web Domain",
      "enter_website": "Enter website",
      "example_email": "example@mail.com",
      "no_unit_selected": "No Unit Selected",
      "please_select_goal": "Please select goal",
      "please_select_objective": "Please select objective",
      "please_select_outcomes": "Please select outcomes",
      "please_select_output_format": "Please select output format",
      "search_address_with_google": "Search address with Google",
      "select_a_domain": "Select a Domain",
      "select_a_goal": "Select a Goal",
      "select_activity_type": "Select an activity type",
      "select_an_option": "Select an Option",
      "select_an_user_type": "Select an User type",
      "select_contractor_service_group": "Select a contractor service group",
      "select_country": "Select country",
      "select_currency_type": "Select Currency Type",
      "select_department": "Select Department",
      "select_goal": "Select Goal",
      "select_organisation": "Select Organisation",
      "select_organisation_user": "Select organisation user",
      "select_outcome": "Select an Outcome",
      "select_output_format": "Select Output Format",
      "select_output_formatter": "Select Output Formatter",
      "select_payment_preference": "Select Payment Preference",
      "select_permission_type": "Select Permission Type",
      "select_primary_objective": "Select primary objective",
      "select_secondary_objective": "Select secondary objective",
      "select_sector": "Select a Sector",
      "select_state": "Select a State",
      "select_status": "Select Status",
      "select_type": "Select Type",
      "select_unit": "Select Unit",
      "select_venue_type": "Select a Venue Type",
      "select_your_goal": "Select your goal"
    },
    "position_designation": "Position / Designation (Optional)",
    "position_designation_optional": "Position / Designation (Optional)",
    "post_code": "Post Code",
    "postal_address_line_1": "Postal Address Line 1",
    "postal_address_line_2": "Postal Address Line 2",
    "postal_city_suburb": "Postal City / Suburb",
    "postal_code": "Postal Code",
    "postal_postcode": "Postal Postcode",
    "postal_state": "Postal State",
    "postcode": "Postcode",
    "primary_domain": "Primary Domain",
    "primary_objective": "Primary Objective",
    "primary_policy": "Primary Policy Domain for Activity",
    "primary_policy_note": "Your primary policy domain will be populated based on the selected goal",
    "program_contribution": "Program Contribution",
    "reference": "Reference",
    "relationship": "Relationship",
    "reload_all_data": "Reload all data",
    "search_venue": "Search Venue",
    "secondary_objective": "Secondary Objective",
    "secondary_policy": "Secondary domain",
    "secondary_policy_note": "Your secondary policy domain will be populated based on the selected goal",
    "select": "Select",
    "select_organisation_user": "Select organisation user",
    "select_user": "Select User",
    "select_user_type": "Select a user type",
    "select_users": "Select Users",
    "sender": "Sender",
    "state": "State",
    "state_province": "State / Province",
    "status": "Status",
    "subscription": "Subscription",
    "suburb": "Suburb",
    "support_description": "Support Description",
    "supports_formats": "Supports jpg, png, gmp formats",
    "surname": "Surname",
    "takso_support_email": "Takso support email  (system won't send emails to this email)",
    "title": "Title",
    "unit": "Unit",
    "unsaved_changes": "Unsaved changes",
    "updated_date": "Updated Date",
    "user_name": "User Name",
    "user_type": "User type",
    "validation": {
      "abn_acn_required": "ABN / ACN is required",
      "activity_manager_required": "Activity manager is required!",
      "activity_name_required": "Activity name is required!",
      "activity_type_required": "Activity type is required",
      "address_line_1_required": "Address Line 1 is required",
      "address_required": "Address is required",
      "business_org_name_required": "Business/ organisation name is required",
      "business_organisation_name_required": "Business/ organisation name is required!",
      "city_suburb_required": "City/ Suburb is required",
      "company_business_name_required": "Company/ Business Name is required",
      "confirm_password_required": "Confirm password is required",
      "confirmation_required": "Confirmation is required!",
      "contact_number_required": "Contact number  is required",
      "content_required": "Content is required",
      "contractor_category_required": "Contractor category is required",
      "contractor_service_group_required": "Contractor Service Group is required",
      "country_required": "Country is required",
      "currency_type_required": "Currency type is required",
      "department_or_unit_name_required": "{{department_or_unit}} name is required!",
      "description_required": "Description is required",
      "document_file_required": "Document file is required",
      "document_title_required": "Document title is required!",
      "doesnt_match_the_new_password": "Doesn't match the new password",
      "domain_required": "Domain is required!",
      "email_does_not_match_org_email_domain": "Email does not match with organisation email domain.",
      "email_invalid": "Please enter valid email address",
      "email_not_valid": "Email is not valid!",
      "email_required": "Email is required",
      "english_translation_required": "English translation is required (primary language)",
      "evidence_type_required": "Evidence type is required",
      "expenditure_value_required": "Expenditure value is required",
      "file_too_large": "File too large",
      "first_name_required": "First Name is required",
      "goal_required": "Goal is required",
      "goal_should_be_less_than_250_characters": "Goal should be less than 250 characters",
      "grant_id_not_valid": "Grant ID is not valid!",
      "grant_id_required": "Grant ID is required!",
      "group_name_required": "Group Name is required",
      "industry_sector_type_id_required": "Industry Sector Type Id is required",
      "last_name_required": "Last name is required",
      "link_invalid": "Link is invalid",
      "link_must_start_with": "Link must start with http:// or https://",
      "link_required": "Link is required",
      "linked_objectives_required": "Linked objectives are required!",
      "manager_first_name_required": "Activity manager first name is required",
      "manager_surname_required": "Activity Manager surname is required",
      "material_type_required": "Material type is required",
      "message_required": "Message is required",
      "min_10_digits": "Must be a minimum of 10 digits",
      "minimum_10_digits": "Must be a minimum of 10 digits",
      "must_be_a_minimum_of_10_digits": "Must be a minimum of 10 digits",
      "must_be_a_minimum_of_15_digits": "Must be a minimum of 15 digits",
      "name_required": "Name is required",
      "no_negative_numbers": "No negative numbers are accepted",
      "no_results_available_for": "No results available for {{label}}",
      "notes_required": "Notes are required!",
      "number_of_participants_considered_required": "Number Of Participants Considered is required",
      "number_of_participants_must_be_nonzero": "Number of participants must be 0 or greater",
      "number_of_participants_required": "Number of participants is required",
      "number_required": "Number is required",
      "occupation_service_type_required": "Occupation / Service Type is required",
      "only_numbers_accepted": "Only numbers accepted",
      "organisation_id_required": "Organisation Id is required!",
      "organisation_name_required": "Organisation name is required",
      "organisation_sector_type_required": "Organisation sector type is required",
      "outcome_required": "Outcome is required",
      "output_format_required": "Output format is required",
      "output_formatter_required": "Output formatter is required",
      "password_lowercase": "At least 1 lower case letter (a...z)",
      "password_min_length": "At least 8 characters",
      "password_must_have_at_least_7_characters": "Password must have at least 7 characters",
      "password_numeric": "At least 1 number (0...9)",
      "password_required": "Password is required",
      "password_special_character": "At least 1 special character",
      "password_uppercase": "At least 1 upper case letter (A...Z)",
      "payment_preference_required": "Payment Preference is required",
      "phone_number_not_valid": "Phone number is not valid!",
      "phone_number_required": "Phone number is required",
      "phone_required": "Phone is required",
      "please_enter_email": "Please enter email",
      "please_enter_password": "Please enter password",
      "please_enter_the_valid_format": "Please enter the valid format",
      "please_enter_valid_email": "Please enter valid email",
      "please_enter_valid_first_name": "Please enter valid first name",
      "please_enter_valid_organisation_name": "Please enter valid organisation name",
      "please_enter_valid_password": "Please enter valid password",
      "please_enter_valid_surname": "Please enter valid surname",
      "postal_address_required": "Postal Address is required",
      "postal_city_suburb_required": "Postal City / Suburb is required",
      "postal_code_required": "Postal Code is required",
      "postal_postcode_required": "Postal Post Code is required",
      "postal_state_required": "Postal State is required",
      "postal_street_address_required": "Postal Street Address is required",
      "postcode_required": "Postcode is required",
      "primary_objective_required": "Primary objective is required!",
      "primary_policy_required": "Primary Policy is required",
      "program_contribution_required": "Program contribution is required!",
      "program_contribution_value_required": "Program contribution value is required",
      "reference_field_label_required": "Reference field label is required!",
      "second_name_required": "Second name is required!",
      "secondary_objective_required": "Secondary objective is required!",
      "select_activity_type_required": "Select Activity type is required",
      "select_style": "Select a style",
      "select_user_required": "Select user is required",
      "source_required": "Source is required!",
      "state_required": "State is required",
      "street_address_required": "Street Address is required",
      "subscription_required": "Subscription is required",
      "suburb_required": "Suburb is required",
      "surname_required": "Surname is required",
      "title_required": "Title is required",
      "unable_to_invite_organisation_user_as_external": "Unable to invite organisation user as external!",
      "unsupported_file_format": "Unsupported File Format",
      "user_type_required": "User type is required",
      "valid_email": "Please enter valid email address",
      "venue_name_required": "Venue name is required!",
      "venue_type_required": "Venue type is required!",
      "web_domain_required": "Web domain is required"
    },
    "venue_name": "Venue Name",
    "venue_type": "Venue Type",
    "web_domain": "Web Domain",
    "website": "Website"
  },
  "grant_trial": {
    "defined_texts": {
      "add_report_to_takso_library": "Add report to Takso library",
      "continue_sentence_with_description": "Continue the sentence started above with your description",
      "continue_sentence_with_evidence_summary": "Continue the sentence started above with your evidence summary",
      "create_participant_sub_group": "Create participant sub group.",
      "goal": "Goal",
      "objective_for_domain": "Objective for {{domainName}} domain",
      "primary_policy_domain_populated": "Primary policy domain is populated based on selected goal",
      "secondary_policy_domain_populated": "Secondary policy domain is populated based on selected goal"
    },
    "help_tips": {
      "activity_activity_plan": "<p><strong>Activity Plan</strong></p>\n<p><strong>Action: </strong></p>\n<p>This page records the practicalities of the activity and is used to plan and project the activity. Once the activity is confirmed to go ahead this page is reset and is where you will record actual activity data.</p>\n<p><strong>Select Activity Type:</strong> use the drop down to select the most appropriate option that describes your activity. Note: if you are unsure of what to select},</p>\n<p><strong>Activity summary:</strong> enter description of the activity.</p> <br/><br/> <strong>Activity members:</strong> The program manager who set up this record will be automatically entered in this field. If you would like other people to assist you, select Add Guest User and enter their details. On selecting invite, they will be sent an email to set up their password and log into this record.<br/><br/>  <strong>Projected Inputs:</strong><br/><br/> <strong>Projected Program Contribution:</strong> This is the amount that this activity seeks from the overall program budget.<br/><br/> <strong>Expenditure:</strong> enter the amount you expect to spend in the delivery of this activity (including funds sought from the program).<br/><br/> <strong>Green light date:</strong>  This is the date for which the final decision to proceed with the activity needs to me made. If the date has been entered by the program manager, you will need to ensure that all pages prior to green light have been completed by the entered green light date.<br/><br/> <strong>Activity Start and End dates:</strong>  enter the expected first and last date of the proposed activity. One day activities should have the same date entered for start and end date.<br/><br/> <strong>Venue:</strong>  Enter Any venues you intend to use in the delivery of this activity should be entered. <br/><br/> <strong>Contractors:</strong> If you will need to pay for any services to deliver this activity enter details here via the Add New Contractor button. When entering new contractors, you will be asked to select two levels of Occupation for the contractor, based on the Australian New Zealand Standard Classification of Occupations (ANZSCO). In the first field, select the broad occupational group and in the second select the specific occupation that you will contract.<br/><br/> If you know the service you will need but not the specific contractor, select the projected button at the top of the pop up window and this will allow you to save with just the ANZSCO information. <br/><br/> <strong>Partners:</strong> Enter any people or organisations that will contribute to the activity but will not be paid. These could include people who provide skills or resources or financial support. <br/><br/> <strong>Projected outputs:</strong> <strong>Other income:</strong>  If you expect to receive an income from the activity such as ticket sales, enter an estimated amount. <strong>Participant fields:</strong><br/><br/> The participant fields shown will very depending on the activity type selected. In the relevant participant fields, enter the number of participants you expect to engage with this activity. You do not need to enter a number is every field but there should be at least one field completed. <br/><br/> Participants are categorized into two main groups: <br/><br/> <strong>Active participants:</strong> are involved with the creative process such as performers, or workshop participants. Depending on your activity, active participants can be free, be paid by the organiser, or be paying to participate. <strong>Receptive participants:</strong> are not involved in creative production but attend creative activities such as audience members or exhibition visitors. They can be free or paying.<br/><br/> <strong>Sub-group participants:</strong> This allows you to identify a sub-group from the participants you have identified above and is used if you wish to direct an evaluation survey to a group separate from the main survey.  If you create a sub-group, you will be able to create an evaluation plan for them on the next page.</p>",
      "activity_documentation": "<p><strong>Documentation page: </strong></p> <p><strong>Action: </strong></p> <p>On this page you will complete your activity record before submitting the report to the program manager.  <br/> <br/> Documents and media: Upload any photos/ videos/ documents etc from the activity. <br/> <br/> Actual Inputs & Actual Outputs: The information for these sections are drawn from the entries you made on the <strong>Activity plan</strong> page after Green Light. Review data to check for accuracy and if any changes are required, return to the Activity plan page to update information.  </p> <p><strong>Evaluation Analysis:</strong>  In this section provide an analysis of what you have learnt from the evaluation. Did your participants experience the intended outcomes? To what extent? What did their comments tell you about what was important to their outcomes.  </p> <p><strong>Reflection:</strong> In this section, look back at the activity as a whole, was it successful?  How do you know? Did it achieve the outcomes you expected? Did you learn anything new? Where there any problems or information you were no aware of when you began planning this activity?  </p> <p><strong>Unpublished note:</strong>  If you want to record any information or comments that are important to record but should not be in the report, you can add them here. The notes are only readable by people who have access to this record.  </p> <strong>Background/ information</strong> <p> The Evaluation Analysis and Reflection entries are added to the public report for this activity.  When writing these sections, think about what information and learning that may useful or you would like to share with others.  </p>",
      "activity_evaluation_plan": "<p><strong>Evaluation </strong></p> <p><strong>Action: </strong></p> <p> On this page you will identify how you intend to evaluate the outcomes of this activity.  Takso has a pre-written question for every outcome, but you will need to consider how you want to survey participants. <br/> <br/> Select the Add Evaluation Plan button and follow the steps to the creation and saving of an evaluation plan for this activity.  </p> <p> <strong>Background/ information</strong> <p>Takso survey methods include direct interview, questionnaire or focus group. You can create survey multiple participant groups in one survey or create separate evaluation plans for your individual participant groups. Takso will not allow you to create two evaluation plans that are the same. When considering multiple evaluations, take into account the need for additional evaluation and whether you have the resources to undertake multiple surveys.  <br/><br/> Start creating an evaluation plan by selecting the outcomes and participant groups you wish to evaluate.  </p> <strong>Recommended sample size,</strong> <p>The sample size number has been included to offer you a guide rather than a requirement and is set to a high validity level. While it is important for effective evaluation to think about the number of respondents, it is important to do the evaluation with the number of people you can access depending on their availability and your resources. All evaluation counts.</p> <strong>Select survey respondent</strong> <p>In most cases the participants will be the people you ask to consider the outcomes of the activity. This may not always be appropriate. For example, if your participant group are young children, you may want to ask a parent to respond for their child as a proxy or you may consider asking an expert in the field who has knowledge of the activity to give their opinion of the participants experience.</p> <p><strong>Participant:</strong> select this option when the people who participate in the activity will be responding to the survey.</p> <p><strong>Proxy:</strong> select this option when the person responding to the survey will not be the participant themselves but someone who knows the participant such as a parent or care giver.</p> <p><strong>Expert:</strong> select this option when the person responding to the survey is not directly involved with the participants but has expertise that can be used to evaluate the participants’ experience.</p> <p><strong>Manager-assessed:</strong> in instances where evaluation with participants, proxies or experts is not possible or a planned evaluation has not occurred, this method will ask the activity manager to give their own opinion on the participants’ outcomes. If you select this method, you do not have to complete any other fields on this page. The evaluation question will appear on this page after green light.  </p> <strong>Select survey method</strong> <p>There are a range of methods built into Takso and you can also choose methods outside the system such as using SurveyMonkey, or paper-based surveys, and phone interviews. All the data, regardless of method is recorded back into Takso. <br/><br/> When selecting your evaluation method, you should consider what resources you have available. For example, do you have enough people available to conduct interviews. If you only have one person available, they may only be able to survey 10 people in an hour. Do you have enough email addresses to use an online survey (and are people engaged enough to respond), do you have phone numbers to do a phone interview? Do you have a small participant group in which case a focus group is useful? These should all be considered when selecting your evaluation method.  </p> <p><strong>Interview:</strong> select this method if you will be speaking directly to the evaluation participants either in person or by phone.  </p> <p><strong>Questionnaire:</strong> select this method if you intend evaluation participants to read and answer questions themselves either via an email link, paper handouts or an “evaluation kiosk” at an event.  </p> <p><strong>Focus group:</strong> select this method when you intend to bring together a small group of evaluation participants to take part in a discussion on the activity and the outcomes.  </p> <strong>Select data collection method</strong> <p>How you collect the data will depend on the participants, the evaluation method, and your resources.  </p> <p><strong>Takso Link:</strong> Takso will generate a survey link and responses to the link will be automatically added to Takso. The survey links will be available on this page once the activity has been given the Green Light.  </p> <p><strong>CSV  Upload:</strong> Select this method if you intend to conduct your evaluation via an external survey platform such as Survey Monkey or on paper. Results can then be uploaded into Takso using the CSV template available after green light.  </p> <strong>Survey question</strong> <p>After you have made your selection, the survey question will be able to be viewed in the page by opening the section marked with the outcome name. If you are doing a paper survey or using platforms such as Survey Monkey you can copy and paste the question into your preferred platform.<br/><br/> The questions have been designed to give respondents the information needed to understand the outcome before being asked to reflect on their experience. Therefore, the question format should not be changed. If you wish to gather additional information such as demographics, this should be done after asking the outcome question as the outcome questions require more reflection on the part of the respondent.<br/><br/> If you are conducting evaluation using the Takso link, there is an opportunity to change parts of the question text to make the evaluation more appropriate to the activity. The editable sections are highlighted in the question preview. If you do change any text, be sure the read the question again to ensure the sentence is grammatically correct.  </p> <strong>Custom questions: </strong> <p> If you are using the Takso link and wish to gather any additional information, you can add additional questions. There are two pre-set questions to gather postcode and age information. If you would like any other information, check the custom question box and enter your own question. Any custom questions will appear in the survey link with a free text field for responses.<br/><br/> You can also request respondents’ email by checking the box and entering a request for email.  </p> <strong>Survey completion message: </strong> <p> After submitting a response to the Takso link, respondents are presented with a submission success message. You can customize this message here. <br/> <br/> Once you have saved an evaluation plan.  <br/> <br/> If you have any missing information on the previous pages, you will see an outstanding information message in blue. If you have no outstanding information message, the activity is considered ready for green light.  </p> <strong>Evaluation page post green light: </strong> <p> After green light has been given the evaluation page is re-set to become the place where you manage the evaluation and compile results. <br/> <br/> Show Survey Information: In this section your will find survey links, if you are using the Takso link.  Two links are generated, the single use link will only accept one response from a single device and should be used if you are sending the link to individual people.  The multi-use link will accept multiple responses from a device and should be used if you expect more than one person to respond on a single device. You can also generate a QR code for each link.   <br/> <br/> If you selected CSV upload, you will find the survey questions to copy into your own survey tool.  If you need to change the data collection method, you can do this from here.  You are able to change the method up until the first response has been entered.  </p> <strong>Show evaluation details: </strong> <p> Here is where responses are gathered for your survey.  If you are using the Takso link for the evaluation, you will see results as they come in here.<br/><br/> If you selected CSV upload as your data collection method, you will see a button to download a CSV template for you to enter results which can then be uploaded via the Upload button. <br/><br/> If you opted for a manager-assessed evaluation, you will only see Show Evaluation details, which will have the manager-assessed evaluation ready for completion. <br/><br/> Once you are certain that you have received all the responses you are likely to get, you can mark the evaluation as closed by responding to the question above the evaluation information button.  If the evaluation did not take place, answering no to this question will change the evaluation to a manager-assessed evaluation for you to complete.  </p>",
      "activity_evidence": "<p><strong>Evidence </strong></p>\n<p><strong>Action: </strong></p>\n<p>On this page you need to enter information on what you know about achieving your selected outcomes and why they are important to the community you intend to engage. The information entered on this page acts as an evidence base for your proposed activity.</p>\n<p>You need to add a minimum of one piece of evidence for each outcome and this evidence can come from published sources or your own experience and practice.</p>\n<p>You can enter evidence by selecting the “Add new evidence” button on the right of the page. If you are entering Practice knowledge evidence, you can add your position title as the source. Any practice knowledge you enter as evidence remains private to this activity and cannot be read by anyone who does not have access to this record.</p>\n<p>You can also search evidence used by other Takso users in their activities by using the search field on the left of the page.</p>\n<p>Once you have a least one piece of evidence linked to each outcome, you can move to the next page.</p><p><strong>Evidence tips: </strong></p>\n<p>If you are not sure about what information to enter as evidence, the following questions may help: <br/><br/>\n<strong>Think about the people you hope to engage with this activity, </strong><br/><br/>\nWhy are these outcomes important to them? <br/>\nWhere are they now in relation to this outcome?<br/><br/><br/>\n<strong>Think about the outcomes,</strong><br/><br/>\nWhat types of activities or processes assist the achievement of the outcomes?<br/>\nHow do you know your activity will achieve the outcomes?<br/>\nWhat resources do you have and what resources will you need to deliver your activity?<br/></p>",
      "activity_goal": "<p><strong>Goal </strong></p>\n<p><strong>Action: </strong></p>\n<p>The entries for this page were set when this record was created.  You do not need to do anything on this page.</p>\n<p><strong>Background: </strong></p>\n<p>This program of activities were created to address a goal of the funding organisation. The goal being addressed has been entered on this page, and should this activity be successful, it will have contributed to the achievement of the goal.</p>\n<p><strong>Domains: </strong></p>\n<p>A domain is an area of activity. There are five domains (Cultural, Social, Economic, Environmental and Governance) and each domain has a set of outcomes that can be achieved by individual activities. The selected domains are based on the selected goal, the program manager’s decision.  In some cases, you may have been given a choice of outcomes for this activity and those choices will dictate the domains entered on this page.</p>",
      "activity_objective": "<p><strong>Objective </strong></p>\n<p><strong>Action: </strong></p>\n<p>The entries for this page were set when this record was created.  You do not need to do anything on this page.</p>\n<p><strong>Background: </strong></p>\n<p> </p>\n<p><strong>Outcomes: </strong></p>\n<p>The objective page identified the outcome/s you are seeking to achieve via this activity. By outcome, we mean the change that occurs for participants as a result of experiencing an activity. In some cases the outcomes selected on this page have been identified by the program manager. In other instances you will have been asked to select the outcomes you wish to focus on. These should be reflected on this page.  If there are any problems, please contact the program manager.</p>",
      "activity_report": "<p><strong>Report: </strong></p> <p><strong>Action: </strong></p> <p>This page presents the final report for your activity that has been compiled from entries in the previous pages. You can download a copy of this report via the Export button on the top right of the page.<br/><br/> If you have any information outstanding from the previous pages, you will see an outstanding information notification in blue at the top of the page. If you have no outstanding information, you are able to close the record by selecting the Archive Activity button at the bottom of the page. </p> <strong>Background/ information:</strong> <p>Once you have Archived your activity, the program manager is notified that your activity has been finalized and that the report is ready to view.  If the Program Manager would like you to add more information to the activity record, they will re-open the record and let you know what information they would like you to enter. </p>",
      "activity_theory_of_change": "<p><strong>Theory of Change </strong></p>\n<p><strong>Action: </strong></p>\n<p>On this page you need to enter information in the text boxes to create a pitch (theory of change) explaining why for your proposed activity will achieve the outcomes.</p>\n<p>There are two text fields to complete for each outcome. Above each text field is a start of a sentence that you should continue in the text field.</p>\n<p>The first field requires you to enter a summary of the ideas from the evidence you entered for the outcome. In the second you should describe what you will do, as a result of that evidence, to achieve the outcome.</p>\n<p>A short way to think about this is:<br/><br/>\n<strong>Aiming for</strong> outcome selected\n<strong>and knowing</strong> summary of your evidence, <strong>we will</strong> do this to achieve the outcome.</p>\n<p>After you have completed both fields, select the preview Theory of Change button to check that your theory of change reads as a coherent idea.</p>"
    },
    "tooltips": {
      "active_participants_free": "Participants who are actively involved e.g. worship participants, performers etc and do not pay to be involved .",
      "active_participants_paid": "Participants who are actively involved e.g. worship participants, performers etc and are paid to attend activity.",
      "active_participants_paying": "Participants who are actively involved e.g. worship participants, performers etc who pay a fee to engage in activity.",
      "activity_approval": "Once all planning requirement have been completed you will be able to green light the activity as ready to proceed. ",
      "activity_description": "Check this description accurately describes what was delivered.",
      "activity_members": "Select the Add guest user button to invite people to collaborate with you on this activity record. The program manager is automatically invited to this record.",
      "activity_name": "The entered activity name can be changed or amended here",
      "activity_plan": "This page records input and output information. Note: in planning stages, this page will record projections  and when the activity has been given the go ahead to proceed, actual information will be recorded",
      "activity_summary": "This description will appear at the top of any reports generated for this activity.",
      "actual_inputs": "Check this information is correct and make any required changes via the Activity page",
      "actual_outputs": "Check this information is correct and make any required changes via the Activity page",
      "add_new_evidence": "Enter information from your own experience or research to support this activity.",
      "create_multi_stage_evaluation_series": "This is designed for long term activities that follow the same participants over an extended period. ",
      "create_sub_group": "Create sub-group if you wish to divide a single participant group in smaller groups for evaluation.",
      "documentation": "Enter you final analysis and reflection of the activity and review data for final report.",
      "evaluation": "Follow the steps to create an evaluation plan for this activity. See help for more information",
      "evaluation_results_analysis": "Consider the information from your evaluation and provide a analysis of what the evaluation tells you about participant's outcomes and the factors that were important.",
      "evidence": "This page records information about the intended outcomes and how to achieve them. See help to learn more.",
      "evidence_content": "Enter a summary of the information you want to use for evidence. Summaries should be clear and concise and avoid acronyms or other internal language as your evidence may be read by others.",
      "evidence_source": "Enter a reference for the information you have added. Your reference should enable anyone reading evidence to find the original source – Author, year, title and publication are suggested even when entering a URL. For practice knowledge evidence, enter your title/position, year and what the knowledge is based on",
      "goal": "This page shows the goals and domains selected for the program this activity is part of.",
      "green_light_date": "Enter the date you expect to have all planning pages in Takso complete and decision made to go ahead with this activity. Note, in some cases this date will have been set by the program manager.",
      "make_visible_in_takso_library": "To aid learning in the sector, final activity reports are added to the Takso library for all users. If you are happy for the final report (next page) to be added to the library, turn this switch on.",
      "objective": "On this page you will see the outcomes (Objective) that this activity is aiming to achieve",
      "projected_program_contribution": "The amount sought from the program to contribute to the delivery of this activity.",
      "receptive_participants_free": "Attendees not involved in creative production and not paying to attend activity.",
      "receptive_participants_paying": "Attendees who are not involved in creative production who are paying to participate in this activity",
      "reflection": "Looking back at the whole activity, provide a final reflection on the activity its successes and challenges.",
      "report": "Review and download final report and close activity record.",
      "search_evidence": "Explore evidence entered by Takso users in their activities",
      "select_activity_type": "From the list, select the activity type that most describes your proposed activity",
      "select_data_collection_method": "Select how you will collect the data and enter results into Takso",
      "select_evaluation_group": "Select the group/s you wish to direct this survey to. You can survey multiple groups in a single evaluation plan or create different plans for each group. Note: Sub-group surveys cannot be combined with other participant groups.",
      "select_evaluation_method": "Select how you will conduct the survey",
      "select_new_contractor": "Select \"Add new Contractor\" button to enter details of any people and services you will need to hire for this activity.",
      "select_new_partner": "Select \"Add new partner\" to enter details of any people/organisations who are contributing to the activity and are not receiving payment.",
      "select_new_venue": "Select \"Add new Venue\" button to enter details of any venues required for this activity",
      "select_objectives": "Select Objectives you wish to include in this survey. You can create multiple evaluation plans but each outcome must be included in at least one plan.",
      "select_outcome": "Select the outcome to preview the survey question.  Highlighted text can be clicked into and edited to make more appropriate to the activity and participants.",
      "summarise_evidence": "Summarise the key points from your evidence.",
      "toc": "On this page, you will create a program logic for the activity using what you have entered as evidence. See help for more information",
      "total_amount_needed": "Total amount needed to deliver this activity. ",
      "unpublished_report": "Enter any thoughts and observations that you wish to record with the activity but not include in the final report. This could issues encountered in delivery, or factors that contributed to success. Entries in this field will only be visible to those with access to this record.",
      "upload_media": "Upload activity records such as photos, short clips, and other documents. URLs are saved as text only and need to be copied and pasted into a browser to view.",
      "we_will": "Considering the evidence you have summarized above, describe the type of activity or process that is mostly likely to achieve the outcome."
    }
  },
  "help": {
    "tips": {
      "org_admin": {
        "tabs": {
          "activities": "",
          "communication": "",
          "contacts": "",
          "goals": "Goals from your organisation's strategic plan.",
          "profile": "Key organisation information",
          "settings": "",
          "user_management": "Add and remove users, assign and reassign activities.",
          "venues": "Venues owned and/or used by your organisation."
        }
      }
    }
  },
  "html_editors": {
    "collapse": "Collapse",
    "collapse_description": "Collapse to compact view",
    "expand_to_fit": "Expand to fit",
    "expand_to_fit_description": "Expand to show full text"
  },
  "image_picker": {
    "could_not_load_images": "Could not load images. Please try again.",
    "dual_outcomes_one": "dual outcome",
    "dual_outcomes_other": "dual outcomes",
    "evaluation_plans_one": "evaluation plan",
    "evaluation_plans_other": "evaluation plans",
    "loading_images": "Loading images",
    "no_images_found_upload": "No images found. Upload images to the activity's <strong>Documents & Media</strong> card first.",
    "plan_count_summary_fmt": "<strong>{{planCount}}</strong> {{evalPlans}} , <strong>{{dualActivityCount}}</strong> {{dualOutcomes}} , <strong>{{singleActivityCount}}</strong> {{singleOutcomes}}",
    "select_image_from": "Select image from Documents & Media",
    "single_outcomes_one": "single outcome",
    "single_outcomes_other": "single outcomes",
    "use_n_images_one": "Use {{count}} image",
    "use_n_images_other": "Use {{count}} images",
    "use_this_image": "Use this image"
  },
  "images": {
    "upload_image": "Upload Image"
  },
  "invoice_status": {
    "closed": "Closed",
    "fail": "Fail",
    "overdue": "Overdue",
    "paid": "Paid",
    "pending": "Pending"
  },
  "library": {
    "browseActivities": {
      "activityBrowser": "Activity Library",
      "activityBrowserSubTitle": "Explore activity reports created across the Takso Platform.",
      "activityName": "Activity Name",
      "activitySummary": "Activity Summary",
      "dateCreated": "Date Created:",
      "lastEdited": "Last Edited:",
      "noActivities": "No activities...",
      "preview": "Preview",
      "scopes": {
        "all_takso": "All Takso",
        "my_library": "My Library",
        "my_organisation": "My Organisation"
      },
      "searchActivities": "Search Activities"
    }
  },
  "maps": {
    "boundary": "Boundary",
    "heatmap": "Heatmap",
    "interactive": "Interactive",
    "map_options": "Map options",
    "map_type": "Map type",
    "report_view": "Report view",
    "yes_load_map": "Yes, load map",
    "zoom_level": "Zoom level"
  },
  "network": {
    "back_online": "Back online",
    "no_internet_connection": "No internet connection",
    "your_connection_is_slow": "Your connection is slow. There may be a delay in saving your work."
  },
  "notifications": {
    "broadcast_message": "Broadcast Message",
    "broadcast_new_message": "Broadcast New Message",
    "broadcast_notification": "Broadcast Notification",
    "broadcast_notification_super_admin": "Broadcast Notification - Super Admin",
    "no_notification_found": "No notification found…",
    "received_notification": "Received Notification",
    "select_organisation": "Select Organisation",
    "select_organisation_is_required": "Select organisation is required",
    "send_to_all_organisation": "Send to all organisation",
    "title": "Notifications",
    "view_broadcast_message": "View Broadcast Message"
  },
  "organisation": {
    "activities": {
      "invited": "Invited",
      "managed": "Managed",
      "no_user_activities_yet": "No user activities yet…",
      "show_by": "Show by:",
      "user_activities_header": "User Activities - {{user_name}}"
    },
    "communication": {
      "contact_support": "Contact Takso Support",
      "errors": {
        "message_reqd": "Message is required",
        "select_a_target": "Select at least one target format (Email or Dashboard)",
        "select_one_option_required": "Select a target",
        "select_users_required": "Select one or more users"
      },
      "new_badge": "New",
      "no_notification_found": "No notification found...",
      "notification_creation_header": "Contact Organisation Users",
      "notification_creation_trigger": "Contact Organisation Users",
      "select_users_heading": "SELECT USERS",
      "select_users_placeholder": "Select Users",
      "send_to_all_users": "All Users",
      "send_to_myself": "Send Test To Myself",
      "send_to_org_admins": "Org Admins",
      "send_to_selected_users": "Selected Users",
      "sender": "Sender",
      "view_broadcast_message": "View Broadcast Message"
    },
    "contacts": {
      "add_new_contractor": "Add New Contractor",
      "add_new_partner": "Add New Partner",
      "confirm_delete_contractor": "Are you sure you want to delete this contractor?",
      "confirm_delete_partner": "Are you sure you want to delete this partner?",
      "delete_contractor_with_name": "Delete Contractor - {{name}}",
      "delete_partner_with_name": "Delete Partner - {{name}}",
      "manage_contacts": "Manage Contacts",
      "no_activities_for_partner": "No Activities belongs to this partner...",
      "no_contractors_added": "No contractors have been added...",
      "no_partners": "No partners have been added...",
      "partner_form": {
        "anonymous_donor": "Anonymous Donor",
        "funding": "Funding",
        "in_kind": "In Kind",
        "in_kind_value": "In-kind value",
        "network": "Network",
        "relationship": "Relationship"
      },
      "update_contractor_header": "Update Contractor",
      "view_contractor_with_name": "View Contractor - {{name}}",
      "view_history": "View History"
    },
    "core_data": {
      "confirm_delete_doc": "Are you sure you want to delete this document in core data?",
      "delete_doc_in_core_data": "Delete document in core data",
      "format": "Format",
      "report_name": "Report Name",
      "set_cultural_assets": "Set Cultural Assets and Budgeted Recurrent Expenditure"
    },
    "department_and_units": {
      "add_department": "Add Department",
      "add_unit": "Add Unit",
      "add_unit_to_department": "Add Unit to Department",
      "all_department_goals_are_available_for_this_department": "All department goals are available for this ,department",
      "all_org_goals": "All Organisation Goals",
      "all_org_goals_are_available_for_selection": "All organisation goals are available for selection",
      "all_organisation_goals_are_available_for_this_department": "All organisation goals are available for this department",
      "are_you_sure_you_want_to_remove_this_department_or_unit": "Are you sure you want to remove this {{department_or_unit}}?",
      "categories": "Categories",
      "department": "Department",
      "department_description": "Department Description",
      "department_name": "Department Name",
      "direct": "Direct",
      "edit_department": "Edit Department",
      "edit_dept_labels": "Edit Department Labels",
      "edit_labels": "Edit Labels",
      "edit_unit": "Edit Unit",
      "goals": "Goals",
      "inherited_goals": "Inherited Goal(s)",
      "label_plural": "Label (plural)",
      "label_singular": "Label (singular)",
      "leave_row_blank_to_remove_label": "Leave a row blank to remove that level.",
      "level": "Level",
      "no_admins_assigned": "No admins assigned.",
      "no_departments_or_units_have_been_added": "No departments/unit have been added",
      "please_create_a_department": "Please create a department",
      "remove_admin": "Remove admin",
      "remove_departement_or_unit": "Remove {{department_or_unit}}",
      "select_departments": "Select Departments",
      "select_goals": "Select Goals",
      "some_org_goals_are_available_for_selection": "Some organisation goals are available for selection",
      "specific_goals": "Specific Goals",
      "unit_description": "Unit Description",
      "unit_name": "Unit Name"
    },
    "goals": {
      "browse_help_message": "This document will be a reference for your {{type}} goals",
      "browse_info_message": "Max file size - 50 MB",
      "browse_label": "Upload {{type}} Strategic Plan",
      "create_strategic_document": "Create strategic document",
      "delete_goal_title": "Delete Your Goal",
      "delete_goalconfirm": "Are you sure you want to delete your goal",
      "document_title": "Document Title",
      "document_title_required": "Document title is required",
      "form": {
        "obtain_from": "You can obtain goals from your {{type}}'s strategic documents (max 250 characters)",
        "optional": "(optional)",
        "primary_policy_domain_for_goal": "Primary Policy Domain for Goal",
        "short_description": "A short description about the goal"
      },
      "new_strategic_document": "New strategic document",
      "noGoals": "No {{type}} goals have been added...",
      "noStrategicDocuments": "No strategic documents have been created",
      "organisation_strategic_document": "Organisation Strategic Document",
      "policy_name_description": "{{policyName}} (i.e. {{policyDescription}})",
      "report_year": "Report Year",
      "strategic_plan_title": "Organisation Strategic Document",
      "title": "Organisation Goals"
    },
    "goals_not_created": "Goals are not yet created.",
    "messages": {
      "account_checklist": "Account Checklist for Activity Planning",
      "account_checklist_item_created": "Your Account checklist item has been successfully created!",
      "account_checklist_item_deleted": "Your Account checklist item has been successfully deleted!",
      "account_checklist_item_updated": "Your Account checklist item has been successfully updated!",
      "account_contractor": "Account Contractor",
      "account_contractor_created": "Account contractor has been successfully created!",
      "account_contractor_deleted": "Account contractor has been successfully deleted!",
      "account_contractor_updated": "Account contractor has been successfully updated!",
      "account_core_data": "Account Core Data",
      "account_core_data_updated": "Your Account core-data has been successfully updated!",
      "account_goal": "Account Goal",
      "account_goal_created": "Your Account goal has been successfully created!",
      "account_goal_deleted": "Your Account goal has been successfully deleted!",
      "account_goal_info": "Account Goal Info",
      "account_goal_references": "Account Goal References",
      "account_goal_references_archived": "Your Account goal references have been successfully archived!",
      "account_goal_references_created": "Your Account goal references have been successfully created!",
      "account_goal_references_deleted": "Your Account goal references have been successfully deleted!",
      "account_goal_references_updated": "Your Account goal references have been successfully updated!",
      "account_goal_updated": "Your Account goal has been successfully updated!",
      "account_guest_user": "Account Guest User",
      "account_guest_user_activity_reassigned": "Account guest user activity has been successfully reassigned!",
      "account_info": "Account Info",
      "account_info_updated": "Your Account Info has been successfully updated!",
      "account_partner": "Account Partner",
      "account_partner_created": "Account partner has been successfully created!",
      "account_partner_deleted": "Account partner has been successfully deleted!",
      "account_partner_updated": "Account partner has been successfully updated!",
      "account_strategic_plan_uploaded": "Your Account strategic plan has been successfully uploaded!",
      "account_user": "Account User",
      "account_user_created": "Account user has been successfully created!",
      "account_user_deleted": "Your Account user has been successfully deleted!",
      "account_user_invited_activities_withdrawn": "Your Account user all invited activities has been withdrawn!",
      "account_user_password_reset": "Account user password has been successfully reset!",
      "account_user_type_updated": "Account user type has been successfully updated!",
      "account_venue_created": "Account venue has been successfully created!",
      "account_venue_deleted": "Account venue has been successfully deleted!",
      "account_venue_updated": "Account venue has been successfully updated!",
      "account_venues": "Account Venues",
      "annual_report": "Annual Report",
      "annual_report_plan_uploaded": "Your Annual Report plan has been successfully uploaded!",
      "core_data_document_removed": "The document in Core Data has been successfully removed.",
      "cross_reference_document": "Cross Reference Document",
      "cross_reference_document_created": "Cross reference document has been successfully created!",
      "cross_reference_document_updated": "Cross reference document has been successfully updated!",
      "get_account_checklist_for_activity_reporting": "Get Account Checklist for Activity Reporting",
      "reset_password": "Reset Password",
      "your_password_has_been_successfully_reset": "Your password has been successfully reset!"
    },
    "organization": {
      "checklist": "Checklist",
      "settings": "Settings"
    },
    "page_title": "Organisation | {{appName}}",
    "permissions": {
      "environmental_tester": "Environmental Tester"
    },
    "profile": {
      "leave_modal_content": "You have unsaved changes. Do you want to leave ?",
      "leave_modal_title": "Are you sure you want to leave this page?ss"
    },
    "settings": {
      "archive_goal_references": "Archive Goal References",
      "archived_goal": "Archived Goal",
      "checklist": {
        "add_checklist_item_header": "Add New Checklist Item",
        "add_checklist_item_trigger": "Add Checklist Item",
        "checklist_question": "Checklist Question",
        "confirm_delete": "Are you sure you want to delete this checklist item?",
        "delete_checklist_item": "Delete Checklist Item",
        "edit_checklist_item": "Edit Checklist Item",
        "label": "Checklist",
        "question_required": "question is required"
      },
      "confirm_archive": "Are you sure you want to archive this references?",
      "cross_reference": "Cross-Reference",
      "deleted_goal": "Deleted Goal",
      "departments": "Departments",
      "departments_units": "Departments and Units",
      "end_cross_referencing_confirmation": "Are you sure you no longer want activities to record cross references?",
      "end_cross_referencing_title": "End cross referencing",
      "item": "Item",
      "new_cross_reference_document": {
        "being_built": "This function is currently being built and will be available soon.",
        "create_new": "Create New Cross-Reference Document",
        "in_the_meantime": "In the meantime, please contact Takso support",
        "request_suffix": "to request for your new references to be added to your account.",
        "support_email": "support@takso-outcomes.com"
      },
      "no_checklist_added": "No checklist have been added ...",
      "no_reference_added": "No reference have been added",
      "once_selected_goal_immutable": "Once you selected the goal you can't change it",
      "organisation_settings": {
        "calendar_year": "Calendar Year",
        "calendar_year_range": "January 1 to December 31",
        "cross_reference": "Cross Reference",
        "culture_counts": "Culture Counts",
        "departments_tooltip": "Turn on if you wish to generate reports by department",
        "enter_management_code_label": "Enter management code label",
        "financial_reporting_period": "Financial Reporting Period",
        "financial_year": "Financial Year",
        "financial_year_range": "July 1 to June 30 Following Year",
        "management_code": "Management Code",
        "require_approval": "Require Approval"
      },
      "organization_settings": "Organization Settings",
      "reference_document": "Reference Document",
      "reference_form": {
        "accepted_file_types": "Accepted file types: .pdf, .docx",
        "add_more_references": "Add More References",
        "browse_file": "Browse File",
        "document_title": "Document Title",
        "document_title_required": "Document title is required",
        "max_file_size": "Max file size - 50 MB",
        "reference_field_label": "Reference Field Label",
        "reference_field_label_required": "Reference field label is required",
        "reference_required": "Reference is required",
        "title": "Add Cross-Reference Document",
        "update_cross_reference_document_header": "Update Cross-Reference Document",
        "upload_reference_document": "Upload Reference Document"
      },
      "update_reference_trigger": "Update Reference"
    },
    "tabs": {
      "contacts": "Contacts",
      "profile": "Profile",
      "settings": "Settings",
      "user_management": "User Management",
      "venues": "Venues"
    },
    "unsaved_modal_content": "You have unsaved changes. Do you want to leave ?",
    "unsaved_modal_title": "Are you sure you want to leave this page?",
    "update_details": "Update Organisation Details",
    "user_management": {
      "cdn_admin": "cdn-admin",
      "change_user_type_header": "Change User Type - {{user_name}}",
      "change_user_type_trigger": "Change User Type",
      "delete_user": "Delete User",
      "delete_user_confirmation": "Are you sure you want to delete this user?",
      "delete_user_header": "Delete User - {{user_name}}",
      "department_removed_from_user": "User has been removed from the department",
      "guest_users": "Guest Users",
      "manage_users": "Manage Users",
      "no_guest_users_added": "No guest users have been added...",
      "no_users_added": "No users have been added...",
      "none": "None",
      "on_confirming_removal_the_user_will_be_withdrawn_from_all_invited_activities": "On confirming removal, the user will be withdrawn from all invited activities.",
      "password_change_header": "Reset Password - {{user_name}}",
      "reassign_activities": "Reassign Activities",
      "reassign_activity": {
        "activity_part_of_group": "This activity is part of a group with {{count}} other activities. If you wish to remove this activity from the group and reassign to another user, select Single activity. If you wish to reassign all activities in the group to a new user, select All activities.",
        "all_activities_need_to_be_transferred_before_users_can_be_removed_from_the_account": "All activities need to be transferred before users can be removed from the account.",
        "assign_to_required": "Assign to is Required",
        "reassign_activities": "Reassign Activities",
        "reassign_all_activities": "Reassign All Activities",
        "reassign_an_activity": "Reassign An Activity",
        "select_activities_from_required": "Select Activities from is Required",
        "select_activities_required": "Select Activities is Required",
        "transfer_all": "Transfer all managed activities from one user to another",
        "transfer_individual": "Transfer management of individual activities",
        "user_has_archived_activities": "User has {{completedOwned}} archived activities. Reassign archived activities to selected user?",
        "user_has_owned_activities": "User has {{ownedActivities}} owned activities. Activities for this user must first be reassigned."
      },
      "remove_user_invited_activities": "Remove User Invited Activities - {{user_name}}",
      "select_user_type": "Select an User type",
      "this_user_is_invited_to_in_active_activity": "This user is invited to {{count}} active activity.",
      "this_user_is_invited_to_in_active_and_in_development_activity": "This user is invited to {{count}} active activity and {{count2}} in development activity.",
      "this_user_is_invited_to_in_development_activity": "This user is invited to {{count}} in development activity.",
      "user_type": "User Type",
      "user_type_required": "User type is required",
      "view_guest_users_activities_header": "View Activities of Guest Users: {{user_name}}",
      "view_guest_users_activities_trigger": "{{count}} Activities"
    },
    "venues": {
      "add_new_venue": "Add New Venue",
      "delete_venue_confirm_text": "Are you sure you want to delete this venue?",
      "delete_venue_header": "Delete Venue - {{name}}",
      "manage_venues": "Manage Venues",
      "no_venues_added": "No venues have been added",
      "this_venue_is_owned_by": "This venue is owned by {{org}}",
      "venue_update_header": "Update Venue - {{name}}"
    }
  },
  "other_translation": {
    "copied": "Copied",
    "copy": "Copy",
    "table": {
      "no_records_found": "No records found.."
    }
  },
  "outcomes": {
    "formal": "Formal",
    "formal_title": "Formal title",
    "graded": "Graded",
    "graded_title": "Graded title",
    "graded_version": "Graded version",
    "not_set_click_edit_to_add": "Not set — click Edit to add"
  },
  "output_formats": {
    "enter_formula_here": "Enter Formula here",
    "errors": {
      "not_possible_to_delete_previously_saved": "It is not possible to delete previously saved output formats."
    },
    "format": "Format"
  },
  "permission_type": {
    "collaborator": "Collaborator",
    "custom": "Custom",
    "documentor": "Documentor",
    "report_only": "Report Only"
  },
  "policy": {
    "cultural": "Cultural",
    "economic": "Economic",
    "environment": "Environment",
    "environmental": "Environmental",
    "governance": "Governance",
    "social": "Social"
  },
  "postcode_maps": {
    "boundaries_unavailable": "Boundaries unavailable",
    "click_a_row_to_zoom": "Click a row to zoom · click again to deselect",
    "csv": {
      "external_csv_no_csv_uploaded": "External CSV <span> — no CSV uploaded</span>",
      "no_column_heading": "<strong>{{fileName}}</strong> appears to contain {{postcodes}} with no column heading. Use it for the map?",
      "select_poctcode_column": "<strong>{{fileName}}</strong> has {{columns}} — select the one containing postcodes:",
      "upload_to_enable": "Upload a CSV to the activity's Documents & Media to enable"
    },
    "different_postcodes_fmt": "<strong>{{num}}</strong> different {{postcodes}}",
    "errors": {
      "boundaries_error": "Boundaries error"
    },
    "fit_to_data": "Fit to data",
    "hide_table": "Hide table",
    "loading_boundaries": "Loading boundaries",
    "loading_postcode_data": "Loading postcode data",
    "no_postcode_responses": "No postcode responses recorded for this activity.",
    "no_valid_postcodes_in_csv": "No valid postcodes found in the selected CSV.",
    "num_postcodes_one": "1 postcode",
    "num_postcodes_other": "{{count}} postcodes",
    "num_with_postcode_fmt": "<strong>{{responsesWithPostcode}}</strong> with postcode",
    "outside_map": "outside map",
    "pct_of_total": "{{pct}}% of total",
    "place_labels": "Place labels",
    "postcode_origin": "Postcode origin",
    "postcodes_one": "postcode",
    "postcodes_other": "postcodes",
    "show_table": "Show table"
  },
  "question_generator": {
    "by_outcome_we_mean": "By {{outcome}} we mean sparking of the imagination, creativity or curiosity, resulting in increased desire to participate more and/or create new cultural works.",
    "can_you_tell_us_more_about_why_you_gave_this_rating": "Can you tell us <strong>why</strong> you gave this rating?",
    "description": "This question generator has been created to support practitioners when undertaking evaluation using the Cultural Development Network's Outcome Schema.",
    "download_pdf": "Download as PDF",
    "full_description_html": "<p>This question generator has been created to support practitioners when undertaking evaluation using the Cultural Development Network's Outcome Schema.</p><p>Before you evaluate, you need to be clear <b>what</b> you are wanting to find out about your activity and <b>who</b> you expect to have been impacted by your activity. If you have followed the planning process recommended in CDN's Planning Framework or in Takso you will have established at least two objectives for your activity that your evaluation will need to measure. If not, we recommend you select outcomes from the <a href=\"https://www.culturaldevelopment.net.au/outcomes/\" target=\"_blank\">outcome schema</a> that your activity is intended to achieve. At least one of these should be a cultural outcome, given that your activity is a cultural activity. You might have an outcome or outcomes from other domains, such as social or economic, that you plan for your activity to address. Select one or more of these from the outcome schema before you start. We recommend no more than two outcomes be selected, as each one requires work to collect data and analyse it.</p>",
    "how_did_you_form_the_assessment_to_provide_this_evaluation": "How did you form the assessment to provide this evaluation? <em> (you can choose multiple options)</em>",
    "intended_outcome_was": "The intended outcome was {{outcome}} through their engagement in this activity.",
    "introduction": "Introduction",
    "outcome_description": "Outcome description",
    "pre_evaluation_guidance": "Before you evaluate, you need to be clear <b>what</b> you are wanting to find out about your activity and <b>who</b> you expect to have been impacted by your activity. If you have followed the planning process recommended in CDN's Planning Framework or in Takso you will have established at least two objectives for your activity that your evaluation will need to measure. If not, we recommend you select outcomes from the <a href=\"https://www.culturaldevelopment.net.au/outcomes/\" target=\"_blank\">outcome schema</a> that your activity is intended to achieve. At least one of these should be a cultural outcome, given that your activity is a cultural activity. You might have an outcome or outcomes from other domains, such as social or economic, that you plan for your activity to address. Select one or more of these from the outcome schema before you start. We recommend no more than two outcomes be selected, as each one requires work to collect data and analyse it.",
    "quantitative_data_html": "<p>The intended outcome was {{outcome}} through engagement in this activity.</p><h4>How did you form the assessment for this evaluation? <em>(choose one or more options)</em></h4>",
    "question_for_qualitative_data": "Question for qualitative data",
    "question_for_quantitative_data": "Question(s) for quantitative data",
    "reason_for_this_evaluation_method": "Reason for this evaluation method <em>(you can only choose one option)</em>",
    "select_method": "Select the method you will use to perform your evaluation.",
    "select_objective": "Select the objective you want to measure",
    "select_policy_domain": "Select a policy domain that your activity belongs to.",
    "title": "QUESTION GENERATOR"
  },
  "report": {
    "activityParticipants": {
      "activityParticipants": "Activity Participants"
    },
    "activityVenues": {
      "activityVenues": "Activity Venues"
    },
    "activity_count": "Activity count",
    "activity_count_with_count": "Activity count: {{count}}",
    "activity_evaluations": "Activity Evaluations",
    "activity_name": "Activity name",
    "actual_outcomes": "Actual Outcomes",
    "after_average": "After Average",
    "after_rating": "After Rating",
    "after_response": "After Response",
    "after_responses": "After Responses",
    "average": "Average",
    "back_to_outcomes_addressed": "Back to Outcomes Addressed",
    "before_average": "Before Average",
    "before_rating": "Before Rating",
    "before_response": "Before Response",
    "before_responses": "Before Responses",
    "builder": {
      "activity_date_range": "Activity date range",
      "activity_did_not_proceed_no_funding": "Activity did not proceed. Funding not committed.",
      "activity_mix": "Activity mix",
      "activity_not_found": "Activity not found.",
      "activity_types": {
        "account_holder": "Account holder",
        "guest": "Guest",
        "linked_singles": "Linked singles",
        "programs": "Programs",
        "singles": "Singles",
        "singles_only": "Singles only"
      },
      "add_custom_section": "Add custom section",
      "add_custom_section_optional": "Add custom section (optional)",
      "add_images_optional": "Add images (optional)",
      "add_images_or_graphics": "Add images/graphics",
      "add_more_images": "Add more images",
      "add_text": "Add text",
      "additional_assets": "Additional assets such as footer imagery, watermarks, or section divider graphics. Details to be confirmed.",
      "additional_text": "Additional text",
      "appendix_contractors": "Appendix: Contractors",
      "brand_colors_and_banner": "Brand colours & banner",
      "breakdown_of_linked_activity_types": "Breakdown of linked activity types by infrastructure, developmental, and presentational",
      "charts": "Charts",
      "click_to_edit_heading": "Click to edit heading",
      "color_picker_in_next_phase": "Colour picker coming in next phase.",
      "completed_activity_mix": "Programs / Linked singles / Singles only",
      "completed_ownership_breakdown": "Programs / Account holder singles / Guest singles / Singles only",
      "completed_programs_vs_singles": "Programs vs Singles",
      "connections": "Connections",
      "contractors": {
        "occupation_category": "Occupation category",
        "service_type": "Service type"
      },
      "contractors_by_occupation": "Contractors by occupation",
      "cover_image": "Cover image",
      "cover_image_editing": {
        "add_cover_image": "Add cover image",
        "change_cover_image": "Change cover image",
        "change_image": "Change image",
        "reposition": "Reposition",
        "reposition_or_zoom": "Reposition or zoom cover image"
      },
      "cover_image_selected_from": "The cover image will be selected from the organisation's <strong>Documents & Media</strong> section on the Documentation page.",
      "enable_show_in_report": "Enable 'Show in report' for this chart in the Charts tab.",
      "evaluation_report": "Evaluation Report",
      "executive_summary": {
        "author_comment": "Begin with a single statement about what this program exists to do — not what it did, but why it matters. The data shows {{numEventsFmt}} community-led {{events}} across {{grantRounds}}, reaching an estimated {{totalReach}} and supported by {{volunteers}} volunteers. That is the scale, but the statement that frames it should be about community self-expression and cultural life, not just numbers.",
        "grant_dollars": "Grant ($)",
        "title": "Executive Summary",
        "writer_note": "The reach figure ({{totalReach}}) may be influenced by a small number of very large events. Decide in your opening whether you lead with the headline number or contextualise it. Both are defensible; the choice shapes how the reader understands the program's character."
      },
      "funded_events": "Funded events",
      "funded_programs_summary": "Funded programs summary",
      "grant_programs": "Grant programs",
      "grant_rounds_one": "1 grant round",
      "grant_rounds_other": "{{countFmt}} grant rounds",
      "grant_rounds_zero": "no grant rounds",
      "highest_gain_across_outcomes": "The highest gain was {{outcomeName}} (+{{points}}), from {{avgPre}} to {{avgPost}}), measured across {{events}}. Open your outcomes narrative with this result.",
      "highest_gain_outcome": "Open your outcomes narrative with the highest-gain outcome.",
      "how_often_each_outcome_measure_is_used": "How often each outcome measure is used across linked activities",
      "how_outcome_measures_co_occur": "How outcome measures co-occur across activities — connected nodes share activities, isolated nodes (top-right) appear alone. Click two nodes to reveal their connection.",
      "image_picker_in_next_phase": "Image picker coming in next phase.",
      "infographic_coming_soon": "Infographic coming soon",
      "inputs": {
        "author_comment": "Describe what the investment level enabled across the community and how it has grown over the program rounds. Note that the {{volunteerCount}} volunteer count represents community labour contributed beyond the grant. Consider calculating an approximate dollar value to show the broader community investment.",
        "events": "Events",
        "grant_awarded": "Grant awarded",
        "investment_by_type": "Investment by type (grant, in-kind, volunteer)",
        "investment_chart_available_in_future": "Investment chart — available in a future update.",
        "program": "Program",
        "venue_breakdown_chart_available_in_future": "Venue breakdown chart — available in a future update.",
        "volunteers": "Volunteers"
      },
      "insert_section_heading": "Insert section heading",
      "intended_impact": {
        "activity_type_breakdown": "Activity type breakdown",
        "activity_type_breakdown_chart_title": "Activity type breakdown: Infrastructure / Developmental / Presentational",
        "author_comment": {
          "describe_actitivy_types": "Describe each activity type and what it achieves.",
          "multiple_output_types_one": "Across the funded activity:",
          "multiple_output_types_other": "Across the {{countFmt}} funded activities:",
          "no_output_types": "Describe the types of activity funded by this program and how they deliver the intended impact.",
          "one_output_type_one": "The funded activity was {{outputType}} in type. Describe what this means in practice and how this activity type delivers the program's intended outcomes.",
          "one_output_type_other": "All {{countFmt}} funded activities were {{outputType}} in type. Describe what this means in practice and how this activity type delivers the program's intended outcomes."
        },
        "author_comment_theory_of_change": "Describe the theory of change running through the grantees' own words. Name the model explicitly rather than describing it event by event. Also consider the distinction between receptive participation (attending as audience) and active participation (making, performing, competing).",
        "title": "Intended Impact"
      },
      "intended_outcomes": {
        "author_comment": "The outcomes used in this program should align directly with your organisation's stated goals. Explain that the program design created this coherence, not just the grantees' choices.",
        "charts": {
          "number_of_funded_activities": "Number of funded activities for each outcome measure"
        },
        "outcome_surveys_conducted": "Outcome surveys conducted",
        "section_title": "Intended outcomes that address the goal",
        "writer_note": {
          "considerations_one": "Grantees in this program consistently chose <em>{{outcome1}}</em> as their primary outcome. Consider naming this focus as a deliberate program design feature.",
          "considerations_other": "The most selected outcomes were <em>{{outcome1}}</em> and <em>{{outcome2}}</em>. Consider whether your report names this pairing as a deliberate program design feature.",
          "think_about_how_the_program_maps": "Think about how the program maps to any cultural strategy or wellbeing framework. Are there cross-department outcomes here that deserve naming?"
        }
      },
      "investment": "Investment (Completed activities only)",
      "investment_and_resourcing_by_program": "Investment and resourcing by program",
      "linked_activities_one": "<strong>{{count}}</strong> linked activity",
      "linked_activities_other": "<strong>{{count}}</strong> linked activities",
      "linked_activities_zero": "<strong>0</strong> linked activities",
      "linked_cnt_one": "{{count}} Linked",
      "linked_cnt_other": "{{count}} Linked",
      "linked_cnt_zero": "No Linked",
      "loading_activities": "Loading activities",
      "loading_activity": "Loading activity",
      "logo_help": "The logo stored here will appear in report headers and Word / PDF exports. Stored at organisation level — one logo per org.",
      "manager_assessed_writer_note": "The evaluation methodology used here is manager self-assessment using Takso's modelled pre/post distribution, not a participant survey. Your report must name this clearly.",
      "measure_for_effect": "Measure for effect",
      "measures_for_change": "Measures for change",
      "no_activities_match_current_filters": "No activities match the current filters.",
      "no_analysis_run_yet": "No analysis run yet",
      "no_evaluation_plans": "No evaluation plans for this activity.",
      "no_linked_activities_found": "No linked activities found.",
      "no_reflection_recorded": "No reflection recorded.",
      "num_events_one": "{{countFmt}} event",
      "num_events_other": "{{countFmt}} events",
      "num_events_zero": "{{countFmt}} events",
      "num_linked_activities_one": "<strong> {{countFmt}} </strong> linked activity",
      "num_linked_activities_other": "<strong> {{countFmt}} </strong> linked activities",
      "num_linked_activities_zero": "<strong> {{countFmt}} </strong> linked activities",
      "num_linked_one": "1 Linked",
      "num_linked_other": "{{countFmt}} Linked",
      "num_linked_zero": "None Linked",
      "num_outcomes_one": "{{count}} outcome",
      "num_outcomes_other": "{{count}} outcomes",
      "num_outcomes_zero": "{{count}} outcomes",
      "num_participants_one": "1 Participant",
      "num_participants_other": "{{countFmt}} Participants",
      "num_participants_zero": "No Participants",
      "num_points_one": "{{count}} point",
      "num_points_other": "{{count}} points",
      "num_points_zero": "0 points",
      "num_programs_fmt_one": "<strong>{{count}}</strong> program",
      "num_programs_fmt_other": "<strong>{{count}}</strong> programs",
      "num_programs_fmt_zero": "<strong>{{count}}</strong> programs",
      "num_programs_one": "{{countFmt}} program",
      "num_programs_other": "{{countFmt}} programs",
      "num_programs_ul_one": "{{countFmt}} Program",
      "num_programs_ul_other": "{{countFmt}} Programs",
      "num_programs_ul_zero": "{{countFmt}} Programs",
      "num_programs_zero": "{{countFmt}} programs",
      "org_logo": "Organisation logo",
      "organisation_goals_one": "Organisation goal",
      "organisation_goals_other": "Organisation goals",
      "other_graphics": "Other graphics",
      "oucome_rating_distributions": "Outcome rating distributions",
      "outcome_change_descrip": "Change = average rating after minus average rating before. Scores are manager estimates using Takso's modelled distribution, not participant surveys.",
      "outcome_ladder_description": "The outcome ladder shows which outcomes were most frequently targeted across funded activities. Use this chart to show the breadth of community outcomes addressed. An activity can contribute more than one evaluation for an outcome when separate evaluations are run for different participant groups.",
      "outcome_relationship": {
        "description_one": "1 activity addresses both outcome measures in the current dataset.",
        "description_other": "{{count}} activities address both outcome measures in the current dataset.",
        "description_zero": "No co-occurrence data available for this pair.",
        "outcome_a": "Outcome A",
        "outcome_b": "Outcome B",
        "placeholder_section": {
          "activity_breakdown": "Activity breakdown — activities addressing both outcomes",
          "comparison_and_trend": "Comparison and trend - differences between the outcome results",
          "evaluation_rating_comparison": "Evaluation rating comparison — how participants rated each outcome",
          "timeline": "Timeline — when these outcomes are typically addressed together"
        },
        "subtitle": "Analysis of outcome relationship",
        "title": "Takso · Outcome Analysis"
      },
      "outcomes": {
        "change": "Change",
        "outcome_evaluation_results_manager_assessed": "Outcome evaluation results: manager self-assessment (pre to post, 1–10 scale)",
        "outcome_evalution_results": "Outcome evaluation results",
        "rating_after": "Rating after",
        "rating_before": "Rating before"
      },
      "outcomes_measured": "Outcomes measured",
      "outcomes_measured_across_events": "The data shows {{outcomes}} measured across {{events}}.",
      "page_1": "Page 1",
      "participant_origin_postcode_map": "Participant origin — postcode map",
      "participant_rating_dist_charts_for_future": "Participant rating distribution charts — available in a future update.",
      "participant_types": "Participant types",
      "participants": {
        "author_comments": "The total reach figure of {{value}} across {{events}} is significant. Your report should clearly explain the ratio of receptive (audience) to active (performers, competitors, workshop participants) participation, and note how attendance was measured — estimated or counted.",
        "event": "Event",
        "largest_events_by_participant_reach": "Largest events by participant reach",
        "outputs_participation": "Outputs: Participation",
        "participant_type_chart_available_later": "Participant type chart — available in a future update.",
        "participant_type_ladder": "Participant Type Ladder: Receptive vs Active breakdown",
        "participation_by_program": "Participation by program",
        "receptive_percentage": "Receptive %",
        "total_reach": "Total reach"
      },
      "participants_by_activity_type": "Participants by activity type",
      "people_one": "1 person",
      "people_other": "{{countFmt}} people",
      "people_zero": "no people",
      "photo_crop": {
        "drag_hints": "Drag to resize the cropped image",
        "drag_to_crop_the_bottom": "Drag to crop the bottom",
        "drag_to_crop_the_left": "Drag to crop the left",
        "drag_to_crop_the_right": "Drag to crop the right",
        "drag_to_crop_the_top": "Drag to crop the top",
        "drag_to_resize_crop_line": "Drag to resize the crop line",
        "hints": "Drag the photo to move the cropped image as a whole; the round handle resizes it. The dashed crop line's edge handles trim one side at a time; its square corner handles resize it proportionally — both change what's cropped without moving/resizing the result."
      },
      "position_cover_image": "Position cover image",
      "preferences": {
        "activity_settings": "activity setting",
        "appendices": "Appendices",
        "banner_and_spot_colour_label": "Banner and spot colour",
        "banner_colour_applied": "Applied to table column headings and accent elements throughout the report. When off, headings use a plain white background.",
        "body_font_size": "Body font size",
        "body_font_size_hint": "Applies to body text throughout",
        "chart_title_style": "Chart title style",
        "chart_title_style_hint": "Word heading style applied to chart titles",
        "charts": "These preferences affect how charts are presented for this organisation. Whether a chart is included in an exported report is set per-chart using the <strong>Include in report</strong> toggle on the chart itself.",
        "colour": "Colour",
        "colours": "Colours",
        "conclusions": "Conclusions",
        "conclusions_hint": "Findings, reflection, next steps",
        "corporate_statement": "Corporate statement",
        "corporate_statement_disabled_hint": "No corporate statement — add one in Organisation › Settings",
        "corporate_statement_hint": "Insert the corporate public statement as page 2",
        "cover_image_background_colour": "Cover image background colour",
        "cover_page": "Cover page",
        "cover_page_hint": "Title page with report header, activity name and org name",
        "cover_photo": {
          "default_description": "Default is dark grey (#1f2937). Choose \"No colour\" to leave the letterbox transparent."
        },
        "document": "Document",
        "end_signature": "End signature",
        "end_signature_disabled_hint": "No end signature — upload one in Organisation › Settings › Reports",
        "end_signature_hint": "Show the organisation end-signature graphic at the bottom of the report",
        "evaluation_hint": "Fast facts, methodology, outcome findings",
        "evidence_ref_table": "Evidence reference table",
        "executive_summary": "Executive summary",
        "executive_summary_hint": "Background, findings summary",
        "font_family": "Font family",
        "footer_text": "Footer text",
        "glossary": "Glossary",
        "graded_outcome_measures": {
          "heading": "Graded outcome measures",
          "is_activity_own_setting": "This is this activity's own setting — it won't change automatically if the organisation default (currently {{onOrOff}}) is changed later.",
          "select_activity": "Select an activity to set this for a specific report. Shows an accessible plain-language version of each outcome measure instead of the full formal definition.",
          "show_accessible_version": "Show an accessible plain-language version of each outcome measure in the report template instead of the full formal definition."
        },
        "header_and_footer": "Header &amp; footer",
        "include_footer": "Include footer",
        "include_footer_hint": "Appears at the bottom of every page",
        "include_header": "Include header",
        "include_header_hint": "Appears at the top of every page after the cover",
        "intended_impact": "Intended impact",
        "intended_impact_hint": "Objectives, theory of change, evidence",
        "left_header_text": "Left header text",
        "letterbox_colour_behind_cover_photo": "The letterbox colour behind the cover photo, shows in any gap where the image doesn't fully fill the frame, and while the image is loading.",
        "no_colour": "no colour",
        "no_colour_set_pick_one": "No colour set — pick one",
        "org_default": "org default",
        "org_name_hint": "Leave blank to use the name from the database",
        "org_settings_hint": "Customise report and chart options for {{org}}. Toggles showing <strong>custom</strong> override the platform default. Use <em>reset</em> to revert any field.",
        "pick_colour": "Pick colour",
        "remove_background_colour_overlay": "Remove background colour overlay",
        "report_header": "Report header",
        "report_header_hint": "Heading shown at the top of the cover page — e.g. the report title or series name",
        "report_sections": "Report sections",
        "reset_to_white": "Reset to white",
        "revert_to_platform_default": "Revert to platform default",
        "select_banner_and_spot_colour": "Select the banner and spot colour for this organisation's reports. Default is white.",
        "show_page_numbers": "Show page numbers",
        "strategic_alignment": "Strategic alignment",
        "strategic_alignment_hint": "Organisational goal, cross-references",
        "survey_responses_appendix": "Survey responses appendix",
        "survey_responses_appendix_hint": "Appendix 2 — respondent comments, grouped by session. Off: a note that comments are available, if any were recorded.",
        "survey_stats_line": "Report view: survey stats line",
        "survey_stats_line_hint": "Show \"N surveys with N responses from N participants (N%)\" instead of the default \"evaluation plans · participants · responses\"",
        "table_of_contents": "Table of contents",
        "use_org_default": "Use the organisation default instead"
      },
      "prepared": "Prepared",
      "prepared_using_takso": "Prepared using Takso",
      "preview": {
        "activity_evaluated_against": "This activity was evaluated against {{outcomes}}",
        "activity_record_type": {
          "program": "Program",
          "single_independent": "Single – Independent",
          "single_linked": "Single – Linked"
        },
        "appendix": "Appendix",
        "background_table": {
          "column_headings": {
            "team": "Team",
            "title": "Title",
            "type": "Type",
            "when": "When",
            "where": "Where"
          }
        },
        "chart_not_captured": "Chart not captured — use the Charts tab to include this chart in the report.",
        "conclusion": "Conclusion",
        "conclusions": "Conclusions",
        "conclusions_and_actions": {
          "draw_out_one_or_two_findings": "Draw out the one or two findings that best answer \"so what changed?\" — link them back to the outcomes this activity was evaluated against, rather than restating the evaluation charts below.",
          "title": "Conclusions and Actions"
        },
        "contents_page_hint": "The Contents page in the downloaded file links to each heading. Word will update page numbers when you first open the document (right-click Contents → Update Field).",
        "cross_reference": "Cross-reference",
        "edits_here_update_the_activity_record": "Edits here update the Takso activity record",
        "evaluation_plans": {
          "placeholder": "Evaluation plan sections will appear here once the activity data is loaded. Each plan in the Takso record generates one section, using the plan name as the heading."
        },
        "evidence": {
          "no_items": "No evidence items recorded for this activity"
        },
        "evidence_based_insight": "evidence-based insight",
        "executive_summary": {
          "background": "Background"
        },
        "export": {
          "downlaod_report_docx": "Download Report (.docx)",
          "word_export_coming_soon": "Word export coming in next phase"
        },
        "fast_facts": "Fast facts",
        "figure": "Figure",
        "findings": "Findings",
        "glossary": "Glossary",
        "glossary_to_be_completed": "Glossary — to be completed",
        "in_the_words_of_participants": "In the words of participants",
        "inputs_and_outputs": "Inputs and Outputs",
        "intended_domain_outcome": "Intended {{domain}} outcome: {{outcome}}",
        "intended_impact": {
          "intended_domain_outcome": "Intended {{domain}}outcome: {{outcome}}",
          "intended_impact_title": "Intended Impact and Reasoning"
        },
        "intended_impact_and_reasoning": "Intended Impact and Reasoning",
        "manager_types": {
          "guest": "Guest",
          "staff": "Staff"
        },
        "measure": "Measure",
        "measures": "Measures",
        "methodology": "Methodology",
        "next_steps": "Next steps",
        "no_comment_for_this_measure": "no comment for this measure",
        "no_fast_facts_available": "No fast facts data available for this activity",
        "no_goal_description_recorded": "No goal description recorded",
        "no_objectives_recorded": "No objectives recorded for this activity",
        "no_org_goal_recorded": "No organisational goal recorded",
        "no_outcome_linked": "no outcome linked",
        "no_participant_quotes": "No participant quotes shortlisted. Go to the Evaluation tab in the activity and shortlist quotes from the evaluation responses.",
        "no_text_entered": "No text entered in the activity record — click to add.",
        "org_goal": "Organisational goal",
        "our_evidence_for_this_theiry_includes": "Our evidence for this theory includes (see attachment for details):",
        "outcome_measure": "outcome measure",
        "page_break": "page break",
        "participant_quote_shortlist_one": "{{participantQuotes}} has been shortlisted for this section.",
        "participant_quote_shortlist_other": "{{participantQuotes}} have been shortlisted for this section.",
        "participant_quotes_one": "{{count}} participant quote",
        "participant_quotes_other": "{{count}} participant quotes",
        "planned_approach": "planned approach",
        "please_complete_your_reflection": "Documentation: Please complete your reflection of this activity",
        "please_enter_final_activity_description": "Documentation: Please enter the final activity description",
        "ratings_from_1_to_10": "Ratings from 1 to 10, where 1 is \"Not at all\" and 10 is \"The most\".",
        "reflection": "Reflection",
        "result": "Result",
        "select_participant_quote": "Select participant quote for this outcome",
        "select_participant_quotes": "Select participant quotes",
        "select_participant_quotes_for_findings": "Select participant quotes for Findings",
        "show_non_editable_text": "Show non-editable text",
        "slides_tab": {
          "description": "Slide layout lives in your own .pptx template, built in PowerPoint — not here. Name a shape with one of the fields below and it gets populated automatically at export time. Any name not used in a given template is simply skipped, so one template can be entirely different from another without touching any code.",
          "description2": "<strong>Chart field names</strong> are shown directly on each chart in the <strong>Charts</strong> tab now (the small \"pptx\" badge above each chart, click to copy) — that's the live chart the name actually refers to, so it's not duplicated here.",
          "export_to_pptx": "Export to .pptx",
          "not_built_yet": "Not built yet. Next steps: an org-level template upload (mirroring the existing Word template stub in Organisation Settings), the aggregate-stats endpoint, and the capture-and-populate export pipeline itself.",
          "planned_pending_report_builder_aggregate_stats": "Planned, pending the Report Builder aggregate-stats endpoint — not live yet.",
          "powerpoint_export": "PowerPoint export",
          "report_context_text_fields": "Report context — text fields",
          "stats_text_fields": "Stats — text fields"
        },
        "state_plainly_activity_achievments": "State plainly whether the activity achieved what it set out to do, and where the evidence is strongest or weakest.",
        "survey_responses": "Survey responses",
        "survey_responses_appendix_hint": "Respondent comments are available for this appendix — enable \"Survey responses appendix\" in Preferences to include them.",
        "text_available": "Text available in activity record.",
        "theory_of_change_not_yet_recorded": "Theory of change not yet recorded for this objective",
        "therefore_we_will": "Therefore, we will",
        "this_activity_ran_on_dates": "This activity ran {{dates}}{{deliveredBy}}.",
        "this_activity_ran_on_dates_consider_naming": "Consider naming the specific community need or opportunity that prompted it — the Background table above captures the logistics, but not the motivation.",
        "we_know_that": "We know that"
      },
      "preview_report": "Preview Report",
      "primary_brand_colors": "Primary and secondary brand colours applied to section heading backgrounds, dividers, and banner areas in exports.",
      "program_cnt_one": "{{count}} Program",
      "program_cnt_other": "{{count}} Programs",
      "program_cnt_zero": "No Programs",
      "receptive": "Receptive",
      "receptive_vs_active": "Receptive vs Active",
      "remove_cover_image": "Remove cover image",
      "remove_custom_section": "Remove custom section",
      "report_graphics_and_branding": "Report graphics & branding",
      "report_preview": "Report preview",
      "report_types": {
        "mixed_report": "Mixed report",
        "multi_program_report": "Multi-program report",
        "multi_single_report": "Multi-single report",
        "program_report": "Program report",
        "single_activity_report": "Single activity report"
      },
      "select_activity_to_view_postcode_map": "Select an activity to view its postcode map.",
      "select_org_to_manage_report_graphics": "Select an organisation to manage its report graphics.",
      "select_org_to_view_activities": "Select an organisation above to view its activities.",
      "selected_cnt_one": "{{count}} Selected",
      "selected_cnt_other": "{{count}} Selected",
      "selected_cnt_zero": "None Selected",
      "selection": "Selection",
      "single_cnt_one": "{{count}} Single",
      "single_cnt_other": "{{count}} Singles",
      "single_cnt_zero": "No Singles",
      "strategic_alignment": "Strategic Alignment",
      "summary": "Summary",
      "surveys_condicted": "Surveys conducted",
      "tab_labels": {
        "charts": "Charts",
        "graphics": "Graphics",
        "preferences": "Preferences",
        "report": "Report"
      },
      "table_of_contents": {
        "appendix_funded_activities": "Appendix: Funded Activities",
        "evaluation": "Evaluation",
        "executive_summary": "Executive Summary",
        "intended_impact": "Intended Impact",
        "strategic_alignment": "Strategic Alignment"
      },
      "table_of_contents_label_short": "Contents",
      "title": "Report Builder",
      "total_activities": "Total activities: {{value}}",
      "total_activities_loading": "Total activities: …",
      "total_grant": "total grant",
      "total_reach": "total reach",
      "total_width_all_activities_description": "Total width represents all activities {{orgNameOrAllOrgs}}",
      "total_width_completed_activities_description": "Total width represents completed activities {{orgNameOrAllOrgs}}",
      "untitled_section": "Untitled section",
      "upload_in_next_phase": "Upload coming in next phase.",
      "volunteers_one": "1 volunteer",
      "volunteers_other": "{{countFmt}} volunteers",
      "volunteers_zero": "no volunteers"
    },
    "charts_will_be_available_in_future_update": "Charts will be available in a future update.",
    "count": "Count",
    "date_period": "Date Period",
    "evalplan": "EvalPlan",
    "evaluation_plan_count": "Evaluation plan count",
    "evaluation_plan_count_with_count": "Evaluation plan count: {{count}}",
    "evaluation_plan_name": "Evaluation Plan name",
    "evaluations_using_self_assessment_and_intercept_methods_cannot_be_aggregated_with_other_methods": "Evaluations using self assessment and intercept methods cannot be aggregated with other methods. To view self assessed or intercept results, select from the method field above.",
    "exit_report_view": "Exit report view",
    "from_date_to_date": "{{startDate}} to {{endDate}}",
    "include_graph_in_report": "Include Graph in Report",
    "include_in_report": "Include in report",
    "inputs": "Inputs",
    "linked_activity_count": "Linked Activity Count",
    "management_summary": {
      "all_departments": "All departments",
      "all_managers": "All managers",
      "ascending": "Ascending",
      "az": "A–Z",
      "completed": "Completed",
      "contact": "Contact",
      "custom_selection": "Custom (Advanced filter)",
      "descending": "Descending",
      "green_light_on": "Green light {{date}}",
      "guest": "Guest",
      "least_developed": "Least developed",
      "managed_by": "Managed by",
      "newest": "Newest",
      "no_activities": "No activities",
      "no_dates": "No dates",
      "oldest": "Oldest",
      "status_result": "Status/Result",
      "strategic_plan_document": "Strategic Plan Document",
      "summary_management_overview": "Summary Management Overview",
      "total": "Total",
      "total_activities": "Total Activities",
      "za": "Z–A"
    },
    "message_banner": {
      "evaluations_using_mgr_assessment_and_intercept_methods_cannot_be_aggregated_with_other_methods": "Evaluations using manager assessment and intercept methods cannot be aggregated with other methods. To view manager-assessed or intercept results, select from the method field above.",
      "evaluations_using_self_assessment_and_intercept_methods_cannot_be_aggregated_with_other_methods": "Evaluations using self assessment and intercept methods cannot be aggregated with other methods. To view self assessed or intercept results, select from the method field above.",
      "in_development_and_active_figures_reflect_status_on_final_day_of_the_search_period": "In development and Active figures reflect status on final day of the search period. Completed figure reflects activities completed in this period.  See help page for more information.",
      "mgr_assessed_evaluation_is_provided_by_a_single_person": "Manager-assessed evaluation is provided by a single person, usually the activity manager. The assessment is distributed by a standard deviation to spread the single rating into the bell curve.",
      "self_assessed_evaluation_is_provided_by_a_single_person": "Self-assessed evaluation is provided by a single person, usually the activity manager. The assessment is distributed by a standard deviation to spread the single rating into the bell curve."
    },
    "no_data_available": "No Data Available",
    "no_data_in_that_method": "No data in that method.",
    "no_inputs_found": "No Inputs found...",
    "no_outcome_selected": "No outcome selected",
    "no_outputs_found": "No Outputs found...",
    "no_response": "No response",
    "no_responses": "No responses",
    "num_responses_one": "response",
    "num_responses_other": "responses",
    "organizationActivitySummary": {
      "activityOverview": "Activity Overview",
      "banner": "In development and Active figures reflect status on final day of the search period. Completed figure reflects activities completed in this period.  See help page for more information.",
      "organisationType": "Organisation Type",
      "totalActivities": "Total Activities"
    },
    "outcome_measure": "Outcome Measure",
    "outcome_overview": "Outcome Overview",
    "outcome_rating_distrib": {
      "errors": {
        "error_loading_ratings": "Error loading ratings"
      },
      "no_completed_eval": "No completed evaluation responses for this outcome yet.",
      "rating_1_to_10": "Rating (1–10)"
    },
    "outcomes_addressed": "Outcomes Addressed",
    "outcomes_reported": "Outcomes Reported",
    "outcomes_reported_with_title": "Outcomes Reported: {{title}}",
    "outputs": "Outputs",
    "participants": "Participants",
    "please_select_an_outcome_type": "Please select an outcome type.",
    "post_pre_survey_evaluation": "Post-Pre Survey Evaluation",
    "post_result": "Post result",
    "pre_post": "Pre-Post",
    "pre_result": "Pre result",
    "program_activity_count": "Program Activity Count",
    "programmeActivity": {
      "activityParticipants": "Activity Participants",
      "noDataFound": "No data found.",
      "organisationType": "Organisation Type",
      "totalActivities": "Total Activities"
    },
    "reportSelector": {
      "blankPreview": "Your report will be previewed here",
      "dateRange": "Date Range",
      "previewReport": "Preview Report"
    },
    "report_view": "Report view",
    "respondent_percentage": "Respondent Percentage",
    "respondents": "Respondents",
    "response": "Response",
    "responses": "Responses",
    "responses_plural_one": "response",
    "responses_plural_other": "responses",
    "results_are_generated_from_activities_funded_by": "Results are generated from activities funded by {{programTitle}}",
    "select_an_outcome": "Select an outcome",
    "select_options_are_required": "Select options are required",
    "self_assessed_evaluation_is_provided_by_a_single_person": "Self-assessed evaluation is provided by a single person, usually the activity manager. The assessment is distributed by a standard deviation to spread the single rating into the bell curve.",
    "settings": {
      "corporate_public_statement": {
        "description": "Add an Acknowledgement of Country, reconciliation statement, or other corporate public statement. This appears before the Contents page in all report exports for your organisation.",
        "failed_to_save": "Failed to save corporate statement.",
        "placeholder": "e.g. [Organisation name] acknowledges the Traditional Owners of the land on which we work...",
        "saved": "Corporate statement saved.",
        "section_heading": "Section heading — e.g. Acknowledgement of Country",
        "title": "Corporate public statement"
      },
      "end_signature": {
        "failed_to_remove": "Failed to remove signature image.",
        "failed_to_upload": "Failed to upload signature image.",
        "label": "End signature",
        "removed": "End signature removed.",
        "saved": "End signature saved."
      },
      "graded_outcome_measures": {
        "description": "Show the plain-language graded version of outcome measures in reports by default, instead of the full formal outcome definition. Sets the starting state of the checkbox in Report Builder Preferences — staff can still switch it per report. Beta feature.",
        "failed_to_save": "Failed to save graded outcome measures settings.",
        "label": "Graded outcome measures",
        "saved": "Graded outcome measures setting saved."
      },
      "save_report_settings": "Save report settings",
      "save_statement": "Save statement",
      "takso_assisted_analysis": {
        "description": "Allow machine-reading draft narratives in report sections. Requires assisted descriptions to be on.",
        "title": "Takso assisted analysis"
      },
      "takso_assisted_descriptions": {
        "charts": {
          "description": "Show editable chart description areas below data visualisations.",
          "label": "Chart descriptions (grey blocks)"
        },
        "description": "Show writing prompts and guidance text in activity records and report previews. Off by default — staff write from the data directly.",
        "label": "Takso assisted descriptions",
        "show_in_reports": "Show in reports",
        "writing_prompts": {
          "description": "Show pre-filled example text in writing areas to guide narrative style.",
          "label": "Suggested writing prompts (plain text)"
        }
      },
      "template": {
        "current": "Current template",
        "title": "Organisation Word template (.dotx)",
        "upload": "Upload template",
        "upload_description": "Upload a .dotx file to apply your style guide to all Word exports. Template upload coming soon."
      },
      "title": "Report Settings",
      "upload_end_signature_description": "Upload a graphic containing your organisation name and contact details. This appears as a fixed end-signature at the bottom of every report for your organisation. Accepts PNG, JPG, or GIF (max 2 MB).",
      "upload_signature_image": "Upload signature image"
    },
    "summary": {
      "activities_summary": "Activities Summary",
      "strategic_plan_document": "Strategic Plan Document"
    },
    "survey_responses": "Survey responses",
    "total_activity_participants": "Total Activity participants",
    "total_participants": "Total Participants",
    "total_participants_assessed": "Total Participants Assessed",
    "total_respondents": "Total Respondents",
    "total_responses": "Total Responses"
  },
  "reports": {
    "remove_this_chart": "Remove this chart"
  },
  "right_header_text": "Right header text",
  "role": {
    "guest": "Guest",
    "organisation_admin": "Organisation Admin",
    "super_admin": "Super Admin",
    "user": "User"
  },
  "routing": {
    "account": "Account",
    "accounts_users": "Accounts & Users",
    "activities": "Activities",
    "activity": "Activity",
    "activity_participants": "Activity Participants",
    "activity_preview": "Activity Preview",
    "activity_settings": "Activity Settings",
    "dashboard": "Dashboard",
    "library": "Library",
    "logs": "Logs",
    "organisation": "Organisation",
    "reports": "Reports",
    "system_features": "System Features",
    "system_logs": "System Logs",
    "system_reports": "System Reports",
    "system_settings": "System Settings",
    "takso_outcomes_planning_platform_help": "TAKSO OUTCOMES PLANNING PLATFORM – HELP",
    "user_profile": "User Profile"
  },
  "search": {
    "all_sectors": "All sectors",
    "clear_filters": "Clear filters",
    "no_results_found": "No results found",
    "record_type": "Record Type",
    "search_by_name_or_email": "Search by name or email",
    "sector": "Sector"
  },
  "sidebar": {
    "activity_notes": "Activity Notes",
    "advanced_filter": {
      "activeParticipants": "Active Participants",
      "activityStatus": "Activity Status",
      "crossReference": "Cross Reference",
      "departmentUnit": "Department Unit",
      "designation": "Designation",
      "filterBy": "Filter By:",
      "groupByStatus": "Group by status",
      "noMethodsFound": "No Methods Found",
      "noOutcomeFound": "No Outcome Found",
      "noParticipantsFound": "No Participants Found",
      "noVenueFound": "No Venue Found",
      "receptiveParticipants": "Receptive Participants",
      "record": "Record",
      "usedData": "Used Data"
    },
    "constants": {
      "activeParticipants": {
        "free": "Free",
        "paid": "Paid",
        "paying": "Paying"
      },
      "activityType": {
        "festivalProgram": "Festival Program",
        "grantProgram": "Grant Program",
        "multiActivityProgram": "Multi-Activity Program",
        "singleActivity": "Single Activity"
      },
      "organizationLevel": {
        "external": "External",
        "internal": "Internal"
      },
      "receptiveParticipants": {
        "free": "Free",
        "paying": "Paying"
      }
    },
    "email_verification": {
      "dismiss": "Dismiss",
      "request": "Takso email policy has been updated. To keep receiving emails, please verify your email address.",
      "resend": "Resend Verification",
      "sent": "The verification email has been sent. Please check your email inbox to verify your email address."
    },
    "go_to_admin": "Go To Admin",
    "go_to_home": "Go To Home",
    "guest_account": "Guest Account",
    "help": {
      "show_me_around": "Show Me Around",
      "title": "Help Center",
      "tour_description": "Walk through Takso's unique activity planning and evaluation features.",
      "tour_title": "Take a quick tour of Takso"
    },
    "help_center": "Help Center",
    "help_label": "Help",
    "individual_account": "Individual Account",
    "log_out": "Log Out",
    "notes": {
      "are_you_sure_you_want_to_delete_this_note": "Are you sure you want to delete this note ?",
      "delete_note": "Delete Note",
      "enter_note": "Enter note",
      "note_is_required_to_save": "Note is required to save",
      "title": "Activity Notes"
    },
    "panel": {
      "advanced_filter": "ADVANCED FILTER"
    },
    "show_me_around": "Show Me Around",
    "take_a_quick_tour_of_takso": "Take a quick tour of Takso",
    "unsaved_note_modal": {
      "body": "You have unsaved changes. Do you want to leave ?",
      "title": "Are you sure you want to leave ?"
    },
    "user_profile": "User Profile",
    "walk_through_takso_s_unique_activity_planning_and_evaluation_features": "Walk through Takso's unique activity planing and evaluation features."
  },
  "specific_actions": {
    "add_contractor": "Add Contractor",
    "add_goal": "Add New Goal",
    "add_more_options": "Add More Options",
    "add_note": "Add Note",
    "add_partner": "Add Partner",
    "add_reference": "Add Reference",
    "add_user": "Add New User",
    "add_venue": "Add Venue",
    "edit_department": "Edit Department",
    "edit_evaluation_method": "Edit Evaluation Method",
    "edit_evidence": "Edit Evidence",
    "edit_feature": "Edit Feature",
    "edit_goal": "Edit Goal",
    "edit_graded_outcome": "Edit Graded Outcome",
    "edit_note": "Edit Note",
    "edit_outcome": "Edit Outcome",
    "edit_permission_group": "Edit Permission Group",
    "edit_series": "Edit Series",
    "edit_subtitle": "Edit Subtitle"
  },
  "store": {
    "errors": {
      "problem_with_rows_and_columns": "There was a problem with the following rows and columns row: 0 column: before response (1-10) row: 0 column: after response (1-10)"
    },
    "messages": {
      "account_card_added": "Account card has been successfully added!",
      "account_card_updated": "Account card has been successfully updated!",
      "account_goal_info": "Account Goal Info",
      "account_reassigned": "Activity successfully reassigned",
      "account_subscription": "Account Subscription",
      "account_subscription_ended": "Account subscription has been successfully ended!",
      "account_upgraded": "Account upgraded successfully!",
      "account_user": "Account User",
      "activities_created": "{{numberOfLinkedActivities}} activities successfully created!",
      "activities_reassigned": "Activities successfully reassigned",
      "activity_invitation_sent": "Activity invitation has been sent",
      "activity_report": "Activity Report",
      "activity_type_updated": "Activity Type Updated",
      "admin_added": "Admin added successfully!",
      "admin_removed": "Admin removed successfully!",
      "broadcast_notification": "Broadcast Notification",
      "department_updated": "Department has been successfully updated!",
      "dept_created": "Department has been successfully created!",
      "dept_deleted": "Department has been successfully deleted!",
      "dept_labels": "Department Labels",
      "email_verification": "Email Verification",
      "final_eval_plan_closed": "Final evaluation plan is successfully closed.",
      "labels_updated": "Labels updated successfully!",
      "linked_activity_accepted": "The linked activity has been accepted",
      "linked_activity_reopened": "The linked activity is re-opened for review",
      "new_subscription_type_added": "New account subscription type has been successfully added!",
      "notification_sent": "Notification has been sent.",
      "password_reset_email_sent": "Password reset email sent",
      "password_reset_success": "Password reset success",
      "password_updated": "Your password has been updated",
      "payment_added": "Payment has been successfully added!",
      "profile_updated": "Your profile has been updated",
      "question_saved": "Question completed and saved",
      "report_assistance_settings_saved": "Report assistance settings saved.",
      "report_settings": "Report Settings",
      "successfully_completed": "Successfully completed",
      "user_assigned_to_department": "User has been assigned to the department",
      "verification_sent_check_email": "Verification has been sent. Please check your email."
    }
  },
  "strong": "",
  "survey": {
    "activity_survey": {
      "as_an_artist_in_art_not_apart_please_consider_the_following_questions_carefully": "As an artist in Art, Not Apart, please consider the following questions carefully.",
      "by_agency_and_voice_enabled_we_mean": "By <label className='bold-text'>agency and voice enabled</label> we mean that you have the freedom to express your opinions publicly and they are welcomed, respected, and valued.",
      "by_knowledge_ideas_or_insight_we_mean": "By <label className='bold-text'>knowledge, ideas or insight</label> we mean that you have the freedom to express your opinions publicly and they are welcomed, respected, and valued.",
      "do_you_have_any_other_comments_about_the_festival": "Do you have any other comments about the festival?",
      "having_engaged_with_the_festival_how_much_agency_and_voice_do_you_feel_you_have": "Having engaged with the festival, on a scale of 1-10, where 1 is not at all and 10 is the most imaginable, how much agency and voice do you feel you have <label className='bold-text'>now?</label>",
      "if_you_d_like_to_win_tickets_to_australian_dance_party_political_dance_escape_ferocity_techno_parties_cellar_door_wine_market_and_sound_and_fury_performance_art_party_events_leave_your_email_so_you_can_receive_this_prize": "If you’d like to win tickets to Australian Dance Party (political dance), Escape Ferocity (techno parties), Cellar Door (wine market) and Sound and Fury (performance art party) events, leave your email so you can receive this prize.",
      "please_tell_us_your_postcode": "Please tell us your postcode",
      "question_1_knowledge_ideas_or_insight": "Question 1. Knowledge, ideas or insight.",
      "question_2_agency_and_voice": "Question 2: Agency and Voice",
      "thats_it_thanks_so_much_festival_photos_are_available_for_download_on_the_next_page": "That’s it – thanks so much.<br></br>The festival photos are available for download on the next page.",
      "thinking_about_your_participation_what_have_you_gained": "Thinking about your participation in this festival, on a scale of 1 to 10, where 1 is not at all and 10 is the most imaginable, how would you rate the amount of <label className='bold-text'>knowledge, ideas or insight</label> you have gained?",
      "thinking_back_to_before_you_engaged_with_the_festival_how_much_agency_and_voice_do_you_feel_you_had": "Thinking back to <label className='bold-text'>before</label> you engaged with the festival, how much agency and voice do you feel you had <label className='bold-text'>then</label>, using the same scale of 1-10?",
      "this_section_description": "This section is to enable Art, Not Apart to understand more about the outcomes of its activities.<br></br>We ask you to consider the impact of the festival on you.",
      "this_survey_is_based_on_measurable_outcomes_developed_by_cultural_development_network_as_part_of_their_ongoing_research": "This survey is based on measurable outcomes developed by Cultural Development Network as part of their ongoing research. Participating in this research will enable <label className='bold-text'>Art, Not Apart</label> to understand more about the outcomes of its activities and areas for improvement.",
      "this_will_only_be_used_if_you_win_a_prize_thank_you": "This will only be used if you win a prize to contact you, that’s it.<br></br><Trans i18nKey='survey.activity_survey.thank_you'></Trans>"
    },
    "ageClassificationHelp": "ABS Age Classification",
    "ageQuestionLabel": "What is your age?",
    "ana2020_official_photography": "ANA2020 Official Photography",
    "assessment_based_on": "What is your assessment based on?",
    "assessment_basis_required": "Assessment basis is required",
    "before_higher_than_after_fmt": "<div>Your <strong>pre-participation</strong> rating is higher than your <strong>after</strong> rating.</div> <p>This can happen if the activity did not meet your expectations. <br/> If this wasn’t intentional, please review your ratings, or continue and tell us more below.</p>",
    "brokenLinkMessage": "Oops! the requested survey link is broken",
    "closeConfirmationMessage": "Are You Sure You Want to Close This Survey?",
    "closeConfirmationTitle": "Close Confirmation",
    "completion_message": "Thank you for completing the survey, your responses have been submitted.",
    "copied_to_clipboard": "Copied to clipboard",
    "copy_survey_question_link": "Copy Survey Question Link",
    "csv_upload": "CSV Upload",
    "cultural_analysis_thanks": "Thank you for informing the cultural analysis of {{name}}.",
    "culture_counts": "Intercept (imported)",
    "data_collection_method": "Data Collection Method",
    "data_collection_method_required": "Data collection method is required",
    "defaultQuestionLabel": "How are you?",
    "download_survey_pdf": "Download Survey PDF",
    "edit_title": "Edit title used on survey",
    "emailQuestionLabel": "What's your company email?",
    "ensure_previous_in_series_closed": "Please ensure that the results from the previous evaluation in this series has been closed",
    "errors": {
      "title_required": "A title for your surveys is required"
    },
    "evaluation_groups": "Evaluation Groups",
    "evaluation_method": "Evaluation Method",
    "evaluation_respondent_type": "Evaluation Respondent Type",
    "facilitator_notes": "Facilitator Notes",
    "facilitator_tips": "Tips for running this evaluation",
    "field_required": "Field is required",
    "generate_qr_code": "Generate QR Code",
    "generated_by": "Survey generated by",
    "go_to_culture_counts": "Go to Culture Counts",
    "go_to_survey": "Go to Survey",
    "higher_rating_warning": "<div> The <strong>pre-participation</strong> rating is higher than the <strong>post-participation</strong> rating. </div> <p> This implies the activity did not meet participant expectations. <br/> If this wasn’t intentional, please review your ratings, or continue and tell us more below. </p>",
    "links_and_tools_active_once_previous_plan_closed": "Survey links and upload tools will be active once the previous plan has been closed",
    "maxCharactersError": "Maximum Number of Characters is 200",
    "mgr_assessed": "Manager-assessed",
    "mgr_assessed_evaluation_method": "Manager-assessed evaluation method",
    "missing_survey_pdf_url": "Missing survey PDF URL",
    "multiple_use": "Multiple Use",
    "nextResponseButton": "Next response",
    "notCollectingResponsesMessage": "This evaluation is not currently collecting responses as the activity has not started. Responses may be submitted once the activity is underway",
    "number_of_participants_considered": "Number Of Participants Considered",
    "online_survey": "Online survey",
    "photo_link_description": "Here is a link to all official photos of the festival, free for you to use on the agreement that you credit the photographer's full name. Those names are written in the base folder titles.",
    "postal_code": {
      "question": "What is your postcode?",
      "unavailable": "Post code unavailable"
    },
    "printable_survey": "Printable Survey",
    "qualitative_question": "Qualitative Question",
    "reason_for_evaluation_method": "Reason for this evaluation method",
    "reason_for_evaluation_method_required": "Reason for evaluation method is required",
    "selectAgePlaceholder": "Select Age",
    "select_before_response": "Select your <strong>before</strong> response.",
    "select_data_collection_method": "Select Data Collection Method",
    "select_response": "Select your response.",
    "select_your_response": "Select your response.",
    "self_assessed": "Self-assessed",
    "self_assessed_evaluation_method": "Self-assessed evaluation method",
    "show_evaluation_question": "Show Evaluation Question",
    "single_use": "Single Use",
    "surveyForPrefix": "",
    "survey_link": "Survey Link",
    "survey_links_instructions_1": "Survey links will be operational from the first day of your activity. For paper-based surveys, download the CSV (available below under ‘Show Evaluation Details’), enter participants' responses, then reupload.",
    "survey_links_instructions_2": "You can use both online and paper-based surveys for any given evaluation plan.",
    "survey_links_will_be_operational_from_the_first_day_of_your_activity_results_will_be_automatically_compiled_in_takso_and_visible_on_the_documentation_page": "Survey links will be operational from the first day of your activity. Results will be automatically compiled in Takso and visible on the documentation page.",
    "survey_qr_code": "Survey QR Code",
    "takso_link": "Takso Link",
    "tell_us_more_one_rating": "Can you tell us why you gave this rating?",
    "tell_us_more_two_ratings": "Can you tell us why you gave these two ratings?",
    "title_tooltip": "This will be the title displayed on your surveys.",
    "title_used_on_survey": "Title used on survey",
    "title_used_on_survey_updated_successfully": "Title used on survey updated successfully",
    "unable_to_prepare_survey_download": "Unable to prepare survey download.",
    "use_survey_link_info": "Use the survey links for direct participant responses, or download and print the PDF survey for paper-based responses.",
    "validEmailError": "Please enter valid email address",
    "when_you_are_ready_to_enter_survey_data_into_takso_select_show_evaluation_details_where_you_can_download_a_csv_template_to_enter_your_results_and_upload_to_takso": "When you are ready to enter survey data into Takso, select “Show Evaluation Details,” where you can download a CSV template to enter your results and upload to Takso.",
    "you_can_use_the_links_above_to_refer_your_target_groups_to_your_survey_question_s_the_link_can_also_be_inserted_into_an_existing_survey_monkey_or_used_on_its_own_on_a_tablet_or_mobile_devise_for_interviews_or_focus_groups": "You can use the links above to refer your target groups to your survey question(s). The link can also be inserted into an existing Survey Monkey, or used on its own on a tablet or mobile devise for interviews or focus groups.",
    "you_will_find_survey_questions_below_when_adding_questions_to_your_survey_ensure_to_add_a_1_10_scale_at_the_appropriate_stage": "You will find survey questions below. When adding questions to your survey, ensure to add a 1-10 scale at the appropriate stage."
  },
  "toggle": {
    "see_all": "See All",
    "see_less": "See Less",
    "see_more": "See More",
    "show_all": "Show All",
    "show_less": "Show Less",
    "show_more": "Show More",
    "view_less": "View Less",
    "view_more": "View More"
  },
  "typeface": "Typeface",
  "users": {
    "search": {
      "no_matching_user_filter_by_this_email": "No matching user account — filter by this email address",
      "use_input": "Use \"{{value}}\""
    }
  },
  "utils": {
    "activity_and_project_validation": {
      "activity_dates_enter": "Please enter your activity dates",
      "activity_dates_required": "Please enter your activity dates",
      "activity_name_required": "Please give your activity a suitable name",
      "activity_name_suitable": "Please give your activity a suitable name",
      "activity_summary_enter": "Please enter an activity summary",
      "activity_summary_required": "Please enter an activity summary",
      "activity_type_select": "Please select the activity type",
      "actual_participant_field": "Please enter a number in at least one actual participant field",
      "actual_participant_field_named": "Please enter a number in the {{label}} field",
      "approve_activity": "Please approve this activity",
      "contractor_cost_required": "Please enter contractor cost for contractors",
      "enter_expenditure_or_tick_no_reportable_expenditure": "Please enter an amount for Venue Hire, a Contractor or Other Expenditure, or tick the 'No reportable Other Expenditure' box",
      "evaluation_all_objectives_enter": "Please enter at least one evaluation plan for all objectives",
      "evaluation_completed": "Please confirm whether \"{{planName}}\" evaluation was completed.",
      "evaluation_no_responses": "\"{{evalName}}\" has no responses recorded. Please enter responses or complete a manager-assessed evaluation for this plan.",
      "evaluation_participants_required": "Please select at least one evaluation participants group for \"{{planName}}\"",
      "evaluation_plan_enter": "Please enter an evaluation plan",
      "evidence_for_outcome": "Please enter evidence for {{outcomeTitle}}",
      "evidence_required": "Please enter evidence",
      "festival_type_select": "Please select at least one festival type",
      "final_description_required": "Please enter the final activity description",
      "goal_required": "Please enter a goal",
      "grants_application_closing_date": "Please select your grants application closing date",
      "green_light_date_required": "Please select the green light date",
      "green_light_date_select": "Please select the green light date",
      "linked_activities_accepted": "Please ensure all linked activities are accepted",
      "linked_activity_required": "Please enter at least one linked activity",
      "mgr_assessment_required": "Evaluation: \"{{outcomeTitle}}\" in \"{{planName}}\" requires a manager-assessed evaluation to be completed. Click View Details and answer the manager-assessed questions.",
      "no_responses_recorded": "\"{{planName}}\" has no responses recorded for \"{{outcomeTitle}}\". Please enter responses or complete a manager-assessed evaluation for this plan.",
      "objective_per_domain": "Please select at least one objective for each domain",
      "objectives_required": "Please select the objectives",
      "output_format_enter": "Please enter your {{label}}",
      "participant_numbers_required": "Please enter the participant numbers for this activity",
      "participant_responses_mismatch_post": "Number of participants who completed the evaluation does not match the number of participant (POST) responses entered for \"{{outcomeTitle}}\" in \"{{planName}}\". Please contact Takso admin for more information.",
      "participant_responses_mismatch_pre": "Number of participants who completed the evaluation does not match the number of participant (PRE) responses entered for \"{{outcomeTitle}}\" in \"{{planName}}\". Please contact Takso admin for more information.",
      "partner_contribution_required": "Please enter contribution costs for all partners",
      "projected_grants_pool": "Please enter your projected total grants pool",
      "projected_participant_field": "Please enter a figure in at least one projected participant field",
      "reflection_required": "Please complete your reflection of this activity",
      "remove_projected_contractors": "Please remove any projected contractors or complete all required information",
      "secondary_objective_required": "Please specify your secondary objective",
      "self_assessment_required": "Evaluation: \"{{outcomeTitle}}\" in \"{{planName}}\" requires a self-assessed evaluation to be completed. Click View Details and answer the self-assessed questions.",
      "theory_of_change_for_outcome": "Please enter or complete the Theory of Change for {{outcomeTitle}}",
      "theory_of_change_required": "Please enter or complete the Theory of Change",
      "venue_details_required": "Please enter venue details"
    },
    "activity_description": {
      "festival": "A program designed with multiple objectives that are delivered by multiple linked activities and publicly identified as a unified celebration or cultural event.",
      "grant": "An activity with multiple objectives that are achieved via a number of single activities; initiated through a process of pitching for and distribution of a pool of funds that occur between the Grant opening date and the final acquittal date.",
      "multi_activity": "A program designed with multiple objectives that are delivered by multiple linked activities not necessarily identified publicly as a unified program.",
      "single": "An activity that aims to achieve a maximum of two objectives; has its own start and end dates and is not part of a defined larger program of activities."
    },
    "collection_method": {
      "csv_upload": "CSV Upload",
      "culture_counts": "Intercept (imported)",
      "link_plus_csv_upload": "Takso Link + CSV Upload",
      "takso_link": "Takso Link"
    },
    "date_picker": {
      "activity_end_date": "Activity End Date",
      "activity_period": "Activity Period",
      "activity_start_date": "Activity Start Date",
      "festival_dates": "Festival Dates",
      "festival_end_date": "Festival End Date",
      "festival_start_date": "Festival Start Date",
      "program_end_date": "Program End Date",
      "program_period": "Program Period",
      "program_start_date": "Program Start Date"
    },
    "error": {
      "idle_timeout": "You were idle too long. You need to login again.",
      "invalid_value": "Your entered value is not valid or required, please check again!",
      "network_connection": "Network Connection Error!",
      "no_permission": "You don't have permission to make this call",
      "record_not_found": "Sorry, record not found",
      "request_not_allowed": "Request is not allowed",
      "something_wrong": "Oops, something went wrong!",
      "timed_out": "You've timed out!"
    },
    "evaluation_method": {
      "focus_group_experts": "Focus Group - experts",
      "focus_group_participants": "Focus Group - participants",
      "focus_group_proxies": "Focus Group - proxies",
      "intercept": "Intercept",
      "interview_expert": "Interview - expert",
      "interview_participant": "Interview - participant",
      "interview_proxy": "Interview - proxy",
      "mgr_assessed": "Manager-assessed",
      "questionnaire_expert": "Questionnaire - expert",
      "questionnaire_participant": "Questionnaire - participant",
      "questionnaire_proxy": "Questionnaire - proxy",
      "quick_response": "Quick Response",
      "self_assessed": "Self-assessed"
    },
    "evidence": {
      "grants_program": "Evidence supporting the grants program",
      "objectives": "Evidence"
    },
    "green_light": {
      "not_able": "This activity is not able to be green lit as the program it is linked to has not been given its green light"
    },
    "program_type": {
      "festival_programs": "Festival programs",
      "grant_programs": "Grant programs",
      "multi_activity_programs": "Multi-Activity programs"
    }
  }
}
